import { DAILY_REWARD_STATUS } from '@Data/Models';
import { IGU_WALLET_TRANSACTIONS } from '@models/gamingWallet';
import {
    MARKETPLACE_ORDERS_SORT_OPTION,
    MARKETPLACE_PET_TYPE,
} from '@models/marketplace';
import {
    GAME_DIFFICULTY,
    LUCKY_STRIKE_GAMES_STATUS,
    MYSTERY_GAMES,
    MYSTERY_LIKES_STATUS,
    NFT_ROYAL_GAME_HISTORY_STATUS,
    NFT_ROYAL_GAME_MODE,
    TOKEN_TELLER_GAME_PREDICTION_DIRECTION,
    TOKEN_TELLER_GAME_STATUS,
    TOKEN_TELLER_HISTORY_GAMES_STATUS,
} from '@models/mysteryGames';
import ROUTES from '@navigation/routes';

const id = {
    createWalletPassphrase: {
        title: 'Frasa Benih Anda',
        text: 'Simpanlah 12 kata ini pada selembar kertas. Perhatikan urutannya ketika mencatatnya. Simpanlah di tempat yang aman.',
        button: 'Lanjutkan',
        loading: 'Menghasilkan frase benih..',
    },
    createWalletVerification: {
        title: 'Verifikasi',
        text: 'Pilihlah kata-kata yang benar berdasarkan nomornya (urutan yang ditulis pada layar sebelumnya)',
        button: 'Lanjutkan',
        errors: {
            passphraseNotCorrect:
                'Urutan kata salah. Pilihlah kata-kata yang tepat sesuai dengan urutannya',
        },
        loading: 'Memeriksa frase benih..',
    },
    createWalletFirst: {
        title: 'Tuliskan Frasa Benih Anda',
        text: 'Jika perangkat Anda hilang atau dicuri, Anda akan dapat mengambil akses ke dana Anda menggunakan seed phrase. Jika Anda kehilangan seed phrase Anda, maka akan mengakibatkan kehilangan dana.',
        button: 'Saya Siap, Lanjutkan',
    },
    importWalletInit: {
        title: 'Kami Menemukan Akun Anda',
        text: 'Anda telah login dari perangkat lain, dan Anda tidak memiliki akses ke dompet yang terhubung. Harap, berikan 12 kata seed phrase dari dompet Anda untuk terus menggunakan aplikasi ini',
        pets: 'Hewan peliharaan',
        import: 'Dompet Impor',
        loading: 'Mengimpor dompet..',
    },
    importWalletScreen: {
        title: 'Impor dompet',
        text: 'Masukkan 12 kata seed phrase Anda, untuk dapat menggunakan dompet Anda di dalam aplikasi',
        listTitle: 'Frasa benih',
        inputPlaceholder: 'Ketik di sini',
        clearAll: 'Hapus semua',
        importWallet: 'Impor',
        privateKeyButton: 'Impor dari Kunci Pribadi',
        privateKeyModal: {
            title: 'Impor dari Kunci Pribadi',
            text: 'Jika Anda tidak memiliki seed phrase, Anda bisa mengimpor wallet Anda menggunakan private key',
            label: 'Kunci Pribadi',
            placeholder: 'Masukkan kunci pribadi',
            button: 'Impor',
        },
        errors: {
            mnemonicError:
                'Dompet dengan 12 kata frase benih itu tidak ada. Mohon periksa kembali atau berikan frasa lain',
            privateKeyError:
                'Dompet dengan kunci pribadi tersebut tidak ada. Mohon periksa kembali atau berikan private key yang lain',
            walletNotEqual:
                'Dompet yang disediakan tidak cocok dengan dompet akun',
            walletAlreadyVerified:
                'Dompet ini milik akun lain, tidak bisa mengimpor',
        },
        success: 'Dompet berhasil diimpor',
    },
    createWalletInit: {
        createButton: 'Membuat Dompet',
        importButton: 'Impor Dompet',
        slider: {
            titleSlide1: 'Hubungkan Dompet',
            textSlide1:
                'Buat dompet baru atau impor dompet yang sudah ada dengan memberikan 12 kata frasa benih Anda',
            titleSlide2: 'Dompet yang Dapat Dititipkan Sendiri',
            textSlide2:
                'IguVerse beroperasi pada dompet mandiri, di mana Anda memiliki kendali tunggal atas kunci pribadi Anda, yang pada gilirannya mengontrol mata uang kripto Anda dan membuktikan bahwa dana tersebut adalah milik Anda',
            titleSlide3: 'Pulihkan akun',
            textSlide3:
                'Jika Anda kehilangan akses ke perangkat dan frasa seed Anda, kami tidak akan dapat memulihkan dompet Anda dan dana akan hilang.',
        },
    },
    createWalletSuccess: {
        title: 'Dompet Dibuat',
        text: 'Selamat! Dompet Anda berhasil dibuat, Anda bisa mulai menggunakan akun Anda sekarang',
        button: 'Pergi ke Langkah Terakhir',
        buttonNew: 'Lanjutkan',
    },
    importWalletSuccess: {
        title: 'Dompet Impor',
        text: 'Selamat! Dompet Anda berhasil diimpor, Anda bisa mulai menggunakan akun Anda',
        button: 'Lanjutkan',
        buttonNew: 'Pergi ke Langkah Terakhir',
    },
    login: {
        facebook: 'Lanjutkan dengan Facebook',
        google: 'Lanjutkan dengan Google',
        apple: 'Lanjutkan dengan Apple',
        email: 'Lanjutkan dengan email',
        twitter: 'Lanjutkan dengan Twitter',
        emailTitle: 'Masuk / Daftar',
        creatingAccount:
            'Dengan membuat akun, saya setuju untuk memproses data pribadi saya sesuai dengan',
        and: 'dan',
        privacyPolicy: 'Kebijakan Privasi',
        termsOfUse: 'Ketentuan Penggunaan',
        placeholderEmail: 'Masukkan email',
        labelEmail: 'Email',
        placeholderVerificationCode: 'Masukkan kode verifikasi',
        labelVerificationCode: 'Kode verifikasi akan dikirim ke email Anda',
        sendCode: 'Kirim',
        resendIn: 'Kirim ulang',
        seconds: 'sec',
        welcomeTo: 'Selamat datang di',
        codeSent: 'Kata Sandi Satu Kali dikirim!',
        errors: {
            invalidEmailAddress: 'Alamat email tidak valid',
            emailIsRequired: 'Bidang email diperlukan',
            verificationCodeIsRequired:
                'Kata sandi satu kali diperlukan untuk masuk ke akun Anda',
            verificationCodeIsBadOrExpired:
                'Kata sandi sekali pakai salah atau kedaluwarsa. Coba lagi',
            verificationCodeTooMuchAttempts:
                'Terlalu banyak upaya. Silakan coba lagi nanti',
            loginFailed: 'Login gagal',
            smthWentWrong:
                'Ada yang tidak beres selama log in. Coba lagi nanti, atau coba metode lain',
        },
        loading: { sendingCode: 'Mengirim kode..', loggingIn: 'Masuk.' },
    },
    mintPetRank: {
        title: 'Pilih Peringkat Hewan Peliharaan Anda',
        text: 'Peringkat menentukan berapa banyak hadiah yang akan diperoleh hewan peliharaan Anda untuk menyelesaikan tugas setiap hari',
        free: 'Gratis',
        roi: 'ROI ≈',
        dailyReward: 'Hadiah Harian ≈',
        buttonNext: 'Lanjutkan ke Langkah Berikutnya',
        disabled: 'Hanya satu peringkat Gratis per akun yang diperbolehkan',
        info: 'Apa itu Peringkat?',
        whiteList: 'Daftar putih ({{amount}})',
        mysteryBox: 'Kotak Misteri',
        mysteryBoxWithAmount: 'Kotak Misteri ({{amount}})',
    },
    mintPickPhoto: {
        title: 'Pilih Foto Hewan Peliharaan Anda',
        text: 'Ambil foto hewan peliharaan Anda atau pilih foto favorit Anda dari galeri',
        or: 'atau',
        takePhoto: 'Kamera Terbuka',
        selectFromGallery: 'Pilih dari Galeri',
        tips: {
            title: 'Pedoman untuk Foto Sempurna',
            visible: 'Benar',
            cut: 'Potong',
            blurry: 'Buram',
            glare: 'Silau',
            tipOne: 'Cahaya yang bagus itu penting',
            tipTwo: 'Cobalah membuat bidikan dengan latar belakang netral',
            tipThree:
                'Pastikan bahwa hewan piaraan adalah satu-satunya yang ada dalam foto',
        },
        analyzingPhoto: 'Menganalisis foto Anda ..',
        errors: {
            explicitContent: {
                title: 'Konten terlarang',
                text: 'Gambar mengandung konten terlarang. Tindakan ini dapat menyebabkan pemblokiran akun',
            },
            uploadError: {
                title: 'Unggahan gagal',
                text: 'Periksa koneksi internet Anda dan coba lagi',
            },
            processImageFailed: {
                title: 'Kesalahan Gambar',
                text: 'Tidak dapat memproses gambar Anda saat ini. Coba lagi atau gunakan foto yang berbeda',
            },
            notAnimal: {
                title: 'Tidak ada hewan di sini',
                text: 'Algoritma kami tidak dapat mengenali hewan pada foto Anda. Silakan, coba lagi dengan foto yang berbeda',
                try: 'Coba Lagi',
                cancel: 'Batal',
            },
        },
    },
    mintEditPhoto: {
        title: 'Sesuaikan Hewan Peliharaan Anda',
        text: 'Ambil latar belakang untuk hewan peliharaan NFT Anda',
        loading: 'Mempersiapkan gambar Anda ..',
    },
    mintNamePhoto: {
        title: 'Beri Nama Hewan Peliharaan Anda',
        text: 'Hewan peliharaan Anda layak mendapatkan nama terbaik. Jaga agar nama Anda tidak lebih dari 20 karakter',
        inputLabel: 'Nama',
        placeHolder: 'misalnya Charlie',
        buttonNext: 'Lanjutkan ke Langkah Berikutnya',
        infoText:
            'Algoritme kami mampu mengenali hewan dalam gambar dengan probabilitas 99%',
        deleteNFTphoto: 'Hapus Foto',
        deleteNFTphotoText:
            'Apakah Anda yakin ingin pergi? Kemajuan Anda akan hilang',
        yesDelete: 'Ya, Bawa Aku Kembali',
        noKeep: 'Tidak, Lanjutkan',
        errors: {
            startSpace: 'Spasi tidak boleh menjadi karakter pertama dari nama',
            specialCharacters: 'Nama tidak boleh mengandung karakter khusus',
            latinCharacters: 'Nama hanya bisa berisi karakter dari A hingga Z',
            numbers: 'Nama tidak boleh mengandung angka',
            doubleSpaces: 'Nama tidak boleh mengandung spasi ganda',
            maxLength: 'Nama tidak boleh lebih dari 20 karakter',
            minLength: 'Nama tidak boleh lebih pendek dari 2 simbol',
            mint: {
                title: 'Gagal untuk Mint NFT',
                petRankWrongState:
                    'Peringkat hewan peliharaan tidak tersedia untuk mint',
                obscenePetName:
                    'Nama hewan peliharaan tidak boleh mengandung kata-kata yang buruk. Akun Anda mungkin akan diblokir',
            },
        },
    },
    mintCheckout: {
        transaction: 'NFT sebagai',
        rank: 'Pangkat',
        nftCustomization: 'NFT',
        successTitle: 'Hewan Peliharaan NFT Baru Diciptakan',
        successText:
            'Anda menjadi pemilik hewan peliharaan baru yang membanggakan. Ingatlah untuk merawatnya dengan baik!',
        backToPlaying: 'Mulai Bermain',
        backToCollection: 'Lihat Koleksi',
    },
    wallet: {
        screenTitle: 'Dompet',
        loading: 'Memuat dompet..',
        emptyTitle: 'Tidak bisa memuat dompet',
        emptyText: 'Kesalahan saat memuat dompet',
        total: 'Total',
        deposit: 'Deposit',
        withdraw: 'Menarik diri',
        trade: 'Perdagangan',
        balances: 'Timbangan',
        exchanges: 'Pertukaran',
        exchangesInfo:
            'Anda dapat token kami di salah satu bursa yang tercantum di bawah ini',
        available: 'Tersedia:',
        view: 'Lihat',
        depositTo: 'Setoran Ke',
        depositBEP: 'Deposit {{coin}} (BEP-20)',
        testnet: 'Testnet',
        testnetWarning:
            'Aplikasi saat ini berjalan di jaringan Testnet, jangan menyetor token nyata di sini',
        howToPurchaseBNB: 'Cara Membeli BNB',
        howToPurchaseIGU: 'Cara Membeli IGU',
        warning:
            'Pastikan Anda menyetor token Anda ke alamat dan jaringan yang benar (BEP-20)',
        withdrawFrom: 'Menarik diri dari',
        transactionHistory: 'Riwayat transaksi',
        viewOnBscScan: 'Lihat di BscScan',
        noTransactionYet: 'Belum Ada Transaksi',
        noTransactionYetInfo: 'Anda belum melakukan transaksi apa pun',
        transactionDetails: 'Rincian Transaksi',
        amount: 'Jumlah',
        type: 'Jenis',
        date: 'Tanggal',
        fromAddress: 'Dari Alamat',
        toAddress: 'Untuk Alamat',
        blockChainFee: 'Biaya Blockchain',
        loadingWithdraw: 'Mengirim transaksi..',
        transactions: {
            coin: {
                DEPOSIT: {
                    name: 'Deposit',
                    text: 'Crypto telah tiba di dompet Anda. Lihat riwayat transaksi untuk lebih jelasnya',
                },
                WITHDRAW: {
                    name: 'Penarikan',
                    text: 'Crypto ditransfer keluar dari dompet Anda. Silakan hubungi platform penerima untuk mendapatkan tanda terima transaksi Anda',
                },
                SWAP: {
                    name: 'Tukar',
                    text: 'Crypto ditukar ke crypto lain menggunakan DEX bawaan.',
                },
                CLAIM: {
                    name: 'Hadiah yang Diklaim',
                    text: 'Hadiah diklaim dan ditransfer ke saldo dompet Anda',
                },
                NFT_PAYMENT: {
                    name: 'Pembayaran NFT',
                    text: 'Crypto digunakan untuk membayar di aplikasi untuk mint atau upgrade. Lihat riwayat transaksi untuk lebih jelasnya',
                },
                UNKNOWN: {
                    name: 'Lainnya',
                    text: 'Transaksi jaringan lainnya termasuk menyetujui, biaya, dll. Lihat riwayat transaksi untuk lebih jelasnya',
                },
                CONFIRMED: { title: 'Selesai' },
                FAILED: {
                    title: 'Gagal',
                    text: 'Karena masalah jaringan, kami tidak dapat memproses transaksi Anda',
                },
                PENDING: {
                    title: 'Pending',
                    text: 'Transaksi belum dikonfirmasi oleh jaringan. Biasanya, dibutuhkan waktu dari 5 menit hingga 1 jam',
                },
            },
            nft: {
                DEPOSIT: {
                    name: 'Deposit',
                    text: 'NFT telah tiba di dompet Anda. Lihat riwayat transaksi untuk lebih jelasnya',
                },
                WITHDRAW: {
                    name: 'Penarikan NFT',
                    text: 'NFT ditransfer dari IguVerse. Silakan hubungi platform penerima untuk tanda terima transaksi Anda',
                },
                MINT: {
                    name: 'Mint',
                    text: 'NFT dicetak di aplikasi IguVerse',
                },
                CONFIRMED: { title: 'Selesai' },
                FAILED: {
                    title: 'Gagal',
                    text: 'Karena pekerjaan teknis pada jaringan, kami tidak dapat memproses transaksi Anda',
                },
                PENDING: {
                    title: 'Pending',
                    text: 'Transaksi belum dikonfirmasi oleh jaringan. Biasanya, dibutuhkan waktu dari 5 menit hingga 1 jam',
                },
            },
            reward: {
                GameIterationReward: {
                    title: 'Tugas Hadiah',
                    text: 'Tugas mengunci hadiah untuk menyelesaikan tugas harian',
                },
                ReferralReward: {
                    title: 'Hadiah Rujukan',
                    text: 'Hadiah rujukan untuk aktivitas aplikasi pengguna lain',
                },
                Claim: {
                    title: 'Klaim Hadiah',
                    text: 'Transaksi klaim mengkonversi hadiah VIGUP virtual Anda yang tersedia ke dalam Dompet Utama IGUP Anda',
                },
                PetLevelUpPayment: {
                    title: 'Hewan Peliharaan Naik Level',
                    text: 'Pembayaran internal untuk menaikkan level hewan peliharaan',
                },
                PetRankUpPayment: {
                    title: 'Peringkat Hewan Peliharaan Naik',
                    text: 'Pembayaran internal untuk menaikkan peringkat hewan peliharaan',
                },
                PetRevivePayment: {
                    title: 'Pemulihan Hewan Peliharaan',
                    text: 'Pembayaran internal untuk memulihkan hewan peliharaan',
                },
                PetHealUpPayment: {
                    title: 'Penyembuhan Hewan Peliharaan',
                    text: 'Pembayaran internal untuk penyembuhan hewan peliharaan',
                },
                MintBonus: {
                    title: 'Bonus Mint',
                    text: 'Hadiah Bonus untuk NFT Mint',
                },
                CharityDonation: {
                    title: 'Donasi Amal',
                    text: 'Donasi ke Organisasi Amal pilihan Anda',
                },
                GameIterationRewardSubtransaction: {
                    title: 'Tugas Hadiah',
                    text: 'Tugas mengunci hadiah untuk menyelesaikan tugas harian',
                },
                CONFIRMED: { title: 'Selesai' },
                PENDING: {
                    title: 'Pending',
                    text: 'Transaksi klaim telah dikeluarkan, namun belum selesai. Anda harus menyelesaikan transaksi ini sebelum Anda dapat membuat klaim baru',
                },
                UNLOCK: {
                    title: 'Hadiah Terkunci',
                    text: 'Hadiah-hadiah ini tertunda dan akan dibuka dan tersedia untuk Klaim sesuai dengan jadwal pembukaan kunci.',
                    locked: '{{amount}} {{coin}} Terkunci',
                },
                unlockTransactions: { title: 'Transaksi yang Tidak Terkunci' },
                UNKNOWN: { name: 'Lainnya', text: 'Jenis transaksi lainnya' },
                GameRewardStakeBonus: {
                    title: 'Bonus Dorongan',
                    text: 'Bonus terkunci untuk dorongan',
                },
                GameRewardStakeBonusSubtransaction: {
                    title: 'Bonus Dorongan',
                    text: 'Bonus terkunci untuk dorongan',
                },
            },
        },
        nft: {
            nft: 'NFT',
            tokenId: 'ID Token',
            myCollection: 'Barang Koleksi',
            tooltip: 'Di sini Anda dapat melihat koleksi NFT Anda',
            noNFTYet: 'Tidak ada Koleksi',
            noNFTYetInfo: 'Daftar kosong',
            mintNewNft: 'Mint NFT Baru',
            NFTs: '{{balance}} NFT',
            noNFTs: 'N/A',
            deposit: 'Setoran NFT',
            viewAll: 'Lihat Semua',
            allNFTs: 'Semua NFT',
            withdraw: 'Menarik NFT',
            withdrawNftLabelAddress: 'Alamat',
            withdrawNftPlaceholderAddress: 'Masukkan alamat',
            withdrawNftTitle: 'Menarik NFT',
            blockchainFee: 'Biaya Blockchain',
            confirmButtonLabel: 'Konfirmasi Penarikan',
            confirmModal: {
                title: 'Konfirmasi Penarikan NFT',
                nftName: 'NFT',
                addressFrom: 'Dari (Dompet)',
                addressTo: 'Untuk Alamat',
                send: 'Konfirmasi',
                cancel: 'Batal',
            },
            withdrawSuccess: {
                title: 'Penarikan NFT sedang Diproses',
                text: 'NFT {{name}} berhasil ditarik. Biasanya dibutuhkan dari 5 menit hingga 1 jam',
                addressFrom: 'Dari (Dompet)',
                addressTo: 'Untuk Alamat',
                backToWallet: 'Kembali ke Dompet',
            },
            transactionNft: 'Penarikan NFT',
            withdrawWarningText:
                'Pastikan Anda menarik token Anda ke alamat dan jaringan yang benar (BEP-20). Jika Anda mengirim NFT ke jaringan lain atau dompet pertukaran, Anda dapat kehilangannya secara permanen',
            transactionHistory: 'Riwayat Transaksi',
            noTransactionYet: 'Belum Ada Transaksi',
            noTransactionYetInfo:
                'Anda belum melakukan transaksi apa pun. Tapi itu bukan masalah, jangan lakukan sekarang juga',
        },
        rewards: {
            tooltipText:
                'Tombol Klaim memungkinkan Anda mengonversi token hadiah virtual Anda ke IGUP. Transaksi ini berantai. Tombol akan tersedia setelah Anda memiliki hadiah yang tertunda.',
            claimButton: 'Klaim',
            reclaimButton: 'Reklamasi',
            stakeButton: 'Dorong',
            rewardsWallet: 'Dompet Hadiah',
            mainWallet: 'Dompet Utama',
            transactionHistoryText: 'Riwayat Transaksi',
            rewardsCarousel: {
                availableRewards: 'Hadiah yang Tersedia',
                availableRewards_text:
                    'Hadiah yang tersedia untuk dikonversi ke token IGUP',
                lockedRewards: 'Hadiah Terkunci',
                lockedRewards_text:
                    'Hadiah akan tersedia sesuai dengan jadwal buka kunci Anda',
                pendingRewards: 'Hadiah Klaim yang Tertunda',
                pendingRewards_text: 'Selesaikan transaksi klaim Anda',
                claimReward: 'Klaim Hadiah',
            },
            transactionHistory: {
                Claim: 'Hadiah yang diklaim',
                GameIterationReward: 'Hadiah tugas',
                ReferralReward: 'Hadiah rujukan',
                PetLevelUpPayment: 'Hewan Peliharaan Naik Level',
                PetRankUpPayment: 'Peringkat Hewan Peliharaan Naik',
                PetRevivePayment: 'Pemulihan Hewan Peliharaan',
                PetHealUpPayment: 'Penyembuhan Hewan Peliharaan',
                MintBonus: 'Bonus Mint',
                CharityDonation: 'Donasi Amal',
                GameIterationRewardSubtransaction: 'Buka kunci',
                GameRewardStakeBonus: 'Bonus Dorongan',
                GameRewardStakeBonusSubtransaction: 'Buka kunci',
            },
            filter: {
                title: 'Urutkan Berdasarkan',
                ALL: 'Semua',
                Claim: 'Hadiah yang Diklaim',
                GameIterationReward: 'Tugas Hadiah',
                ReferralReward: 'Hadiah Rujukan',
                MintBonus: 'Mint Bonus',
                GameRewardStakeBonus: 'Bonus Dorongan',
            },
            empty: {
                title: 'Belum Ada Transaksi',
                text: 'Jangan khawatir dan nantikan. Ketika Anda mendapatkan hadiah, hadiah itu akan ditampilkan di sini',
                button: 'Menyegarkan',
            },
            confirmationModal: {
                title: 'Konfirmasi Klaim',
                keys: {
                    from: 'Dari',
                    to: 'Ke (Dompet)',
                    fee: 'Biaya Blockchain',
                    total: 'Ringkasan Total',
                },
                values: {
                    rewardsWallet: 'Dompet Hadiah',
                    mainWallet: 'Dompet IGUP',
                },
                warning:
                    'Pastikan Anda memiliki cukup dana dan BNB untuk menutupi biaya gas',
            },
            claimSuccess: {
                title: 'Klaim Hadiah Sedang Diproses',
                text: 'Anda telah memulai transaksi klaim baru dari Rewards Wallet Anda. Biasanya dibutuhkan waktu dari 5 menit hingga 1 jam',
                backToWallet: 'Kembali ke Dompet',
            },
            claimLoading: 'Melakukan klaim, jangan menutup aplikasi ..',
            claimBusy:
                'Jaringan sedang sibuk, silakan coba lagi setelah beberapa saat',
        },
        gaming: {
            gamingWalletChangeFeatureText:
                'Ini adalah perkiraan rasio pertukaran dari IGU ke VIGU',
            gamingWalletCarousel: {
                AvailableWallet: {
                    title: 'Dompet yang Tersedia',
                    text: 'Untuk ikut serta, isi ulang dompet game Anda dengan IGU',
                },
                PendingWallet: {
                    title: 'Dompet Tertunda',
                    text: 'Token akan dibekukan sampai Anda menyelesaikan permainan',
                },
            },
            gamingWalletButtons: {
                topUp: 'Isi ulang',
                withdraw: 'Menarik diri',
            },
            TopUpGamingWalletScreen: {
                screenTitle: 'Isi ulang',
                title: 'Isi Ulang Dompet Game',
                text: 'Untuk ikut serta, isi ulang dompet game Anda dengan IGU dan dapatkan VIGU',
                infoText: 'Cara kerjanya',
                button: 'Pembayaran',
                inputSection: {
                    infoText: 'Masukkan atau pilih jumlah yang ingin dibeli',
                    errors: {
                        digits: 'Harus hanya digit',
                        min: 'Jumlahnya harus minimal {{limit}} {{coin}}',
                        max: 'Jumlahnya harus maksimal {{limit}} {{coin}}',
                    },
                },
                howToModal: {
                    title: 'Isi Ulang Dompet Game',
                    text: 'Untuk ikut serta, isi ulang dompet game Anda dengan IGU dan dapatkan VIGU. Gunakan tombol di bawah ini untuk mengisi ulang token',
                },
            },
            SelectWithdrawTokenModal: {
                title: 'Pilih Token Penarikan',
                text: 'Anda dapat memilih token pilihan, di mana Anda akan menerima hadiah di Dompet Utama',
                button: 'Pilihan',
            },
            TopUpSuccessScreen: {
                title: 'Pengisian ulang berhasil',
                text: 'Anda telah berhasil mengisi dompet game Anda dengan token. Bergabunglah dengan permainan kompetitif sekarang!',
                button: 'Jelajahi Permainan',
                button2: 'Lihat Riwayat Transaksi',
                buttonBack: 'Kembali ke Permainan',
            },
            transactionHistory: {
                filter: {
                    title: 'Urutkan berdasarkan',
                    [IGU_WALLET_TRANSACTIONS.All]: 'Semua',
                    [IGU_WALLET_TRANSACTIONS.Deposit]: 'Isi ulang',
                    [IGU_WALLET_TRANSACTIONS.Withdraw]: 'Menarik diri',
                    [IGU_WALLET_TRANSACTIONS.RevertWithdraw]:
                        'Kembalikan Tarik',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGamePayment]:
                        'Pembayaran',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameRefund]:
                        'Kadaluarsa',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDraw]: 'Seri',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameWin]: 'Menang',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameFee]: 'Biaya',
                    [IGU_WALLET_TRANSACTIONS.DepositBonus]: 'Bonus Isi Ulang',
                },
                transactions: {
                    [IGU_WALLET_TRANSACTIONS.Deposit]: {
                        title: 'Isi ulang',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.Withdraw]: {
                        title: 'Menarik diri',
                        text: 'Crypto sedang mentransfer dari Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.RevertWithdraw]: {
                        title: 'Kembalikan Tarik',
                        text: 'Crypto sedang mentransfer dari Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDraw]: {
                        title: 'The Mystery Of Likes Seri',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGamePayment]: {
                        title: 'The Mystery Of Likes Pembayaran',
                        text: 'Crypto sedang mentransfer dari Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameRefund]: {
                        title: 'The Mystery Of Likes Kadaluarsa',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameWin]: {
                        title: 'The Mystery Of Likes Menang',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.DepositBonus]: {
                        title: 'Bonus Isi Ulang',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.DirectReferralDepositBonus]: {
                        title: 'Bonus Isi Ulang (Langsung)',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.IndirectReferralDepositBonus]: {
                        title: 'Bonus Isi Ulang (Tidak Langsung)',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameFee]: {
                        title: 'The Mystery Of Likes Biaya',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDirectReferralBonus]:
                        {
                            title: 'Hadiah Referensi (Langsung)',
                            text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                        },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameIndirectReferralBonus]:
                        {
                            title: 'Hadiah Referensi (Tidak Langsung)',
                            text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                        },
                    [IGU_WALLET_TRANSACTIONS.Breeding]: {
                        title: 'NFT Evolution Mint',
                        text: 'Crypto sedang mentransfer dari Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.GamesTurnoverReward]: {
                        title: 'PVP Bonus',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },

                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameDraw]: {
                        title: 'The Grand Race - Seri',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGamePayment]: {
                        title: 'The Grand Race - Pembayaran',
                        text: 'Crypto sedang mentransfer dari Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameRefund]: {
                        title: 'The Grand Race - Kadaluarsa',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameWin]: {
                        title: 'The Grand Race - Menang',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameFee]: {
                        title: 'The Grand Race - Biaya',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.LuckyStrikeGameWin]: {
                        title: 'Lucky Strike - Menang',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.LuckyStrikeGamePayment]: {
                        title: 'Lucky Strike - Tiket',
                        text: 'Crypto sedang mentransfer dari Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.QuantumSpinReward]: {
                        title: 'Quantum Disk - Hadiah',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.QuantumSpin]: {
                        title: 'Quantum Disk - Pembayaran',
                        text: 'Crypto sedang mentransfer dari Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictWin]: {
                        title: 'Tokenteller - Menang',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredict]: {
                        title: 'Tokenteller - Pembayaran',
                        text: 'Crypto sedang mentransfer dari Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictFee]: {
                        title: 'Tokenteller - Biaya',
                        text: 'Crypto sedang mentransfer dari Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictRefund]: {
                        title: 'Tokenteller - Seri',
                        text: 'Crypto ditransfer ke Dompet Game. Periksa detail lebih lanjut di bscscan',
                    },
                },
            },
        },
        stakingBanner: {
            title: 'Dorong hadiah dan dapatkan bonus!',
            text: 'Mendorong dengan IGUP tersedia di tab Hadiah sekarang!',
            button: 'Aktifkan Dorongan',
        },
    },
    trade: {
        poweredBy: 'Didukung oleh',
        from: 'Dari',
        to: 'Untuk',
        estimate: ' (Perkiraan)',
        enterAmount: 'Masukkan jumlah',
        available: 'Max',
        selectToken: 'Pilih Token',
        deposit: 'Deposit',
        trade: 'Tukar',
        rate: 'Nilai tukar',
        confirmTrade: 'Konfirmasi Perdagangan',
        cancel: 'Batal',
        settings: 'Pengaturan',
        settingTitle: 'Toleransi Selip',
        slippageMainText:
            'Transaksi Anda akan dikembalikan jika harga berubah secara tidak menguntungkan lebih dari persentase di bawah ini',
        save: 'Simpan',
        percentFour: 'Masukkan %',
        inputWarning:
            'Toleransi Slippage harus berada di antara {{minAmount}}% dan {{maxAmount}}%. Silakan masukkan persentase lain',
        checkout: { estimate: 'Anda membayar', to: 'Anda menerima' },
        processingTrade: 'Memproses perdagangan..',
        calculatingTrade: 'Menghitung..',
        button: 'Perdagangan',
        errors: {
            isRequired: 'Nilai diperlukan.',
            maxAmountError:
                'Tidak cukup token di saldo. Silakan masukkan jumlah atau deposit lain',
            minLimit: 'Jumlah swap harus setidaknya {{limit}} {{coin}}',
            bnbNotEnough:
                'Tidak cukup BNB di saldo Anda untuk menutupi biaya gas. Silakan masukkan jumlah lain atau setor BNB',
            transaction: 'Transaksi gagal',
            DS_MATH_SUB_UNDERFLOW:
                'Jumlah token terlalu besar, coba masukkan jumlah yang berbeda',
        },
        tradeSuccess: {
            title: 'Tukar Guling Selesai',
            text: 'Selamat! Anda telah berhasil menukar token. Token Anda tersedia di saldo Anda. Lihat lebih banyak dalam riwayat transaksi',
            backToWallet: 'Kembali ke Dompet',
            from: 'Dari',
            to: 'Untuk',
            estimate: '(Perkiraan)',
            blockchainFee: 'Biaya Blockchain',
            totalSummary: 'Ringkasan Total',
            back: 'Lanjutkan Perdagangan',
        },
    },
    tradingView: {
        title: 'Grafik',
        back: 'Kembali ke Perdagangan',
    },
    walletSettings: {
        title: 'Pengaturan dompet',
        header: 'Pengaturan keamanan',
        description:
            'Lihat frase awal dan kunci pribadi Anda, serta kelola kode sandi Anda di sini',
        backup: {
            title: 'Frasa Benih',
            description:
                'Jangan pernah menunjukkan frase benih Anda kepada siapa pun! Ini mengontrol semua dana Anda',
            modal: {
                title: 'Frasa / Kunci Pemulihan Dompet',
                text: 'Pastikan tidak ada yang bisa melihat data rahasia Anda. Dengan mengeksposnya kepada siapa pun, Anda berisiko kehilangan dana Anda',
                yes: 'Lihat',
                no: 'Kembali',
                alert: 'Tim IguVerse tidak akan pernah menanyakan kepada Anda mengenai seed phrase atau private key Anda. Jika ada yang bertanya kepada Anda, itu 100% penipu, berhati-hatilah!',
                checkbox:
                    'Saya mengakui bahwa saya memahami risiko jika saya membagikan seed phrase/kunci pribadi kepada seseorang, token dan hewan peliharaan saya akan dicuri',
            },
        },
        passcode: {
            title: 'Kode Sandi dan Biometrik',
            description:
                'Mengatur atau mengubah kata sandi/mengaktifkan identifikasi biometrik',
        },
    },
    passcode: {
        passcode: 'Kode Sandi',
        modal: {
            title: 'Aktifkan Kode Sandi',
            subTitle:
                'Kode empat digit akan meningkatkan keamanan Anda dan akan digunakan untuk mengonfirmasi tindakan penting',
        },
        welcome: {
            title: 'Aktifkan Kode Sandi',
            subTitle:
                'Masukkan kode sandi, yang akan Anda gunakan untuk mengakses aplikasi dan mengonfirmasi tindakan penting',
        },
        new: {
            title: 'Aktifkan Kode Sandi',
            subTitle:
                'Masukkan kode sandi, yang akan Anda gunakan untuk mengakses aplikasi dan mengonfirmasi tindakan penting',
        },
        confirm: {
            title: 'Konfirmasi Kode Sandi',
            subTitle:
                'Masukkan kode sandi, yang akan Anda gunakan untuk mengakses aplikasi dan mengonfirmasi tindakan penting',
            error: 'Kode salah. Masukkan kode yang sama dengan yang Anda ketikkan pada langkah sebelumnya',
        },
        check: {
            title: 'Masukkan Kode Sandi',
            subTitle: 'Masukkan kode sandi Anda saat ini untuk mengonfirmasi',
            error: 'Kode salah. Coba lagi atau gunakan identifikasi biometrik',
        },
        success: {
            title: 'Akun Anda Dilindungi!',
            subTitle:
                'Sekarang akun dan dompet IguVerse Anda terlindungi dari aktivitas berbahaya. Anda selalu dapat mengubah kode sandi di Pengaturan',
        },
        change: {
            title: 'Ubah Kode Sandi',
            subTitle:
                'Masukkan kode sandi baru, yang akan digunakan untuk mengonfirmasi tindakan penting',
        },
        faceId: {
            title: 'Aktifkan Identifikasi Biometrik',
            subTitle:
                'Konfirmasikan tindakan penting dengan cara yang lebih sederhana dan lebih cepat. Data biometrik Anda tidak dikumpulkan oleh IguVerse',
        },
        modalRemove: {
            title: 'Matikan Kode Sandi?',
            subTitle:
                'Semua data Anda disimpan dengan aman dengan kode sandi. Anda dapat mengaturnya lagi di pengaturan kapan saja',
        },
        toasts: {
            turnOff: 'Sukses! Kode sandi dimatikan!',
            biometricOff: 'Sukses! Biometrik dimatikan!',
            biometricOn: 'Sukses! Biometrik aktif!',
            change: 'Sukses! Kode sandi berubah!',
            biometricError: 'Kesalahan! Coba Lagi!',
        },
        settings: {
            turnOff: 'Matikan Kode Sandi',
            biometric: {
                title: 'Identifikasi Biometrik',
                subTitle:
                    'Gunakan ID Wajah atau sidik jari Anda untuk mengonfirmasi tindakan penting di aplikasi',
            },
        },
    },
    walletSettingsBackup: {
        mnemonic: {
            title: 'Frasa Benih Anda',
            text: 'Simpanlah 12 kata ini pada selembar kertas. Perhatikan urutannya ketika mencatatnya. Simpanlah di tempat yang aman.',
            reveal: 'Tahan untuk Mengungkapkan Frasa',
        },
        privateKey: {
            title: 'Kunci Pribadi Anda',
            text: 'Kunci pribadi adalah nomor yang dihasilkan secara acak yang memberikan kontrol pengguna atas semua dana yang terhubung ke dompet. Jaga kerahasiaannya',
            reveal: 'Tahan untuk Mengungkapkan Kunci Pribadi',
        },
        privateKeyModal: {
            title: 'Kunci Pribadi',
            text: 'Tuliskan Kunci Pribadi Anda. Simpan di tempat yang aman',
        },
        buttons: {
            hidden: 'Tahan untuk Mengungkapkan',
            visible: 'Sembunyikan',
        },
        viewPrivateKey: 'Lihat Kunci Pribadi Anda',
        emptyTitle: 'Kesalahan',
        emptyText: 'Tidak bisa memuat dompet',
    },
    withdrawScreen: {
        title: 'Menarik diri',
        labelAddress: 'Alamat',
        labelAmount: 'Jumlah',
        placeholderAddress: 'Masukkan alamat',
        placeholderAmount: 'Masukkan jumlah',
        labelAvailable: 'Tersedia',
        allButtonLabel: 'Max',
        confirmButtonLabel: 'Konfirmasi transaksi',
        depositButtonLabel: 'Deposit',
        depositBEP: 'Deposit {{coin}} (BEP-20)',
        blockchainFee: 'Biaya Blockchain',
        totalSummary: 'Total ringkasan',
        errors: {
            address: 'Alamat tidak boleh kosong',
            amountRequired: 'Jumlah tidak boleh kosong',
            invalidAddress: 'Dompet alamat tidak valid',
            sameWallet: 'Tidak bisa menarik ke dompet Anda sendiri',
            digits: 'Harus hanya berupa angka',
            maxAmountError:
                'Tidak cukup token di saldo. Silakan masukkan jumlah atau deposit lain',
            minLimit: 'Penarikan harus setidaknya {{limit}} {{coin}}',
            bnbNotEnough:
                'Tidak cukup BNB di saldo Anda untuk menutupi biaya gas. Silakan masukkan jumlah lain atau setor BNB',
        },
        withdrawWarningText:
            'Pastikan Anda menarik token Anda ke alamat dan jaringan yang benar (BEP-20)',
        withdrawWarningTextNFT:
            'Jika Anda mengirim NFT ke jaringan lain atau wallet pertukaran, Anda mungkin akan kehilangannya secara permanen',
        transaction: 'Penarikan',
        withdrawSuccess: {
            title: 'Penarikan sedang Diproses',
            text: 'Anda telah memulai penarikan baru dari dompet Anda. Biasanya dibutuhkan dari 5 menit hingga 1 jam',
            backToWallet: 'Kembali ke Dompet',
            viewTransactionHistory: 'Lihat Riwayat Transaksi',
        },
    },
    ModalConfirmTransaction: {
        title: 'Konfirmasi transaksi',
        confirm: 'Konfirmasi',
        cancel: 'Batal',
    },
    ModalCoinSelect: { select: 'Pilih Token' },
    ModalCropImage: { title: 'Pangkas Gambar', crop: 'Pangkas dan Lanjutkan' },
    qrCodeScanner: {
        openSettings: 'Pengaturan',
        noAccessToCamera: 'Tidak ada akses ke kamera',
        title: 'Posisikan QR-Code dalam bingkai',
        wallet: {
            titleScanned: 'Alamat yang dipindai',
            text: 'Pindai kode QR dari alamat token. Pastikan semua detail terlihat',
        },
        referral: {
            titleScanned: 'Kode rujukan dipindai',
            text: 'Pindai kode QR dari kode Referral. Pastikan semua detail terlihat',
        },
        verify: {
            titleScanned: 'Verifikasi kode yang dipindai',
            text: 'Pindai kode QR dari kode Verifikasi. Pastikan semua detail terlihat',
        },
    },
    nftSelectGeneration: {
        continue: 'Lanjutkan',
        search: 'Pencarian',
        pageTitle: 'Buat Hewan Peliharaan NFT Anda',
        pageInfo: 'Anda bisa memilih cara NFT Anda akan dibuat',
        nftFromPhoto: 'NFT dari Foto',
        nftFromPhotoText:
            'Buat NFT yang indah dari foto hewan peliharaan Anda sendiri. Pilih salah satu latar belakang kami yang indah untuk pendamping masa depan Anda',
        nftFromImagination: 'NFT dari Imajinasi Anda',
        nftFromImaginationText:
            'Algoritma AI / ML kami dapat menggambar hewan peliharaan virtual Anda persis seperti yang Anda bayangkan. Jelaskan fitur hewan peliharaan Anda dan nikmati hasilnya',
        provideMoreInformation: 'Jelaskan Hewan Peliharaan Impian Anda',
        provideMoreInformationInfo:
            'Pilih dari salah satu opsi yang disarankan di bawah ini sehingga NFT yang dibuat akan sangat cocok dengan apa yang Anda bayangkan',
        selectAccessories: 'Pilih Aksesori',
        maximumAccessories: 'Anda bisa memilih aksesori {{num}} maksimum',
        selectGeneratedNFT: 'Pilih Hewan Peliharaan Anda',
        selectGeneratedNFTInfo:
            'Kami menciptakan beberapa hewan peliharaan unik sesuai permintaan Anda. Pilih salah satu yang paling Anda sukai',
        continueNextStep: 'Lanjutkan ke Langkah Berikutnya',
        generateNewNFT: 'Coba lagi',
        generateNFTButton: 'Hasilkan NFT',
        loadingModalText: 'Loading..',
        randomize: 'Acak',
        clear: 'Bersih',
        select: 'Pilih',
        noResult: 'Tidak ada hasil',
        noResultText:
            'Tidak ada hasil untuk "{{query}}". Masukkan kata kunci lain untuk mencari',
        form: {
            animal: {
                label: 'Hewan',
                placeHolder: 'Pilih hewan',
                modalTitle: 'Pilih Hewan',
            },
            'drawing-type': {
                label: 'Jenis Gambar',
                placeHolder: 'Pilih jenis gambar',
                modalTitle: 'Pilih Jenis Gambar',
            },
            cat: {
                label: 'Jenis Kucing',
                placeHolder: 'Pilih jenis kucing',
                modalTitle: 'Pilih Ras Kucing',
            },
            dog: {
                label: 'Jenis Anjing',
                placeHolder: 'Pilih jenis anjing',
                modalTitle: 'Pilih Jenis Anjing',
            },
            'maturity-size': {
                label: 'Kematangan / Ukuran',
                placeHolder: 'Pilih kematangan atau ukuran',
                modalTitle: 'Pilih Kematangan atau Ukuran',
            },
            color: {
                label: 'Warna',
                placeHolder: 'Pilih warna',
                modalTitle: 'Pilih Warna',
            },
            emotion: {
                label: 'Emosi',
                placeHolder: 'Pilih emosi',
                modalTitle: 'Pilih Emosi',
            },
            accessories: {
                label: 'Aksesori',
                placeHolder: 'Pilih aksesori',
                modalTitle: 'Pilih Aksesori',
            },
            context: {
                label: 'Konteks',
                placeHolder: 'Pilih konteks',
                modalTitle: 'Pilih Konteks',
            },
            style: {
                label: 'Gaya',
                placeHolder: 'Pilih gaya',
                modalTitle: 'Pilih Gaya',
            },
        },
        errors: {
            maintenance: {
                title: 'Model AI kami kelebihan beban',
                text: 'Sayangnya model AI kami tidak dapat melayani permintaan Anda saat ini. Silakan coba lagi',
            },
        },
    },
    bottomNavigation: {
        play: 'Bermain',
        charity: 'Amal',
        statistics: 'Statistik',
        collection: 'Koleksi',
        marketplace: 'Toko',
    },
    playScreen: {
        timeToComplete: 'Putaran Permainan Berakhir di',
        startPlaying: 'Mulai Bermain',
        howToPlay: 'Bagaimana Cara Bermainnya?',
        nftToPlay: 'Hewan Anda',
        edit: 'Edit',
        nftToPlayInfo:
            'Pilih hewan peliharaan Anda yang akan berpartisipasi dalam permainan dan dapatkan hadiah',
        nftToPlayHint:
            'Urutan hewan peliharaan Anda penting. Hewan peliharaan pertama akan menjadi hewan peliharaan yang terlihat pada Pet ID Anda dalam berbagi permainan. Hewan peliharaan pertama juga mendapatkan pengalaman paling banyak untuk melakukan tugas-tugas',
        noNFTyet: 'Tidak Ada yang Tinggal di Sini',
        noNFTyetInfo:
            'Sayangnya, Anda belum memiliki hewan pendamping. Dapatkan hewan peliharaan pertama Anda dan mulailah bermain',
        exploreShop: 'Jelajahi Toko',
        mintNew: 'Dapatkan Hewan Anda',
        dailyTasks: 'Tugas Harian',
        dailyTasksInfo:
            'Selesaikan tugas harian Anda untuk mendapatkan energi dan kemudian menukarnya dengan token',
        timeLeftToComplete: 'Putaran Permainan Berakhir Dalam',
        selectNFT: 'Tambahkan lebih banyak hewan peliharaan',
        playCards: {
            SHARE_title: 'Bagikan Hewan Peliharaan Anda',
            SHARE_info:
                'Hewan peliharaan Anda membutuhkan perhatian setiap hari.\n' +
                'Bagikan di media sosial',
            SHARE_button: 'Tugas Sosial Terbuka',
            addSocialAccount: 'Tambahkan Akun Sosial',
            socialAlert:
                'Tugas sosial membutuhkan waktu antara 6-12 jam untuk verifikasi dan dapat diverifikasi dalam iterasi permainan berikutnya',
            MOVE_title: 'Berjalan-jalan dengan Hewan Peliharaan Anda',
            MOVE_info:
                'Hewan peliharaan Anda perlu berjalan kaki setiap hari.\n' +
                'Berjalan dengan hewan peliharaan Anda',
            MOVE_button: 'Tugas Berjalan Terbuka',
            PLAY_title: 'Bermain dengan Hewan Peliharaan Anda',
            PLAY_info:
                'Bermain dengan hewan peliharaan Anda dalam mini-game arcade berbasis reaksi',
            PLAY_button: 'Tugas Bermain Terbuka',
            VERIFY_title: 'Temukan Hewan Peliharaan Lainnya',
            VERIFY_info:
                'Temukan hewan peliharaan pengguna lain di media sosial',
            VERIFY_button1: 'Lanjutkan Temukan Tugas',
            VERIFY_button2: 'Temukan Hewan Peliharaan Lainnya',
            completedEnergy:
                '{{energyRewarded}} / {{maxEnergyReward}} Energi yang Dikumpulkan',
            SHARE_failed_title: 'Postingan Anda belum diverifikasi',
            SHARE_failed_text:
                'Saat memverifikasi postingan Anda, pengguna lain tidak berhasil menemukan atau melihat Pet ID Anda. Kami telah melihat postingan tersebut dan juga tidak dapat memverifikasinya. Sayangnya, Anda tidak akan menerima energi dari tugas ini hari ini. Tolong, cobalah untuk lebih perhatian lain kali',
            SHARE_failed_button: 'Kembali Bermain',
            knowledgeBase: 'Lihat Basis Pengetahuan',
            SHARE_failed_reasons: {
                notEnoughFollowers:
                    'Tampaknya akun Anda tidak cukup aktif. Silakan, pilih akun lain atau coba kembangkan akun ini',
                petIdNotFound:
                    'Pengguna lain mengatakan mereka tidak dapat menemukan Pet ID yang diposting di akun Anda. Tolong, jangan lupa untuk memposting lain kali',
                petIdIncorrectPosition:
                    'Pet ID Anda ditempatkan sedemikian rupa sehingga pengguna lain tidak dapat melihatnya. Cobalah untuk lebih berhati-hati lain kali',
                userNotFound:
                    'Baik pengguna maupun admin tidak dapat menemukan akun Anda. Apakah ada sesuatu yang terjadi padanya?',
            },
            SHARE_success_title: 'Tugas Berbagi Selesai',
            SHARE_success_text:
                'Selamat! Anda berbagi foto dan lolos verifikasi. Kembalilah besok untuk lebih banyak lagi',
            SHARE_success_button: 'Lihat Detail',
        },
        modalAllDead: {
            title: 'Hewan Peliharaan Anda Sudah Mati',
            text: 'Anda tidak dapat memainkan tugas sampai setidaknya salah satu hewan peliharaan Anda dalam kondisi baik. Kembalikan hewan peliharaan Anda dan kembali',
            button: 'Memulihkan Hewan Peliharaan',
        },
        modalSomeDead: {
            title: 'Beberapa Hewan Peliharaan Anda Sudah Mati',
            text: 'Beberapa hewan peliharaan Anda sudah mati, dan mereka tidak akan mendapatkan hadiah. Apakah Anda yakin ingin melanjutkan?',
            button: 'Memulihkan Hewan Peliharaan',
            button2: 'Lanjutkan Bermain',
        },
    },
    collectionsScreen: {
        title: 'Koleksi Saya',
        text: 'Ini adalah rumah bagi hewan peliharaan Anda yang mengagumkan',
        mintNewNft: 'Dapatkan Hewan Anda',
        mintPet: 'Buat Hewan Peliharaan',
        noCollectionsYet: 'Tidak Ada yang Tinggal di Sini',
        noCollectionsYetInfo:
            'Sayangnya, Anda belum memiliki hewan pendamping. Bagaimana Anda bisa hidup tanpa hewan peliharaan?',
        levelUp: 'Naik Level',
        rankUp: 'Naik Peringkat',
        restore: 'Kembalikan',
        feed: 'Umpan',
        healAllButtonTooltip:
            'Anda dapat menggunakan penyembuhan hewan peliharaan massal hanya jika Anda memiliki setidaknya 2 hewan peliharaan dengan kesehatan lebih rendah dari 100%',
    },
    detailedPet: {
        headerSubtitle:
            'Ini adalah hewan peliharaan NFT Anda, Anda dapat menyelesaikan tugas harian dengan bantuannya dan mendapatkan hadiah token. Rawatlah dengan baik',
        levelXP: {
            title: 'Level & XP',
            text: 'Dapatkan XP untuk menyelesaikan tugas dan meningkatkan level hewan peliharaan Anda. Setelah mencapai level tertentu, hewan peliharaan dapat meningkatkan ke peringkat yang lebih tinggi',
            textUpgrade:
                'Anda telah mencapai semua pengalaman di level {{level}}. Tingkatkan NFT Anda ke level baru untuk mendapatkan lebih banyak token',
            upgrade: 'Tingkatkan ke Level {{level}}',
        },
        animalType: {
            title: 'Jenis Hewan',
            text: 'Algoritme kami mampu mengenali hewan pada gambar dengan probabilitas tinggi',
        },
        rank: {
            title: 'Peringkat {{rank}}',
            text: 'Peringkat adalah salah satu karakteristik utama pet. Peringkat yang lebih tinggi mendapatkan lebih banyak hadiah dan memiliki tingkat Buka Kunci Hadiah yang lebih tinggi',
            upgrade: 'Tingkatkan ke "{{rank}}" Peringkat',
            textUpgrade:
                'Anda telah mencapai semua level dalam peringkat "{{rank}}". Tingkatkan ke peringkat baru untuk mendapatkan lebih banyak token',
        },

        age: {
            button: 'Mengembalikan NFT',
            Baby: 'Anak NFT = {{current}} / {{max}} Hari',
            Young: 'Remaja NFT = {{current}} / {{max}} Hari',
            Adult: 'Dewasa NFT = {{current}} / {{max}} Hari',
            Old: 'Tua NFT = {{current}} / {{max}} Hari',
            description:
                'Usia NFT Anda dipertimbangkan sejak pembuatannya. Setelah NFT Anda menjadi tua, itu akan mati dan perlu dipulihkan',
            descriptionDead:
                'NFT telah menjalani hidup yang panjang dan bahagia dan meninggal dunia. Tidak perlu kesal, Anda dapat memulihkannya dan bermain lagi!',
            dailyUnlock: 'Buka Kunci Harian = ',
            daysMore: 'hari lagi',
            modalWhatIsAge: {
                title: 'Apa itu Umur?',
                text: 'Setelah Anda membuat NFT, itu akan mulai hidup dan menua. Seiring bertambahnya usia, akhirnya akan mati. Dalam hal ini, perlu dihidupkan kembali. Umur panjang hewan peliharaan virtual Anda bergantung pada Peringkatnya',
                feature: {
                    title: 'Diskon Saat Memulihkan = {{discount}}%',
                    text: 'Setelah kematian alami NFT, Anda dapat memulihkannya dengan diskon {{discount}}% (mempertahankan Peringkat)',
                    alert: 'Naik Peringkat akan mengatur ulang usia NFT Anda kembali ke 0, dan hewan peliharaan virtual yang ditingkatkan akan hidup sesuai dengan batas usia Peringkat baru. Setelah menghidupkan kembali NFT, Anda akan memulai Level 1',
                },
            },
            modalNFTisAgeDead: {
                button: 'Mengembalikan',
                title: 'NFT Meninggal Karena Usia Tua!',
                text: 'NFT "{{name}}" telah menjalani hidup yang panjang dan bahagia dan meninggal dunia. Tidak perlu kesal, Anda dapat memulihkannya dan bermain lagi!',
                feature: {
                    title: 'Diskon Saat Memulihkan = {{discount}}%',
                    text: 'Setelah kematian alami NFT, Anda dapat memulihkannya dengan diskon {{discount}}% (mempertahankan Peringkat)',
                    alert: 'Naik Peringkat akan mengatur ulang usia NFT Anda kembali ke 0, dan hewan peliharaan virtual yang ditingkatkan akan hidup sesuai dengan batas usia Peringkat baru. Setelah menghidupkan kembali NFT, Anda akan memulai Level 1',
                },
            },
            checkoutAgeRevive: {
                title: 'Kembalikan NFT',
                text: 'NFT Anda tidak tersedia untuk tugas harian. Kembalikan untuk bermain dan dapatkan lebih banyak token',
                restoreTo: 'Kembalikan ke',
                transaction: 'Kembalikan "{{name}}" NFT',
                errors: {
                    wrongState:
                        'Ada yang salah, tidak bisa menghidupkan kembali hewan peliharaan.',
                },
            },
            successAgeRevive: {
                title: 'NFT Dipulihkan!',
                text: 'NFT berhasil dipulihkan. Mainkan tugas harian dan dapatkan lebih banyak token',
                backToPet: 'Lihat Hewan Peliharaan',
            },
        },
        earnings: {
            title: 'Penghasilan',
            text: 'Penghasilan NFT tergantung pada peringkat dan level hewan peliharaan',
            rank: 'Peringkat Penghasilan = ',
            level: 'Bonus Level = ',
        },
        matching: {
            title: 'Cocok',
            text: 'Dalam tugas sehari-hari, pengguna lain dapat menilai NFT Anda dan mencocokkan satu sama lain',
            like: '{{like}} Suka',
            dislike: '{{dislike}} Tidak suka',
        },
        health: {
            title: 'Kesehatan',
            text: 'Jaga agar hewan peliharaan Anda tetap diberi makan, jika tidak, ia bisa kehilangan kesehatannya. Setelah kesehatan hewan peliharaan mencapai 0, hewan peliharaan akan mati',
            titleDead: 'NFT sudah Mati',
            textDead:
                'Anda belum memberi makan hewan Anda untuk waktu yang lama dan sekarang hewan itu mati. Anda tidak akan dapat mengumpulkan pengalaman, hadiah, dan bermain dengan hewan peliharaan Anda. Tapi jangan khawatir, Anda dapat menghidupkannya kembali dan terus bermain. Cepatlah!',
            buttonFeed: 'Pakan Hewan Peliharaan',
            buttonRestore: 'Kembalikan NFT',
            modalWhatIsHealth: {
                title: 'Apa itu Kesehatan?',
                text: 'Kesehatan hewan peliharaan Anda menurun setiap hari jika Anda tidak memberinya makan. Jaga kesehatan Anda selalu maksimal untuk mendapatkan lebih banyak.',
                card: {
                    title: 'Kesehatan Hewan Peliharaan = Hadiah Harian',
                    text: 'Hadiah sebanding dengan HP, misalnya dengan 80 HP Anda akan mendapatkan 80% hadiah. Rawatlah hewan peliharaan Anda dengan baik!',
                },
            },
            modalNFTisDead: {
                title: 'NFT sudah Mati',
                text: 'Anda belum memberi makan hewan "{{petName}" Anda untuk waktu yang lama dan sekarang hewan itu mati. Anda tidak akan dapat mengumpulkan pengalaman, hadiah, dan bermain dengan hewan peliharaan Anda. Tapi jangan khawatir, Anda dapat menghidupkannya kembali dan terus bermain. Cepatlah!',
                button: 'Kembalikan NFT',
            },
            checkoutRevive: {
                title: 'Kembalikan NFT',
                text: 'NFT Anda tidak tersedia untuk tugas harian. Kembalikan untuk bermain dan dapatkan lebih banyak token',
                restoreTo: 'Kembalikan ke',
                transaction: 'Kembalikan "{{name}}" NFT',
                max: '100 Kesehatan',
                errors: {
                    wrongState:
                        'Ada yang salah, tidak bisa menghidupkan kembali hewan peliharaan.',
                },
            },
            successRevive: {
                title: 'NFT Dipulihkan!',
                text: 'NFT berhasil dipulihkan. Mainkan tugas harian dan dapatkan lebih banyak token',
                backToPet: 'Lihat Hewan Peliharaan',
            },
            checkoutHealUp: {
                title: 'Umpan NFT',
                text: 'Kesehatan hewan Anda bergantung pada pemberian makan harian. Dengan kesehatan penuh, hewan Anda menghasilkan lebih banyak koin',
                restoreTo: 'Pulihkan pada',
                transaction: 'Kembalikan "{{name}}" NFT',
                max: '{{amount}} Kesehatan',
                errors: {
                    wrongState:
                        'Ada yang salah, tidak bisa menyembuhkan hewan peliharaan.',
                },
            },
            infoMultipleHealUp: {
                title: 'Beri Makan Banyak Hewan Piaraan',
                text: 'Gunakan satu tombol untuk memberi makan semua hewan peliharaan Anda! Hewan peliharaan akan disembuhkan satu per satu. Semua transaksi terjadi di blockchain, sehingga Anda dapat melacaknya',
                primaryButton: 'Beri makan hewan peliharaan',
                secondaryButton: 'Jangan tunjukkan lagi',
            },
            checkoutMultipleHealUp: {
                title: 'Beri Makan Banyak Hewan Piaraan',
                text: 'Kembalikan Kesehatan semua hewan peliharaan Anda. NFT dengan lebih banyak Kesehatan akan mendapatkan lebih banyak hadiah',
                transaction: 'Kembalikan {{count}} NFTs',
            },
            proceedingMultipleHealUp: {
                title: 'Kesehatan sedang Dipulihkan',
                text: 'Harap tunggu sebentar sampai semua transaksi selesai. Jangan keluar dari layar, karena transaksi mungkin gagal! Setelah selesai, Anda akan dapat keluar dari layar',
                error: 'Beberapa transaksi NFT gagal karena masalah blockchain. Coba lagi',
            },
            multipleSuccessHealUp: {
                title: 'Kesehatan NFT Dipulihkan!',
                text: 'Kesehatan hewan peliharaan Anda dipulihkan. Klik tombol di bawah untuk detail lebih lanjut tentang setiap transaksi',
                backToCollection: 'Kembali ke Koleksi',
                item: 'Memberi makan {{length}} hewan peliharaan',
            },
            successHealUp: {
                title: 'Kesehatan NFT Pulih Kembali!',
                text: 'NFT berhasil diberi makan dan kesehatannya pulih kembali. Mainkan tugas harian dan dapatkan lebih banyak token',
                backToPet: 'Lihat Hewan Peliharaan',
            },
            healUpAmountChoose: {
                title: 'Pakan untuk Memulihkan Kesehatan',
                text: 'Pilih opsi dengan kuantitas poin kesehatan yang ingin Anda pulihkan',
                button: 'Checkout',
                loading: 'Menghitung ringkasan..',
                label: 'Pilih nomor yang sesuai',
                errors: {
                    MAX: 'Maksimum yang tersedia untuk memulihkan {{amount}} kesehatan',
                    MIN: 'Minimum yang tersedia untuk memulihkan {{amount}} kesehatan',
                },
            },
            healthPetCollectionList: {
                health: '{{health}} Kesehatan',
            },
            healAllLeave: {
                title: 'Apakah Anda yakin ingin pergi?',
                text: 'Penyembuhan hewan peliharaan Anda sedang berlangsung, meninggalkan hewan peliharaan Anda selama proses tersebut dapat mengakibatkan kesalahan, pengeluaran ganda, atau pengurangan saldo yang salah. Lanjutkan dengan hati-hati',
                leave: 'Pergi saja',
                keep: 'Selesai Penyembuhan',
            },
        },
        blockchainInfo: {
            tokenId: 'ID Token',
            title: 'Ikhtisar NFT',
            description:
                'Aset NFT hewan peliharaan Anda disimpan di blockchain. Anda dapat menariknya dari dompet kapan saja',
            descriptionFree:
                'Hewan peliharaan Anda adalah Rank Free dan bukan NFT yang sebenarnya. Naikkan level dan Anda akan dapat membuat NFT darinya',
            warningText:
                'Setelah penarikan NFT akan memasuki mode Cooldown dan tidak akan tersedia untuk dimainkan selama 24 jam',
            cooldown: 'Cooldown berakhir pada',
            withdraw: 'Menarik diri',
        },
    },
    mysteryBoxes: {
        title: 'Kotak Misteri',
        emptyTitle: 'Belum ada Kotak Misteri',
        emptyText: 'Anda tidak memiliki Kotak Misteri apa pun',
        emptyButton: 'Membeli Kotak',
        prepareToOpen: 'Membuka kotak, menunggu hasil acak ChainLink Oracle ..',
        banner: {
            isComing: {
                title: 'Penjualan Kotak Misteri Akan Datang',
                text: ' waktu yang tersisa',
            },
            isStart: {
                title: 'Beli Kotak Misteri',
                text: 'Cobalah keberuntungan Anda dan menangkan peringkat tertinggi',
            },
            isNotAvailable: {
                title: 'Penjualan Kotak Misteri ditutup',
                text: 'Penjualan Kotak Misteri jarang terjadi dan tidak tersedia hingga pemberitahuan lebih lanjut',
            },
        },
        header: {
            title: 'Kotak Misteri',
            text: 'Kotak yang Anda beli akan disimpan di sini. Buka mereka kapan saja dan mint NFT',
        },
        mysteryBoxCard: { open: 'Kotak Terbuka', mint: 'Sebagai NFT' },
        error: {
            title: 'Kesalahan',
            text: 'Ada yang salah. Cobalah untuk memuat ulang',
        },
        openRank: { button: 'Lihat Detail' },
        openBoxModal: {
            title: 'Apakah Anda Ingin Membuka Kotak?',
            text: 'Setelah membuka kotak, Anda akan mendapatkan peringkat acak dan akan dapat mencetak NFT secara gratis',
            button1: 'Ya, Terbuka',
            button2: 'Tidak, Batalkan',
        },
        purchaseWelcome: {
            stepOne: {
                title: 'Cobalah Keberuntungan Anda dengan Kotak Misteri',
                text: 'Mystery Box memberi Anda kesempatan untuk mendapatkan Peringkat NFT terbaik dengan harga tetap. Cobalah keberuntungan Anda!',
            },
            stepTwo: {
                title: 'Kesempatan Untuk Mendapatkan Peringkat Tertinggi',
                text: 'Setelah Anda membeli Mystery Box, Anda dapat membukanya kapan saja dan kemudian melanjutkan proses pencetakan tanpa biaya tambahan',
            },
            stepThree: {
                title: 'Keacakan yang Sebenarnya',
                text: 'Peluang Kotak Misteri untuk memenangkan peringkat yang berbeda sepenuhnya acak dan menggunakan teknologi ChainLink Oracle untuk menghasilkan angka acak yang sebenarnya pada blockchain',
            },
            button: 'Pilih Jumlah Kotak',
        },
        purchaseScreen: {
            title: 'Pilih Kuantitas',
            text: 'Anda bisa membeli banyak kotak sekaligus',
            label: 'Masukkan atau pilih jumlah',
            labelNoInput: 'Pilih jumlah kotak Misteri',
            errors: {
                max: 'Maksimum yang tersedia adalah 10 kotak',
                min: 'Minimum yang tersedia adalah 1 kotak',
                noSymbols: 'Hanya angka yang diperbolehkan',
            },
            button: 'Checkout',
            loading: 'Menghitung ringkasan..',
        },
        purchaseCheckout: {
            title: 'Beli Kotak Misteri',
            text: 'Mystery Box memberi Anda kesempatan untuk mendapatkan Peringkat NFT terbaik dengan harga tetap. Cobalah keberuntungan Anda!',
            transactionDetails: {
                label: 'Kotak',
                text: '{{amount}} Kotak Misteri',
                transaction: 'Beli {{amount}} Kotak Misteri',
            },
        },
        purchaseSuccess: {
            title: 'Kotak Misteri Dibeli!',
            text: 'Kotak misteri berhasil dibeli. Anda dapat membukanya dari tab Kotak Misteri',
            button: 'Lihat semua',
        },
        comingSoon: {
            title: 'Kotak Misteri Segera Hadir',
            text: 'Penjualan Kotak Misteri akan datang. Pantau terus dan coba keberuntungan Anda!',
            timer: 'Sisa Waktu',
        },
        saleClosed: {
            title: 'Kotak Misteri Tidak Tersedia',
            text: 'Penjualan Mystery Boxes tidak tersedia saat ini. Nantikan pengumuman resmi',
        },
        errors: {
            forbidden: {
                title: 'Penjualan sudah berakhir',
                text: 'Penjualan sudah berakhir, tidak ada Kotak Misteri yang tersisa untuk dibeli. Cobalah keberuntungan Anda lain kali',
            },
        },
        modalMysteryBoxSaleInfo: {
            title: 'Cobalah Keberuntungan Anda dengan Kotak Misteri',
            text: 'Nilai NFT dijamin tidak kurang dari harga Mystery Box. Mystery Box akan dijual dengan harga',
            timerTitle: 'Waktu Sampai Penjualan',
            timerText:
                'Ini adalah penjualan koleksi terbatas, yang akan berlangsung dalam waktu terbatas. Hanya ',
            timerAdditionalText: 'tersedia {{amount}} NFT',
            chanceTitle: 'Peluang untuk Menang',
            chanceText:
                'Menangkan NFT dengan probabilitas tertentu. Berikut adalah peluangnya:',
            button: 'Untuk Kotak Misteri',
        },
    },
    errorBoundary: {
        navigation: 'Kesalahan',
        title: 'Kesalahan sisi klien',
        text: 'Sayangnya ada yang salah di pihak kami. Jika Anda terus melihat kesalahan ini, silakan hubungi dukungan kami',
        button: 'Pergi ke halaman Utama',
        reloadApp: 'Muat Ulang Aplikasi',
    },
    pullToRefresh: {
        reloadBalance: {
            text: 'Keseimbangan yang menyegarkan ..',
            modalText: 'Menyegarkan..',
        },
        reloadPets: {
            text: 'Hewan peliharaan yang menyegarkan..',
            modalText: 'Menyegarkan..',
        },
        reloadMysteryBox: {
            text: 'Kotak misteri yang menyegarkan..',
            modalText: 'Menyegarkan..',
        },
        reloadTasks: {
            text: 'Tugas yang menyegarkan..',
            modalText: 'Menyegarkan..',
        },
        reloadVerifyUsers: {
            text: 'Mencari hewan peliharaan ..',
            modalText: 'Menyegarkan..',
        },
        reloadRewards: 'Hadiah yang menyegarkan..',
        reloadStatistics: 'Statistik yang menyegarkan..',
        reloadReferrals: 'Referensi yang menyegarkan..',
        loading: 'Menyegarkan..',
        pulling: 'Tarik Untuk Menyegarkan',
        releasing: 'Rilis',
    },
    petLevelUp: {
        readyToUpModal: {
            titleStart: 'NFT Siap untuk',
            titleLevelUp: ' {{level}} Level',
            titleEnd: 'Naik',
            subTitleStart:
                'Selamat! Anda telah mengumpulkan semua pengalaman dan NFT',
            subTitleEnd: ' siap untuk naik level',
            button: 'Tingkatkan',
            featureRankEarnings: {
                title: 'Penghasilan Peringkat ≈ {{igup}} ≈ ({{usd}}$)',
                text: 'Ini adalah penghasilan Anda berdasarkan Peringkat saja',
            },
            featureLevelEarnings: {
                title: 'Penghasilan Tingkat',
                text: 'Penghasilan tambahan yang Anda dapatkan dari Level NFT Anda. Setiap Level-up meningkatkan penghasilan Anda',
            },
            featureNextRank: {
                title: '{{levels}} tingkat(level) Lebih ke “{{rankName}}”',
                text: 'Anda perlu menaikkan level NFT Anda {{levels}} kali lagi untuk dapat meningkatkannya ke Peringkat berikutnya',
            },
        },
        petLevelUpSuccess: {
            title: 'NFT Naik Level!',
            text: 'NFT {{name}} berhasil naik level ke Level {{level}}. Mainkan tugas harian dan dapatkan lebih banyak token dengan NFT yang ditingkatkan',
            backToPet: 'Lihat Hewan Peliharaan',
            loading: 'Memperbarui hewan peliharaan..',
        },
        headerTitle: 'NFT Naik Level',
        checkout: {
            upgrade: 'Tingkatkan ke',
            level: 'Level {{level}}',
            transaction: 'Naikkan level untuk {{name}} NFT',
        },
        errors: { PET_WRONG_STATE: 'Kenaikan level tidak tersedia' },
    },
    petRankUp: {
        readyToUpModal: {
            title: 'Tingkatkan ke {{rank}} Rank',
            subTitle:
                'Anda mencapai semua level dalam {{rank}} peringkat dan Hewan Peliharaan Anda siap untuk ditingkatkan',
            button: 'Tingkatkan',
        },
        petLevelUpSuccess: {
            title: 'NFT Naik Peringkat!',
            text: 'NFT {{name}} berhasil naik peringkat ke peringkat {{rank}}. Mainkan tugas harian dan dapatkan lebih banyak token dengan NFT {{rank}} yang telah diupgrade',
            backToCollection: 'Kembali ke Koleksi',
            loading: 'Perbarui hewan peliharaan..',
        },
        headerTitle: 'NFT Naik Level',
        checkout: {
            upgrade: 'Tingkatkan ke',
            level: 'Level {{level}}',
            transaction: 'Naikkan level untuk {{name}} NFT',
        },
        errors: { PET_WRONG_STATE: 'Peringkat tidak tersedia' },
    },
    petIsPlaying: {
        title: 'Hewan Peliharaan Anda Sedang Bermain',
        text: 'Jika Anda menariknya dari akun Anda sebelum menyelesaikan tugas, Anda tidak akan mendapatkan hadiah untuk hari ini dan hewan peliharaan Anda akan memasuki mode Cooldown selama 24 jam ke depan',
        button: 'Saya mengerti',
    },
    petOnCooldown: {
        title: 'Cooldown NFT',
        text: 'NFT Anda sedang ditransfer dari bursa lain dan belum dapat dimainkan, perkiraan waktu transfer ditunjukkan di atas. Kami mencoba yang terbaik untuk membuatnya lebih cepat, terima kasih atas pengertian Anda',
    },
    petIsDead: {
        title: 'NFT sudah Mati',
        text: 'Anda belum memberi makan hewan "{{petName}" Anda untuk waktu yang lama dan sekarang hewan itu mati. Anda tidak akan dapat mengumpulkan pengalaman, hadiah, dan bermain dengan hewan peliharaan Anda. Tapi jangan khawatir, Anda dapat menghidupkannya kembali dan terus bermain. Cepatlah!',
        errors: {
            PET_WRONG_STATE: 'Pemulihan hewan peliharaan tidak tersedia',
        },
    },
    socializeToEarn: {
        welcomeSlidesShare: {
            startSharing: 'Mulai Berbagi',
            sharing: 'Berbagi adalah Peduli',
            sharingText:
                'Setiap hari hewan peliharaan Anda membutuhkan perhatian dari Anda. Berikan kepada mereka dengan membagikannya di media sosial dengan teman-teman Anda',
            sharingEnergy: ' Total Energi',
            socialMedia: 'Bagikan Hewan Peliharaan Anda di Media Sosial',
            socialMediaText:
                'Pilih akun media sosial Anda dan lampirkan Pet ID ke konten media sosial Anda dan biarkan pengguna lain menemukan hewan peliharaan Anda',
            socialMediaEnergy: ' Total Energi',
            referral: 'Tambahkan tautan rujukan Anda',
            referralText:
                'Tautan rujukan Anda harus dilampirkan ke ID hewan peliharaan dalam cerita. Pemain lain tidak akan dapat memeriksa tugas Anda jika tautannya tidak ada!',
            errors: {
                FORBIDDEN: {
                    text: 'Anda tidak dapat memulai tugas sosial sekarang dengan akun sosial ini. Coba lagi besok',
                },
            },
        },
        shareYourPetPhoto: {
            copyToClipboard: 'Nama pengguna disalin ke clipboard',
            title: 'Bagikan Foto Hewan Peliharaan Anda',
            texts: {
                INSTAGRAM:
                    'Bagikan konten Anda dengan kartu ID Hewan Peliharaan terlampir di Instagram dan biarkan pengguna lain menemukan hewan peliharaan Anda',
                TIKTOK: 'Bagikan konten Anda dengan kartu ID Hewan Peliharaan terlampir di TikTok dan biarkan pengguna lain menemukan hewan peliharaan Anda',
                TWITTER:
                    'Bagikan konten Anda dengan kartu ID Hewan Peliharaan terlampir di Twitter dan biarkan pengguna lain menemukan hewan peliharaan Anda',
                FACEBOOK:
                    'Bagikan konten Anda dengan kartu ID Hewan Peliharaan terlampir di Facebook dan biarkan pengguna lain menemukan hewan peliharaan Anda',
            },
            info: 'Bagaimana cara berbagi?',
            download: 'Unduh',
            share: 'Berbagi',
            createPhoto: 'Editor Terbuka',
            button: 'Bagikan dan Selesaikan',
            warningText:
                'Pastikan ID Hewan Peliharaan Anda tersedia dan mudah ditemukan oleh pengguna lain sampai tugas Anda selesai',
            selectCreationMethod: 'Pilih Foto',
            creationMethod: {
                camera: 'Ambil Foto',
                gallery: 'Pilih dari Galeri',
            },
            modalPetIdVisible: {
                title: 'Pet ID Dan Tautannya Terlihat?',
                text: 'Cerita Anda akan diperiksa oleh pengguna lain. Jika mereka tidak dapat menemukan ID Hewan Peliharaan atau tautannya atau tidak dapat membedakan kontennya, penyelesaian tugas Anda akan ditolak',
                button1: 'Ya, Lanjutkan',
                button2: 'Tidak, Periksa Lagi',
            },
            modalShareYourPhoto: {
                title: 'Pilih Metode Berbagi',
                shareTemplate: {
                    title: 'Bagikan Template',
                    text: 'Gunakan templat yang kami buat untuk membagikan Pet ID Anda lebih cepat',
                },
                editToShare: {
                    title: 'Edit untuk Berbagi',
                    text: 'Unggah gambar dari galeri atau ambil foto untuk pengeditan Pet ID khusus',
                },
                downloadPetId: {
                    title: 'Unduh Pet ID',
                    text: 'Tata postingan sesuai keinginan Anda tanpa menggunakan alat bantu kami',
                },
                submit: 'Saya memiliki ID Hewan Peliharaan Bersama',
                loading: 'Mempersiapkan konten..',
                saveSuccess: 'Foto berhasil disimpan',
            },
            petIdVisibleLoading: 'Membuat Tugas Menemukan ..',
            shareSuccess: {
                title: 'Temukan Hewan Peliharaan Lainnya',
                text: 'Anda telah berhasil membagikan foto hewan peliharaan Anda. Tugas Anda sedang dalam verifikasi dan biasanya membutuhkan waktu antara 6 hingga 12 jam. Sekarang giliran Anda untuk menemukan hewan peliharaan lain di media sosial',
                button1: 'Temukan Hewan Peliharaan Lainnya',
                button2: 'Kembali ke Berbagi',
                button3: 'Kembali ke Tugas',
                toastSuccess: 'Semua tugas verifikasi selesai',
            },
            alert: 'Tugas akan dianggap selesai hanya jika Anda menempatkan tautan ke aplikasi',
        },
        createShareTemplate: {
            screenTitle: 'Berbagi Templat',
            title: 'Gunakan Templat untuk Berbagi',
            text: 'Manfaatkan templat pra-desain kami untuk berbagi konten dengan cepat dan nyaman',
            shareTemplate: {
                Default: 'Saya Memainkan IguVerse dan Menghasilkan Crypto',
                BinanceNft: 'Dapatkan hewan peliharaan NFT dengan IguVerse',
                BnbChain: 'Dapatkan hewan peliharaan NFT dengan IguVerse',
                Okx: 'IGU Pendaratan di Bulan: Peluncuran di OKX',
                KuCoin: 'IGU Pendaratan di Bulan: Peluncuran di KUCOIN',
                Bybit: 'Pilih IguVerse &\nBagikan Hadiah\n$121.000!',
            },
            placeForLink: 'Tempat untuk Tautan',
            socialCardTemplate: {
                Default: 'Saya IguVerse\ndan Menghasilkan Crypto',
                Bybit: 'Pilih IguVerse &\nBagikan Hadiah\n$121.000!',
            },
        },
        welcomeSlidesVerify: {
            startVerify: 'Mulai Temukan Tugas',
            find: 'Temukan Hewan Peliharaan Lainnya',
            findText:
                'Hewan peliharaan Anda membutuhkan perhatian dari hewan peliharaan lain. Temukan hewan peliharaan pemain lain dan nikmati hadiah bersama. Jangan salah saat mencari hewan peliharaan lain, mereka mengandalkan Anda. Tujuan harian Anda adalah menemukan semua hewan peliharaan.',
            findEnergy: ' Total Energi',
            beResponsible: 'Bertanggung Jawab',
            beResponsibleText:
                'Bermainlah dengan adil dan jangan mencoba menipu dengan menyesatkan sistem dengan memberikan ID yang salah atau mengklaim bahwa Anda tidak dapat menemukannya. Akun Anda mungkin ditandai setelah Anda melakukan ini',
            beResponsibleEnergy: ' Total Energi',
        },
        verifyUser: {
            title: 'Temukan Hewan Peliharaan',
            text: 'Anda perlu mencari dan memasukkan ID Pet pengguna lain, yang dapat ditemukan di media sosial. Untuk setiap pertandingan yang berhasil, Anda akan mendapatkan {{energy}} Energi',
            info: 'Bagaimana Menemukan Identitas Hewan Peliharaan?',
            label: 'ID Hewan Peliharaan',
            placeHolder: 'Masukkan ID Hewan Peliharaan',
            question: 'Bagaimana Cara Menemukannya?',
            buttonVerify: 'Verifikasi',
            buttonNotFound: 'ID tidak ditemukan',
            errorMessage:
                'Kode ID Hewan Peliharaan salah. Silakan coba lagi. Upaya tersisa {{attempts}}!',
            loadingVerifyUser: 'Memeriksa..',
            errors: {
                noTasksText1: 'Tidak ada tugas yang tersedia sekarang',
                noTasksText2: 'Kembali lagi nanti',
                gameIterationExists1: 'Anda tidak diizinkan untuk membuat',
                gameIterationExists2:
                    'lebih banyak tugas dalam iterasi permainan ini',
            },
            toastNoPetVerification: {
                title: 'Kesalahan',
                text: 'Tidak ada hewan peliharaan yang tersedia untuk verifikasi',
            },
            toastSuccess: 'Selamat! Pengguna {{user}} telah diverifikasi',
            toastFailedVerify: 'Gagal! Pengguna {{user}} tidak terverifikasi',
            regexError: 'Hanya digit dan karakter A-Z yang diperbolehkan',
            verifyEmpty: {
                title: 'Tidak Ada Lagi Hewan Peliharaan',
                text: 'Sepertinya tidak ada yang bermain sekarang. Kami akan memberi tahu Anda ketika lebih banyak hewan peliharaan tersedia',
                button1: 'Jelajahi Tugas Lainnya',
                button2: 'Coba lagi',
                refresh: 'Menyegarkan',
            },
            verifyNotFound: {
                title: 'Hewan Peliharaan Tidak Ditemukan',
                text: 'Semoga Anda benar. Jika hewan peliharaan benar-benar ada di sana maka kami akan memberikan peringatan kepada Anda',
                button1: 'Temukan Berikutnya',
                button2: 'Selesai Bermain',
            },
            verifyAlreadyCompleted: {
                title: 'Sudah Selesai',
                text: 'Teks Sudah Selesai',
                button1: 'Verifikasi Berikutnya',
                button2: 'Selesai Bermain',
            },
            verifyMatch: {
                title: 'Hewan Peliharaan Cocok!',
                text: {
                    step1: 'Selamat! Hewan peliharaan Anda',
                    step2: ' cocok dengan hewan peliharaan',
                    step3: '! Sekarang Anda akan dapat terhubung di dalam aplikasi',
                },
                button1: 'Temukan Berikutnya',
                button2: 'Selesai Bermain',
                like: 'Suka',
                dislike: 'Tidak suka',
                alreadyRate: 'Tidak dapat mengubah keputusan Anda',
            },
            verifyFailed: {
                title: 'Gagal',
                text: 'Sayangnya, Anda gagal memberikan kode Pet ID yang benar',
                button1: 'Temukan Berikutnya',
                button2: 'Selesai Bermain',
            },
            modalPetIdNotFound: {
                title: 'ID Hewan Peliharaan Tidak Ditemukan?',
                text: 'Coba temukan ID Hewan Peliharaan pada foto pengguna. Jika ID Hewan Peliharaan ada di sana dan Anda tidak memberikannya, maka Anda tidak akan mendapatkan poin Energi dan mungkin akan menerima peringatan.',
                button1: 'Ya, Konfirmasi',
                button2: 'Batal',
            },
            tips: {
                title: 'Kiat Verifikasi',
                alert: "Jika Pet ID tidak memenuhi aturan, klik tombol 'ID Hewan Peliharaan tidak ditemukan'",
                post: 'Pet ID harus ada di story atau postingan',
                picture:
                    'Pet ID dan semua info di dalamnya harus mudah dilihat dalam gambar',
                changes:
                    'Pet ID dapat diubah, tetapi perubahan tersebut tidak boleh bertentangan dengan aturan lain',
                cropping:
                    'Dilarang memotong atau menyembunyikan gambar atau bagian-bagiannya',
                overlaying:
                    'Tidak ada overlay atau perampingan berlebihan yang diperbolehkan',
            },
        },
        petCardId: {
            link: 'Unduh aplikasi IguVerse di ',
            earnStart: 'Hewan peliharaan saya mendapatkan ',
            earnEnd: ' setiap hari',
            freeEarn: 'Penghasilan hewan peliharaan gratis saya ',
            donateMessage: 'Sebagian dari penghasilan saya disumbangkan ke ',
            binanceMessage: 'IguVerse x Binance Penjualan NFT',
            bnbMessage:
                'IguVerse x BNB Chain: Bergabunglah dengan tren viral baru di Web3 dan media sosial',
            okxKuCoinMessage: 'Token IGU Diluncurkan di ',
            defaultMessage:
                'AI ve bir reklam ağı içeren bir pazar yeri - şimdi katılın!',
        },
    },
    moveToEarn: {
        welcomeSlides: {
            walkPet: 'Berjalan-jalan dengan Hewan Peliharaan Anda',
            walkPetText:
                'Hewan peliharaan Anda perlu berjalan kaki setiap hari agar tetap sehat seperti halnya Anda. Jalan-jalan dengan hewan peliharaan Anda dan Anda akan diberi hadiah poin Energi',
            energyTotal: ' Total Energi',
            complete: 'Selesaikan Target Berjalan Kaki Anda',
            completeText:
                'Selesaikan tujuan berjalan kaki Anda, lacak kinerja Anda dan nikmati gaya hidup sehat',
            antiCheating: 'Algoritma Anti-Kecurangan',
            antiCheatingText:
                'Algoritma anti-kecurangan kami mampu mendeteksi aktivitas mencurigakan dari pengguna. Pengguna yang melakukan kecurangan akan kehilangan poin energi mereka',
        },
        modals: {
            prepare: 'Bersiaplah untuk Berjalan',
            prepareText:
                'Anda dapat menyelesaikan tugas berjalan satu kali per hari. Setelah Anda menyelesaikan atau menutup tugas, Anda tidak akan dapat bermain lagi hari ini',
            leave: 'Apakah Anda ingin pergi?',
            leaveText:
                'Anda akan menyelesaikan tugas dengan kemajuan Energi Anda saat ini. Anda bisa memulai tugas lagi besok',
            leaveBtn1: 'Ya, Tinggalkan',
            leaveBtn2: 'Tidak, Lanjutkan',
            prepareBtn1: 'Mulai Berjalan',
            prepareBtn2: 'Batal',
            permissionsInfoText:
                'IguVerse mengumpulkan data lokasi bahkan ketika aplikasi ditutup atau tidak digunakan. Aplikasi dapat mengakses lokasi Anda di latar belakang untuk memastikan fungsionalitas Walking Task',
            permissionsInfoBtn1: 'Lanjutkan',
            permissionsInfoBtn2: 'Batal',
            leaveWithOutFinish: 'Apakah Anda Ingin Keluar?',
            leaveWithOutFinishText:
                'Setelah Anda menutup tugas, progres Anda akan hilang dan Anda harus memulai lagi',
            leaveWithOutFinishBtn1: 'Keluar',
            leaveWithOutFinishBtn2: 'Batal',
        },
        notSupported: {
            title: 'Geolokasi Tidak Tersedia',
            text: 'Perangkat Anda tidak mendukung API geolokasi, Anda tidak dapat menyelesaikan Walking Task',
            button: 'OK',
        },
        locationProblem: {
            title: 'Masalah Geolokasi',
            text: 'Kami telah memperhatikan, bahwa fitur geolokasi perangkat Anda berhenti berfungsi seperti yang diharapkan, Anda perlu memulai ulang tugas',
            button: 'Dapat',
        },
        progress: {
            paused: 'Berhenti sejenak',
            walking: 'Berjalan',
            stopped: 'Berhenti',
            tooFast: 'Terlalu Cepat',
            title: 'Berjalan-jalan dengan Hewan Peliharaan Anda',
            timeLeft: 'Waktu yang tersisa untuk berjalan',
            tooFastMessage:
                'Kecepatan Anda tidak boleh lebih dari 20 km/jam. Kemajuan akan dilanjutkan ketika kecepatan menjadi lebih rendah',
            walkStoppedMessage:
                'Sepertinya Anda berhenti berjalan. Kemajuan Anda akan berlanjut setelah Anda terus berjalan',
        },
        summary: {
            title: 'Statistik Berjalan',
            youEarned: 'Anda Mendapatkan',
            energy: 'Energi',
            subtitle:
                'Selamat! Anda menemukan semua hewan peliharaan. Kembalilah besok untuk lebih banyak lagi',
            distance: 'Jarak',
            steps: 'Langkah-langkah',
            averageSpeed: 'Kecepatan Rata-rata',
            viewMoreTasks: 'Lihat Tugas Lainnya',
            finishPlaying: 'Selesai Bermain',
        },
        startWalking: 'Mulai Berjalan',
        skip: 'Ketuk untuk Melewati',
        km: 'km',
        kmH: 'km/jam',
    },
    playToEarn: {
        welcomeSlides: {
            energy: 'Kembalikan Energi Anda',
            energyText:
                'Kumpulkan buah-buahan dan lompati rintangan dan pulihkan tingkat Energi harian Anda. Hati-hati, Anda hanya memiliki satu percobaan per hari',
            energyAgainText:
                'Latih keterampilan Anda dalam game untuk mendapatkan lebih banyak hadiah. Tugas tersedia sekali sehari, namun Anda dapat memainkan game kapan saja ',
            energyTotal: ' Total Energi',
            energyAgainTotal: 'Latihan',
            avoid: 'Hindari Rintangan',
            avoidText:
                'Tujuan utama Anda adalah melompati rintangan untuk mengumpulkan poin. Hati-hati!',
            food: 'Kumpulkan Makanan',
            foodText:
                'Makanan yang dikumpulkan memberi Anda skor tambahan. Setelah mencapai skor target, permainan selesai dan level Energi Anda segera dipulihkan ',
        },
        modals: {
            prepareToPlay: {
                title: 'Bersiap untuk Bermain',
                text: 'Dalam permainan pertama Anda, Anda akan bermain untuk memulihkan energi. Jika Anda tidak dapat mengumpulkan semua energi, Anda akan dapat bermain game, tetapi tanpa kemajuan energi',
                accept: 'Mulai Bermain',
                cancel: 'Batal',
            },
            playAgain: {
                title: 'Bersiap untuk Bermain',
                text: 'Anda telah mengumpulkan energi dalam game ini hari ini. Sekarang Anda hanya bisa bermain untuk meningkatkan keterampilan untuk hari-hari berikutnya',
                accept: 'Mulai Bermain',
                cancel: 'Batal',
            },
            loading: { text: 'Mempersiapkan permainan..' },
            gameTimer: {
                text: 'Ketuk untuk melompati rintangan. Dapatkan skor dan kumpulkan buah-buahan',
                textWebDesktop:
                    'Tekan spasi atau klik kiri mouse untuk melompati rintangan. Dapatkan skor dan kumpulkan buah-buahan',
                textWebMobile:
                    'Ketuk untuk melompati rintangan. Dapatkan skor dan kumpulkan buah-buahan',
            },
            pause: {
                title: 'Apakah Anda ingin pergi?',
                text: 'Progress Anda saat ini akan dikonversi menjadi Energi, namun Anda tidak akan bisa bermain lagi hari ini',
                accept: 'Ya, Tinggalkan',
                cancel: 'Tidak, Lanjutkan',
            },
            win: {
                title: 'Tugas Selesai',
                text: 'Selamat! Anda telah berhasil menyelesaikan tugas harian Anda. Anda bisa terus bermain untuk bersenang-senang, namun tidak akan memengaruhi level Energi Anda',
                accept: 'Selesai',
                cancel: 'Mainkan Lebih Banyak',
            },
            loose: {
                title: 'Permainan Selesai',
                text: 'Anda gagal dalam tugas harian Anda. Anda dapat terus bermain untuk bersenang-senang, namun tidak akan memengaruhi level Energi Anda',
                accept: 'Selesai',
                cancel: 'Mainkan Lebih Banyak',
            },
            score: 'Skor Anda',
            energy: 'Energi Dipulihkan',
            savedLives: 'Menyelamatkan Nyawa',
            fruitCollected: 'Buah yang Dikumpulkan',
        },
        summary: {
            title: 'Statistik Bermain',
            score: 'Skor Anda',
            lives: 'Menyelamatkan Nyawa',
            fruitCollected: 'Buah yang Dikumpulkan',
        },
        startPlaying: 'Mulai Bermain',
        loadingStatuses: {
            downloading: 'Mengunduh Aset',
            preparing: 'Mempersiapkan Tekstur',
            loadingGraphics: 'Memuat Grafik',
            spawning: 'Objek Permainan Pemijahan',
            loading: 'Memuat (Jangan Tutup Aplikasi)',
        },
    },
    editNFTsScreen: {
        title: 'Pilih Hewan Untuk Bermain',
        dragText:
            'Hewan peliharaan yang akan berpartisipasi dalam permainan. Seret untuk mengubah urutan',
        selectList: 'Pilih hewan peliharaan dari daftar',
        warningMessage:
            'Hewan peliharaan pertama secara berurutan akan digunakan dalam tugas Sosial Anda sebagai Pet ID',
        cooldownMessage:
            'NFT Anda berada dalam mode Cooldown dan tidak dapat berpartisipasi dalam permainan. Tunggu sampai mode Cooldown berakhir',
        button: 'Simpan',
        errors: {
            saveChanges: {
                title: 'Perubahan yang Belum Disimpan',
                text: 'Anda memiliki perubahan yang belum diselamatkan, apakah Anda yakin ingin pergi?',
                button1: 'Pergi',
                button2: 'Kembali dan simpan',
            },
        },
        loading: 'Menyimpan perubahan..',
        success: 'Pesanan NFT tersimpan!',
    },
    statuses: {
        COMPLETED: { title: 'Selesai' },
        AWAITS_VERIFICATION: { title: 'Menunggu verifikasi' },
        MODERATOR_VERIFICATION_REQUIRED: { title: 'Menunggu verifikasi' },
        FAILED: { title: 'Gagal' },
    },
    profile: {
        title: 'Pengaturan',
        logOut: 'Keluar',
        deleteAccount: 'Hapus Akun',
        logOutModal: {
            title: 'Sudah Pergi?',
            description:
                'Anda harus masuk lagi atau mendaftar akun baru untuk menggunakan Aplikasi IguVerse',
            okText: 'Ya, Keluar',
            cancelText: 'Batal',
        },
        deleteAccountModal: {
            title: 'Hapus Akun?',
            description:
                'Anda bisa menghapus akun Anda secara permanen, tetapi perlu diketahui, bahwa Anda tidak akan bisa masuk dan menggunakannya lagi',
            okText: 'Hapus Akun',
            inputLabel: 'Frasa Konfirmasi',
            placeholder: 'Masukkan frasa konfirmasi',
            preConfirmationPhrase: 'Jenis',
            afterConfirmationPhrase: ' untuk mengonfirmasi tindakan',
            success: 'Akun Anda berhasil dihapus',
            loading: 'Menghapus akun Anda..',
        },
        lightTheme: 'Cahaya',
        darkTheme: 'Gelap',
        menuItems: {
            admin: {
                title: 'Verifikasi pengguna',
                description: 'Verifikasi media sosial pengguna',
            },
            security: {
                title: 'Keamanan',
                description: 'Sesuaikan pengaturan keamanan Anda',
            },
            socialAccounts: {
                title: 'Akun Sosial',
                description:
                    'Hubungkan media sosial Anda untuk hadir dalam permainan Sosial',
            },
            assignRole: {
                title: 'Tetapkan Peran',
                description: 'Pilih dan tetapkan peran akun kepada pengguna',
            },
            language: {
                title: 'Bahasa',
                description: 'Mengatur bahasa tampilan',
            },
            theme: { title: 'Tema', description: 'Pilih tema antarmuka' },
            notifications: {
                title: 'Pemberitahuan',
                description:
                    'Pilih jenis notifikasi yang ingin Anda dapatkan dari aplikasi',
            },
            support: {
                title: 'Dukungan melalui Chat',
                description:
                    'Tinggalkan permintaan Anda dan spesialis kami akan terhubung dengan Anda melalui live-chat',
            },
            supportEmail: {
                title: 'Dukungan melalui Email',
                description:
                    'Tinggalkan permintaan Anda dan spesialis kami akan menjawab Anda melalui obrolan',
            },
            knowledgeBase: {
                title: 'Basis Pengetahuan',
                description:
                    'Periksa informasi bermanfaat lainnya dari aplikasi IguVerse untuk mempelajari lebih lanjut tentang privasi kami',
            },
            privacyPolicy: {
                title: 'Kebijakan Privasi',
                description:
                    'Periksa lebih lanjut tentang Kebijakan Privasi kami',
            },
            termsOfUse: {
                title: 'Syarat dan Ketentuan',
                description:
                    'Periksa lebih lanjut tentang Ketentuan Penggunaan kami',
            },
            appVersion: {
                title: 'Versi aplikasi',
                description: 'Terbaru {{version}}',
            },
            webVersion: {
                title: 'Aplikasi Web',
                description: 'Masuk ke Aplikasi Web',
            },
            accessibility: {
                title: 'Aksesibilitas',
                description:
                    'Sesuaikan antarmuka agar sesuai dengan preferensi Anda',
            },
            socialMedia: {
                title: 'Media Sosial Kami',
                description:
                    'Ikuti IguVerse di media sosial untuk terus mengikuti perkembangannya',
            },
            adminSendPushNotification: {
                title: 'Kirim pemberitahuan push',
                description:
                    'Buat notifikasi satu kali yang akan ditampilkan ke semua pengguna',
            },
            adminReverification: {
                title: 'Verifikasi ulang',
                description:
                    'Sebagai admin, Anda dapat mengirim akun sosial untuk verifikasi ulang',
            },
            adminBlockUser: {
                title: 'Blokir Pengguna',
                description: 'Blokir akun yang melanggar aturan IguVerse',
            },
            adminMaintenanceMode: {
                title: 'Modus Pemeliharaan',
                description:
                    'Dalam hal pekerjaan teknis, tempatkan aplikasi dalam mode pemeliharaan',
            },
            adminAssignWhiteList: {
                title: 'Tetapkan Daftar Putih',
                description:
                    'Pilih Nomor dan Peringkat NFT untuk mengirim Daftar Putih ke Pemenang',
            },
        },

        languageSettings: {
            title: 'Bahasa',
            subtitle: 'Pilih Bahasa',
            description:
                'Anda dapat memilih bahasa yang lebih disukai untuk menampilkan konten di aplikasi IguVerse',
            options: {
                pl: {
                    name: 'Polandia',
                    change: 'Polandia',
                },
                en: {
                    name: 'Bahasa Inggris',
                    change: 'Bahasa Inggris',
                },
                ru: {
                    name: 'Rusia',
                    change: 'Rusia',
                },
                uk: {
                    name: 'Ukraina',
                    change: 'Ukraina',
                },
                cn: {
                    name: 'Bahasa Tionghoa',
                    change: 'Bahasa Tionghoa',
                },
                id: {
                    name: 'Bahasa Indonesia',
                    change: 'Bahasa Indonesia',
                },
                es: {
                    name: 'Bahasa Spanyol',
                    change: 'Bahasa Spanyol',
                },
                tr: {
                    name: 'Bahasa Turki',
                    change: 'Bahasa Turki',
                },
            },
            switchLanguageModal: {
                title: 'Beralih ke bahasa {{localeId}}',
                description:
                    'Semua konten di aplikasi IguVerse akan beralih ke {{localeId}}. Anda dapat mengubahnya kapan saja',
            },
        },
        notificationsSettings: {
            title: 'Pemberitahuan',
            pushNotificationTitle: 'Pemberitahuan Push',
            emailNotificationTitle: 'Pemberitahuan Email',
            notifications: {
                pushDailyReminder: 'Dorong Pengingat Harian',
                pushRewardEarned: 'Push Reward yang Diperoleh',
                pushSocialTaskCompleted: 'Tugas Sosial Dorong Selesai',
                pushPetLowHealth: 'Dorong Hewan Peliharaan Kesehatan Rendah',
                pushPetDead: 'Hewan Peliharaan Dorong Sudah Mati',
                pushMysteryLikesGame: 'The Mystery Of Likes',
                emailPetDead: 'Email Hewan Peliharaan Sudah Mati',
                emailSocialTaskCompleted: 'Tugas Sosial Email Selesai',
            },
            saved: 'Pengaturan notifikasi tersimpan!',
        },
        socialAccountsSettings: {
            title: 'Akun Sosial',
            headerTitle: 'Hubungkan Sosial',
            headerText:
                'Ikat akun sosial Anda untuk dapat menyelesaikan tugas sosial. Baca selengkapnya tentang persyaratan akun di basis pengetahuan',
            headerInfo: 'Lihat Basis Pengetahuan',
            alert: 'Setelah menghubungkan akun Anda, Anda harus menyelesaikan tugas sosial agar akun tersebut diverifikasi',
            modal: {
                title: 'Verifikasi Lengkap',
                text: 'Anda telah berhasil menghubungkan akun sosial Anda. Selesaikan tugas sosial untuk akun yang akan diverifikasi!',
                button: 'Menavigasi ke Tugas',
            },
        },
        roles: {
            PLAYER: 'Pemain',
            ADMIN: 'Admin',
            MODERATOR: 'Moderator',
        },
        support: {
            success: {
                title: 'Pesan terkirim!',
                text: 'Kami akan segera menghubungi Anda kembali',
            },
            notSent: { text: 'Pesan tidak terkirim' },
            errorOpen: { text: 'Kesalahan saat membuka aplikasi klien Mail' },
        },
        accessibilitySettings: {
            title: 'Aksesibilitas',
            faceId: 'Identifikasi biometrik / Kode Sandi',
            shake: 'Kirimkan Umpan Balik Anda Mengenai Shaking',
            vibration: 'Respons Getaran',
            saved: 'Pengaturan aksesibilitas tersimpan!',
        },
        socialMediaSettings: {
            screenTitle: 'IguVerse Media',
            communities: {
                title: 'Komunitas Resmi',
                text: 'Bergabunglah dengan komunitas pecinta hewan peliharaan kami yang luar biasa, dapatkan bantuan & bersosialisasi',
                socials: {
                    discord: 'Discord',
                    telegram: 'Telegram',
                },
            },
            media: {
                title: 'Media Resmi',
                text: 'Ikuti saluran media sosial kami untuk menerima berita & pengumuman terbaru',
                socials: {
                    twitter: 'Twitter',
                    instagram: 'Instagram',
                    youtube: 'Youtube',
                    tiktok: 'TikTok',
                    website: 'Situs web',
                    facebook: 'Facebook',
                },
            },
            telegram: {
                title: 'Komunitas Telegram',
                main: 'Obrolan Utama',
                en: 'Obrolan Inggris',
                uk: 'Obrolan Ukraina',
                ru: 'Obrolan Rusia',
                cn: 'Obrolan Tionghoa',
                tr: 'Obrolan Turki',
                id: 'Obrolan Indonesia',
                kr: 'Obrolan Korea',
                jp: 'Obrolan Jepang',
                ab: 'Obrolan Arab',
                in: 'Obrolan India',
                pp: 'Obrolan Filipina',
                vt: 'Obrolan Vietnam',
                bg: 'Obrolan Bangladesh',
                pl: 'Obrolan Polandia',
                es: 'Obrolan Bahasa Spanyol',
                fr: 'Obrolan Bahasa Prancis',
                pt: 'Obrolan Bahasa Portugis',
            },
        },
        adminSendPushNotification: {
            title: 'Kirim pemberitahuan push',
            text: 'Buat notifikasi satu kali yang akan ditampilkan ke semua pengguna',
            button: 'Kirim',
            selectLanguage: {
                label: 'Bahasa',
                placeHolder: 'Pilih bahasa pemberitahuan',
                modalTitle: 'Pilih Bahasa',
                button: 'Simpan',
                title: '{{amount}} Bahasa Terpilih',
            },
            titleInput: {
                label: 'Judul (kurang dari {{amount}} simbol)',
                placeHolder: 'Pembaruan Baru!',
            },
            bodyInput: {
                label: 'Deskripsi (kurang dari {{amount}} simbol)',
                placeHolder:
                    'Jelajahi pembaruan baru kami dengan kotak misteri',
            },
            errors: {
                required: 'Bidang ini wajib diisi',
            },
        },
        adminReverification: {
            screenTitle: 'Verifikasi ulang',
            title: 'Kirim untuk verifikasi',
            text: 'Pilih jejaring sosial dan masukkan nama pengguna untuk mengirim akun untuk verifikasi',
            button: 'Kirim',
            labelSocial: 'Jaringan sosial',
            labelInput: 'Tautan akun',
            placeHolder: 'Masukkan tautan akun',
            socialMediaModal: {
                title: 'Pilih jaringan sosial',
            },
            checkModal: {
                title: 'Periksa Detail Profil',
                text: 'Lihatlah akun sosial di bawah ini dan periksa apakah itu benar. Berhati-hatilah, karena tindakan ini tidak dapat diurungkan',
                button1: 'Kirim untuk verifikasi',
                button2: 'Salah Akun, Batalkan',
            },
            toastSuccess: 'Akun dikirim untuk verifikasi ulang',
        },
        adminBlockUser: {
            screenTitle: 'Blokir Pengguna',
            title: 'Masukkan Alamat Dompet',
            text: 'Masukkan dompet yang terikat ke akun yang melanggar aturan IguVerse',
            button: 'Blokir',
            modal: {
                title: 'Blokir Pengguna?',
                text: 'Pastikan Anda memblokir pengguna yang tepat. Anda harus sangat berhati-hati dengan pengguna yang Anda blokir. Tindakan ini tidak bisa dibatalkan!',
                button1: 'Kirim',
                button2: 'Batal',
            },
            toastSuccess: 'Pengguna berhasil diblokir',
            toastError: 'Tidak dapat menemukan Pengguna',
            banReason: {
                screenTitle: 'Pilih alasan pemblokiran',
                label: 'Alasan pemblokiran',
                placeHolder: 'Pilih alasan pemblokiran',
            },
            banComment: {
                label: 'Komentar',
                placeHolder: 'Tambahkan komentar jika perlu',
            },
            error: {
                banComment: 'Harus menambahkan komentar',
                banReason: 'Pilih alasan pemblokiran',
            },
        },
        adminMaintenanceMode: {
            screenTitle: 'Modus Pemeliharaan',
            on: {
                title: 'Nyalakan Mode Pemeliharaan',
                text: 'Anda dapat menempatkan aplikasi dalam mode pemeliharaan dan pengguna tidak akan dapat mengaksesnya. Untuk menyediakannya bagi pengguna, klik Matikan Mode Pemeliharaan di Pengaturan',
                button: 'Menyalakan',
                modal: {
                    title: 'Nyalakan Mode Pemeliharaan?',
                    text: 'Pengguna tidak akan dapat mengakses aplikasi jika Anda mengaktifkan mode pemeliharaan. Untuk membuat aplikasi tersedia kembali, klik Matikan Mode Perawatan di Pengaturan',
                    button1: 'Menyalakan',
                    button2: 'Batal',
                },
                toastSuccess: 'Mode Pemeliharaan Aktif',
            },
            off: {
                title: 'Matikan Mode Perawatan',
                text: 'Aplikasi sedang dalam mode pemeliharaan dan pengguna tidak dapat mengaksesnya saat itu. Nonaktifkan segera setelah pekerjaan teknis selesai dengan mengklik tombol di bawah ini. Jangan lupa konfirmasi!',
                button: 'Matikan',
                modal: {
                    title: 'Matikan Mode Perawatan?',
                    text: 'Pastikan pekerjaan teknis selesai dan aplikasi akan berfungsi dengan benar. Untuk membuat aplikasi tersedia lagi, klik tombol di bawah ini',
                    button1: 'Matikan',
                    button2: 'Batal',
                },
                toastSuccess: 'Mode Pemeliharaan Mati',
            },
        },
        adminAssignWhiteList: {
            screenTitle: 'Tetapkan Daftar Putih',
            button: 'Tetapkan',
            title: 'Tetapkan Daftar Putih',
            text: 'Masukkan dompet alamat pengguna dan pilih Peringkat dan Kuantitas NFT',
            rank: {
                label: 'Peringkat NFT',
                placeHolder: 'Pilih Peringkat',
            },
            quantity: {
                label: 'Kuantitas',
            },
            modal: {
                screenTitle: 'Pilih Peringkat',
                title: 'Tetapkan Daftar Putih?',
                text: 'Periksa semuanya dengan cermat: Peringkat NFT dan jumlah NFT, serta alamat dompet. Anda harus percaya diri saat mengonfirmasi tindakan ini, karena tidak dapat diurungkan',
                button1: 'Tetapkan',
                button2: 'Batal',
            },
            toastSuccess: 'Daftar Putih berhasil ditetapkan',
            error: {
                quantity: {
                    max: 'Jumlah maksimal {{quantity}}',
                    min: 'Jumlah minimum {{quantity}}',
                    numbers: 'Hanya angka',
                },
                rank: 'Peringkat harus dipilih',
            },
            toastError: 'Tidak dapat menemukan Pengguna',
        },
        adminAssignRole: {
            screenTitle: 'Tetapkan Peran',
            button: 'Tetapkan',
            title: 'Tetapkan Peran',
            text: 'Masukkan dompet alamat pengguna dan peran yang akan ditetapkan',

            role: {
                label: 'Wewenang',
                placeHolder: 'Pilih Peran',
            },
            roleModal: {
                title: 'Pilih Peran',
            },
            attentionModal: {
                title: 'Tetapkan Peran?',
                text: 'Periksa dengan hati-hati semua data yang diberikan: alamat dompet dan peran. Pastikan bahwa Anda tidak membuat kesalahan. Tindakan ini tidak bisa dibatalkan!',
                button1: 'Tetapkan',
                button2: 'Batal',
            },
            error: {
                role: 'Peran harus dipilih',
            },
            success: 'Peran berhasil ditetapkan',
            toastError: 'Tidak dapat menemukan Pengguna',
            toastSuccess: 'Peran berhasil ditetapkan',
        },
        walletInput: {
            label: 'Alamat Dompet',
            placeHolder: 'Masukkan Alamat Dompet',
        },
        walletInputError: 'Is not wallet address',
    },
    admin: {
        title: 'Admin',
        verify: {
            title: 'Verifikasi Pengguna',
            subtitle: 'Verifikasi media sosial pengguna',
            text: 'Buka akun media sosial dan berikan ID Hewan Peliharaan agar verifikasi berhasil',
            emptyTitle: 'Tidak ada lagi tugas',
            emptyText:
                'Tidak ada tugas yang tersedia untuk diverifikasi, kembali lagi nanti',
            messages: {
                error: 'ID Hewan Peliharaan salah, coba lagi',
                success: 'Selamat! Pengguna terverifikasi',
                notFound: 'Pengguna ditolak',
                failed: 'Terjadi kesalahan, harap laporkan ke admin',
            },
            modalPetIdNotFound: {
                title: 'Identitas Hewan Peliharaan tidak ditemukan?',
                text: 'Mohon, periksa Pet ID dengan cermat dan jika Anda tidak dapat memverifikasi, pilih salah satu alasan kegagalan verifikasi berikut ini',
                reasons: {
                    notEnoughFollowers: {
                        title: 'Not Enough Followers',
                        text: 'Your account is not active enough on social media, is not open and/or has few followers',
                    },
                    petIdNotFound: {
                        title: 'Pet ID Not Found',
                        text: 'Pet ID is not visible in the picture or has not been posted',
                    },
                    petIdIncorrectPosition: {
                        title: 'Pet ID Incorrect Position',
                        text: 'Pet ID is cropped or is incorrectly placed, so that it is not possible to see the code',
                    },
                    userNotFound: {
                        title: 'User Could Not Be Found',
                        text: 'The account with the post has been either deleted or linked incorrectly and can not be checked',
                    },
                },
                button1: 'Ya, Konfirmasi',
            },
            label: 'ID Hewan Peliharaan',
            placeHolder: 'Masukkan ID Hewan Peliharaan',
            buttonVerify: 'Verifikasi',
            buttonNotFound: 'ID Hewan Peliharaan tidak ditemukan',
            loadingVerifyUser: 'Memeriksa..',
            regexError: 'Hanya digit dan karakter A-Z yang diperbolehkan',
        },
    },
    socialMediaConnect: {
        addSocialAccount: 'Tambahkan Akun Sosial',
        selectAccountToShare: 'Pilih Akun untuk Berbagi',
        select: 'Pilih',
        connect: 'Terhubung',
        disconnect: 'Putuskan hubungan',
        unavailable: 'Saat ini tidak tersedia',
        status: {
            moderating:
                'Akun Anda telah ditambahkan dan akan diperiksa setelah Anda memposting ID Hewan Peliharaan untuk menyelesaikan tugas sosial!',
            success:
                'Akun tersebut telah berhasil diverifikasi oleh moderator kami. Sekarang Anda dapat menggunakannya untuk menyelesaikan tugas Socialize to Earn',
            reject: 'Akun tersebut belum disetujui oleh moderator kami. Tolong, hubungkan akun yang sesuai dengan aturan kami',
        },
        modalTerms: {
            start: 'Dengan menghubungkan akun sosial, saya setuju untuk ',
            and: ' dan ',
            privacyPolicy: 'Kebijakan Privasi',
            termOfUse: 'Ketentuan Penggunaan',
        },
        connectTiktokModal: {
            title: 'Hubungkan Akun TikTok',
            label: 'Nama belakang',
            placeHolder: 'Masukkan nama pengguna Anda',
            button: 'Terhubung',
            errors: {
                notExist:
                    'Akun ini tidak ada. Silakan masukkan nama pengguna TikTok yang valid',
                somethingWrong: 'Ada yang salah, silakan coba lagi',
                likeFollowers:
                    'Tidak cukup aktivitas di akun Anda. Hanya dapat menghubungkan akun live',
                cannotLoad:
                    'Tidak dapat memuat akun pengguna. Silakan coba lagi',
                alreadyLinked:
                    'Nama pengguna yang diberikan sudah digunakan oleh pengguna lain',
                notLinked: 'Akun sudah tidak terhubung',
            },
        },
        socialPreview: {
            checkProfile: 'Periksa Profil Anda',
            takeALook: `Lihatlah akun media sosial di bawah ini dan periksa apakah akun ini milik Anda`,
            view: 'Lihat',
        },
        connectInstagramModal: {
            title: 'Hubungkan Akun Instagram',
            label: 'Nama belakang',
            placeHolder: 'Masukkan nama pengguna Anda',
            addAccount: 'Ini Saya, Tambah Akun',
            cancel: 'Bukan Saya, Batal',
            button: 'Terhubung',
            errors: {
                somethingWrong: 'Ada yang salah, silakan coba lagi',
                alreadyLinked:
                    'Nama pengguna yang diberikan sudah digunakan oleh pengguna lain',
            },
            viaInstagram: 'atau Masuk melalui Instagram',
        },
        connectTwitterModal: {
            title: 'Hubungkan Akun Twitter',
            label: 'Nama belakang',
            placeHolder: 'Masukkan nama pengguna Anda',
            button: 'Terhubung',
            errors: {
                notExist:
                    'Akun ini tidak ada. Masukkan nama pengguna Twitter yang valid',
                alreadyLinked:
                    'Nama pengguna yang diberikan sudah digunakan oleh pengguna lain',
                somethingWrong: 'Ada yang salah, silakan coba lagi',
            },
        },
        connectFacebookModal: {
            title: 'Hubungkan Akun Facebook',
            label: 'Nama belakang',
            placeHolder: 'Masukkan nama pengguna Anda',
            button: 'Terhubung',
            errors: {
                notExist:
                    'Akun ini tidak ada. Masukkan nama pengguna Facebook yang valid',
                alreadyLinked:
                    'Nama pengguna yang diberikan sudah digunakan oleh pengguna lain',
                somethingWrong: 'Ada yang salah, silakan coba lagi',
            },
            via: 'atau Masuk melalui Facebook',
        },
        terms: {
            instagram: {
                one: 'Profil publik',
                two: 'Akun aktif dengan setidaknya 100 pengikut',
                three: 'Setidaknya 5 postingan yang lebih tua dari 3 bulan',
            },
            tikTok: {
                one: 'Setidaknya 500 pengikut',
                two: 'Akun aktif dengan setidaknya 5 video yang lebih tua dari 3 bulan',
                three: 'Setidaknya 500 suka di akun',
            },
            twitter: {
                one: 'Profil publik',
                two: 'Akun aktif dengan setidaknya 500 pengikut',
                three: 'Setidaknya 5 postingan yang lebih tua dari 3 bulan',
            },
            facebook: {
                one: 'Profil publik',
                two: 'Akun aktif dengan setidaknya 100 pengikut',
                three: 'Setidaknya 5 postingan yang lebih tua dari 3 bulan',
                four: 'Cerita harus bersifat publik',
            },
        },
        errors: {
            duplicate: {
                title: '{{social}} Anda sudah terhubung ke akun lain',
                text: 'Profil media sosial Anda terhubung ke akun lain. Putuskan koneksi terlebih dahulu dan coba lagi',
                button: 'Tutup',
            },
            disconnect: {
                title: 'Putuskan Akun?',
                text: 'Anda akan dapat menggunakan akun baru Anda untuk menyelesaikan tugas sosial, setelah hari permainan baru dimulai',
                button1: 'Ya, Putuskan sambungan',
                button2: 'Tidak, Simpanlah',
            },
            userNameError:
                'Simbol terlarang. Hanya karakter latin, digit, titik dan garis bawah yang diperbolehkan',
        },
        success: {
            linkInstagram: 'Instagram berhasil terhubung',
            unLinkInstagram: 'Instagram terputus',
            linkTiktok: 'TikTok berhasil terhubung',
            unLinkTiktok: 'TikTok terputus',
            linkTwitter: 'Twitter berhasil terhubung',
            unLinkTwitter: 'Twitter terputus',
            linkFacebook: 'Facebook berhasil terhubung',
            unLinkFacebook: 'Facebook terputus',
        },
    },
    playTasksHistory: {
        title: 'Riwayat Tugas',
        info: 'Di sini Anda bisa melihat riwayat tugas dan kemajuan Anda',
        historyCard: {
            SocialTask: 'Tugas Sosial',
            VerificationTask: 'Temukan Tugas',
            MoveTask: 'Tugas Berjalan',
            PlayTask: 'Tugas Bermain',
        },
        emptyState: {
            title: 'Belum ada tugas',
            text: 'Anda belum menyelesaikan tugas harian apa pun. Tapi itu bukan masalah, mari kita lakukan sekarang juga',
            button: 'Mulai Bermain',
        },
        historyTaskDetails: {
            title: 'Rincian Tugas',
            text: 'Energi yang terkumpul akan dikonversi menjadi hadiah token di dompet Reward Anda. Lihat detail lebih lanjut tentang tugas-tugas di bawah ini',
            collectedEnergy:
                '{{earnedEnergy}} / {{maxEnergy}} Energi yang Terkumpul',
            viewRewardWaller: 'Lihat di Dompet Hadiah',
            details: {
                type: 'Jenis:',
                type_SocialTask: 'Tugas Sosial',
                type_VerificationTask: 'Temukan Tugas',
                type_MoveTask: 'Tugas Berjalan',
                type_PlayTask: 'Tugas Bermain',
                petExp: 'Pengalaman Hewan Peliharaan:',
                exp: '{{exp}} XP',
                date: 'Tanggal:',
            },
        },
    },
    successTaskEnergyBlock: {
        text: 'Energi',
        collectedEnergy:
            '{{earnedEnergy}} / {{maxEnergy}} Energi yang Terkumpul',
    },
    successTaskPetsExp: {
        text: 'XP yang Dikumpulkan',
        collectedExp: '{{collectedExp}} XP',
    },
    checkout: {
        title: 'Verifikasi Transaksi',
        text: 'Periksa kembali informasi dan konfirmasi transaksi Anda',
        confirm: 'Konfirmasi dan Pembelian',
        try: 'Coba Lagi',
        cancel: 'Batal',
        purchasingFrom: 'Cara Pembayaran',
        available: 'Saldo',
        deposit: 'Deposit',
        wallet: '{{coin}} Dompet',
        loadingPurchasing:
            'Menyelesaikan transaksi, tolong jangan tutup aplikasinya ..',
        free: 'Gratis',
        whiteList: 'Daftar putih (1)',
        explorerUrl: 'Lihat di BscScan',
        fields: {
            transaction: 'Transaksi',
            value: 'Nilai',
            amount: 'Jumlah',
            totalSummary: 'Ringkasan Total',
            from: 'Dari (Dompet)',
            to: 'Untuk Alamat',
            fee: 'Biaya Blockchain',
            modalTitle: 'Konfirmasi Klaim',
            toWallet: 'Ke (Dompet)',
            gamingWallet: 'Dompet Game',
            mainWallet: 'Dompet Utama',
            confirm: 'Konfirmasi',
            commissionFee: 'Biaya Komisi',
            nft: 'NFT',
            nftWallet: 'Dompet NFT',
            nftMarketplace: 'Pasar NFT',
        },
        errors: {
            notEnoughCoinFunds: 'Dana tidak cukup. Setor dana ke dompet Anda',
            notEnoughCoinFundsMulti:
                'Dana tidak cukup. Pilih opsi pembayaran lain atau setor dana ke dompet Anda',
            bnbNotEnough:
                'Tidak cukup BNB di saldo Anda untuk menutupi biaya gas. Harap setorkan BNB ke dompet Anda',
            notEnoughBalanceFunds: 'Dana tidak cukup',
            notEnoughBalanceFundsMulti:
                'Dana tidak cukup. Pilih opsi pembayaran lain',
            insufficientVirtualBalance:
                'Dana tidak mencukupi pada saldo virtual Anda',
        },
        purchasingFromCoins: {
            coins: 'Token',
            virtual: 'E-Wallet',
            inapp: { ios: 'Apple', android: 'Google Pay' },
        },
        storePurchase: {
            loadings: {
                PURCHASE: 'Menyelesaikan pembayaran, jangan tutup aplikasi ..',
                FINALIZE:
                    'Menyelesaikan transaksi, tolong jangan tutup aplikasinya ..',
            },
            button: 'Oke',
            storePurchaseError: {
                PURCHASE: {
                    title: 'Ada yang tidak beres',
                    message:
                        'Terjadi kesalahan selama proses pembelian. Silakan coba lagi\n' +
                        'Kode Kesalahan: {{code}}',
                },
                FINALIZE: {
                    title: 'Ada yang tidak beres',
                    message:
                        'Terjadi kesalahan saat menyelesaikan transaksi. Silakan coba lagi',
                },
            },
        },
    },
    charity: {
        title: 'Amal',
        description:
            'Pengguna IguVerse membayar donasi dari pendapatan harian mereka ke salah satu organisasi amal yang telah dipilih sebelumnya',
        current: 'Pilihan Saya',
        dailyDonation: 'Donasi Harian dari Hadiah Anda',
        howItWorks: 'Bagaimana cara kerjanya?',
        selectedOrganization: 'Organisasi Terpilih',
        edit: 'Edit',
        organizations: 'Organisasi',
        viewAll: 'Lihat Semua',
        donated: 'Disumbangkan',
        buttonSave: 'Simpan',
        loadingPercentage: 'Memproses..',
        saveSuccess: 'Persentase sumbangan harian diubah',
        organizationsTitle: 'Semua Organisasi',
        infoRows: {
            address: 'Alamat',
            website: 'Situs web',
            email: 'Email',
            instagram: 'Instagram',
            twitter: 'Twitter',
        },
        readMore: 'Baca lebih lanjut',
        hide: 'Sembunyikan',
        donations: 'Donasi',
        totalSummary: 'Ringkasan Total',
        time: {
            minuteAgo: 'menit yang lalu',
            minutesAgo: 'menit yang lalu',
            hourAgo: 'jam yang lalu',
            hoursAgo: 'jam yang lalu',
            dayAgo: 'hari yang lalu',
            daysAgo: 'hari yang lalu',
        },
        payout: 'Pembayaran Amal',
        noDonations: 'Belum ada sumbangan',
        allDonations: 'Semua Donasi',
        modals: {
            confirmPercentage: {
                title: 'Konfirmasikan Tindakan Anda',
                text: 'Persentase donasi akan mempengaruhi penghasilan Anda dan mentransfernya langsung ke organisasi amal, apakah Anda yakin ingin mengubah tingkat donasi Anda?',
            },
        },
        editOrganization: 'Edit Organisasi',
        editOrganizationNotChosen:
            'Anda harus memilih minimal satu organisasi untuk disumbangkan',
        loadingOrganizationChange: 'Memproses..',
        changeOrganizationSuccess: 'Organisasi amal yang diselamatkan',
        organizationDetails: 'Rincian Organisasi',
        selectDescription: 'Pilih organisasi dari daftar di bawah ini',
        chooseOrganization: 'Pilih Organisasi',
    },
    Marketplace: {
        title: 'Pasar',
        text: 'Anda bisa membeli atau menjual hewan peliharaan ke pengguna lain di pasar',
        description: 'Segera hadir',
    },
    Feed: {
        title: 'Umpan Sosial',
        text: 'Anda dapat melihat semua hewan peliharaan yang tersedia dan berinteraksi dengan mereka',
        description: 'Segera hadir',
    },
    Leaderboard: {
        [ROUTES.LEADERBOARD_DAILY_TASKS]: {
            title: 'Pemimpin Tugas',
            text: 'Ikuti kemajuan pengguna lain dan bersainglah dengan mereka dalam melakukan tugas sehari-hari',
            emptyList: {
                title: 'Belum ada Pengguna di Pemimpin Tugas',
                text: 'Sedih untuk mengatakannya, tetapi belum ada pengguna yang menyelesaikan tugas apa pun. Tapi jangan khawatir itu akan diperbaiki dengan cepat',
            },
            energy: 'Energi yang Terkumpul',
            task: 'Tugas yang Diselesaikan',
        },
        [ROUTES.LEADERBOARD_PVP_GAMES]: {
            title: 'Pemimpin PvP',
            text: 'Ikuti kemajuan pengguna lain dan bersainglah dengan memainkan dan memenangkan game PvP',
            emptyList: {
                title: 'Belum ada Pengguna di Pemimpin PvP',
                text: 'Sedih untuk mengatakannya, tetapi belum ada pengguna yang menyelesaikan permainan apa pun. Tapi jangan khawatir itu akan diperbaiki dengan cepat',
            },
            turnover: 'Omzet IGU',
            totalTurnover: 'Total Omzet IGU',
            pnl: 'PNL (menang/kalah)',
            games: 'Game PvP Dimainkan',
        },
        emptyScreen: {
            title: 'Ups!',
            text: 'Ada yang salah. Tapi jangan khawatir itu akan diperbaiki dengan cepat. Coba tarik.',
        },
    },

    playCollectedExperience: {
        screenTitle: 'Pengalaman yang Dikumpulkan',
        title: 'Pengalaman Hewan Peliharaan',
        text: 'Setelah menyelesaikan tugas, hewan peliharaan Anda mengumpulkan XP baru untuk meningkatkan level',
    },
    playSuccessScreen: {
        button: 'Lihat Tugas Lainnya',
        button2: 'Kembali ke Utama',
        emptyStates: {
            VERIFY: {
                title: 'Temukan Tugas Selesai',
                text: 'Selamat! Anda telah menyelesaikan tugas Find untuk hari ini. Kembalilah besok untuk lebih banyak lagi',
                failTitle: 'Temukan Tugas Gagal',
                failText:
                    'Anda gagal menemukan tugas untuk hari ini. Kembalilah besok untuk lebih banyak lagi',
            },
            MOVE: {
                title: 'Tugas Berjalan Selesai',
                text: 'Selamat! Anda berjalan jauh untuk menyelesaikan tugas. Kembalilah besok untuk lebih banyak lagi',
                failTitle: 'Tugas Berjalan Gagal',
                failText:
                    'Anda gagal dalam tugas berjalan untuk hari ini. Kembalilah besok dan cobalah lebih baik',
            },
            SOCIAL: {
                title: 'Tugas Berbagi Selesai',
                text: 'Selamat! Anda berbagi foto dan lolos verifikasi. Kembalilah besok untuk lebih banyak lagi',
            },
            PLAY: {
                title: 'Permainan Selesai',
                text: 'Selamat! Anda telah menyelesaikan permainan untuk hari ini. Kembalilah untuk besok',
                failTitle: 'Permainan Gagal',
                failText:
                    'Sayangnya Anda gagal dalam permainan. Cobalah lebih baik lain kali',
            },
        },
    },
    general: {
        howItWorks: 'Bagaimana cara kerjanya',
        comingSoon: 'Segera hadir',
        comingSoonDesc: 'Fitur ini belum siap.',
        copiedToClipboard: 'Disalin ke Clipboard',
        createPet: 'Buat Hewan Peliharaan',
        next: 'Berikutnya',
        or: 'atau',
        ok: 'OK',
        loading: 'Memuat..',
        loadMore: 'Muat Lebih Banyak',
        errors: {
            unknown: {
                title: 'Kesalahan yang tidak diketahui',
                message: 'Silakan coba lagi',
            },
            error: { title: 'Kesalahan' },
            networkRequestFailed: {
                title: 'Kesalahan jaringan',
                message: 'Permintaan jaringan gagal. Coba lagi',
            },
            TASK_WRONG_STATE: {
                title: 'Kesalahan',
                message: 'Tugas sudah kedaluwarsa, silakan coba lagi',
            },
            TASK_CREATE_FORBIDDEN: {
                title: 'Kesalahan',
                message: 'Tugas sudah kedaluwarsa, silakan coba lagi',
            },
            UNPREDICTABLE_GAS_LIMIT: {
                title: 'Masalah Dompet',
                message:
                    'Tidak dapat memperkirakan biaya gas, transaksi tidak akan berhasil. Pastikan Anda memiliki cukup dana dan BNB untuk menutupi biaya gas dan kemudian coba lagi',
            },
            INSUFFICIENT_FUNDS: {
                title: 'Dana Tidak Cukup',
                message:
                    'Pastikan Anda memiliki cukup dana dan BNB untuk menutupi biaya transaksi. Setor kripto ke dompet Anda dan coba lagi',
            },
            fileIsTooBig: {
                title: 'File terlalu besar',
                text: 'File gambar harus kurang dari {{size}} MB',
            },
            cantOpenUrl: {
                text: 'Perangkat Anda tidak dapat membuka URL {{url}}. Salin URL dan ikuti secara manual',
            },
            gameAlreadyStarted: {
                text1: 'Permainan sudah dimula',
                text2: 'Silakan, pilih permainan lain',
            },
            gameBanned: {
                text1: 'Anda dilarang memainkan game ini',
                text2: 'Tunggu sampai pemberitahuan lebih lanjut',
            },
            wrongGameStatus: {
                text: 'Status permainan salah',
            },
            emptyErrorScreen: {
                title: 'Ups!',
                text: 'Ada yang salah. Tapi jangan khawatir itu akan diperbaiki dengan cepat',
            },
            ops: {
                text1: 'Ups!',
                text2: 'Ada yang tidak beres :(',
            },
        },
        success: { title: 'Sukses' },
        socialLoading: 'Menghubungkan ..',
        cancel: 'Batal',
        back: 'Kembali',
        current: 'Saat ini',
        knowledgeBaseButton: 'Pelajari lebih lanjut di basis pengetahuan',
        timerTitle: 'Sisa Waktu',
        hint: '{{hint}}/{{maxHints}} Petunjuk',
        continue: 'Lanjutkan',
        skip: 'Lewati',
        BUTTONS: {
            mintNewNft: 'Mint NFT Baru',
            continue: 'Lanjutkan',
            continueLater: 'Lanjutkan nanti',
            mintNft: 'Sebagai NFT',
            select: 'Pilih',
            startPlaying: 'Mulai Bermain',
            start: 'Mulai',
            learnMore: 'Pelajari Lebih Lanjut',
            playPvpGames: 'Mainkan Game PVP',
            goToWallet: 'Pergi ke Dompet',
            createNewOrder: 'Buat Pesanan Baru',
            apply: 'Terapkan',
            clear: 'Hapus',
            viewProfile: 'Lihat Profil',
            buyForWithAmount: 'Beli dengan {{amount}}',
            cancel: 'Batalkan',
            delistNft: 'Hapus NFT',
            delist: 'Hapus',
            viewMarketplace: 'Lihat Pasar',
            getStarted: 'Memulai',
            reloadApp: 'Muat Ulang Aplikasi',
            createNewGame: 'Buat Game Baru',
            exploreMoreGames: 'Jelajahi Lebih Banyak Game',
            viewGamesHistory: 'Lihat Riwayat Permainan',
            viewStatistics: 'Lihat Statistik',
            tryAgain: 'Coba Lagi',
            createGame: 'Membuat permainan',
            topUpBalance: 'Saldo isi ulang',
            continueToNextStep: 'Lanjutkan ke Langkah Berikutnya',
            continueShopping: 'Lanjutkan Belanja',
            enableNow: 'Aktifkan Sekarang',
            maybeLater: 'Mungkin Nanti',
            backToSettings: 'Kembali ke pengaturan',
            turnOff: 'Matikan',
            purchaseFor: 'Pembelian untuk {{amount}}',
            purchase: 'Pembelian',
            viewAll: 'Lihat Semua',
            view: 'Lihat',
            purchaseMore: 'Beli Lebih Banyak',
            viewDetails: 'Lihat Detail',
            readMore: 'Baca Lebih Lanjut',
            hide: 'Sembunyikan',
            viewChart: 'Lihat Bagan',
        },
        KEYS: {
            ranks: 'Peringkat',
            price: 'Harga',
            chance: 'Kesempatan',
            rank: 'Peringkat',
            sortedBy: 'Diurutkan Berdasarkan',
            typeOfNft: 'Jenis NFT',
            totalSummary: 'Ringkasan Total',
            totalSuccessfulOrders: 'Total Pesanan yang Berhasil',
            totalPurchasesSummary: 'Ringkasan Total Pembelian',
            NFT: 'NFT',
            profile: 'Profil',
            details: 'Detail',
            numberAndLevel: '{{level}} Level',
            numberAndHealth: '{{health}} Kesehatan',
            deadByAge: 'Hewan Peliharaan Sudah Tua Dan Mati',
            numberAndDaysAge: '{{days}} Usia Hari',
            yourNFT: 'NFT Anda',
            vs: 'VS',
            opponentsNFT: 'NFT Lawan',
            yourPoints: 'Poin Anda',
            opponentsPoints: 'Poin Lawan',
            type: 'Ketik',
            gameSettings: 'Pengaturan permainan',
            difficulty: 'Kesulitan',
            mode: 'Mode',
            livesCount: 'Hitungan Hidup',
            yourAccount: 'Akun Anda',
            leaderboardPlace: 'Tempat Papan Peringkat',
            timeLeft: 'Waktu tersisa',
            ticketsAmount: 'Jumlah Tiket',
            tickets: 'Tiket',
            winner: 'Pemenang',
            prizes: 'Hadiah',
            won: 'Menang',
            hash: 'Hash',
            date: 'Tanggal',
            roundId: 'ID Bulat',
            chainResults: 'Hasil',
            globalSeed: 'Benih Global',
            gamesHistory: 'Riwayat Permainan',
            users: 'Pengguna',
        },
        FILTERS: {
            byDate: {
                Day: 'Hari ini',
                Week: '7 hari terakhir',
                Month: '30 hari terakhir',
            },
        },
        ALERTS: {
            notEnoughCoinsOnGamingWallet:
                'Tidak cukup token di dompet game Anda untuk bergabung dalam permainan. Isi ulang akun Anda untuk mulai bermain',
        },
        MERGED: {
            selectText: 'Pilih {{text}}',
        },
        DECLINATION: {
            Ticket: {
                one: 'Tiket',
                two: 'Tiket',
                five: 'Tiket',
            },
        },
    },
    modal: {
        mintPetLeave: {
            title: 'Apakah Anda ingin pergi?',
            text: 'Anda hampir selesai membuat hewan peliharaan Anda. Jangan menyerah sekarang!',
            keep: 'Selesaikan Hewan Peliharaan Anda',
            leave: 'Ya, Tinggalkan',
        },
        ModalFreeRank: {
            title: 'Anda Kehilangan Bonus Besar!',
            text: 'Apakah Anda yakin ingin melewatkan {{amount}} IGUP (${{dollarValue}}) bonus untuk mencetak peringkat tertinggi?',
            highest: 'Dapatkan Bonus Saya',
            proceed: 'Lanjutkan Tanpa Bonus',
        },
        askForPermissions: 'Meminta Izin',
        goToSettings: 'Pergi ke pengaturan',
        try: 'Coba Lagi',
        cancel: 'Batal',
        deletePhoto: 'Hapus Foto NFT?',
        deletePhotoInfo: 'Apakah Anda yakin ingin menghapus foto Anda?',
        yesDelete: 'Ya, Hapus',
        noCancel: 'Tidak, Batalkan',
        changeRank: 'Apakah Anda Ingin Mengubah Peringkat?',
        changeRankInfo: 'Anda akan diarahkan ke langkah pertama proses mint',
        changeRankGo: 'Ubah Peringkat',
        upgradeRank: {
            title: 'Tingkatkan ke Peringkat "{{slug}}"',
            text: 'Beberapa fitur tidak terkunci dengan Peringkat yang lebih tinggi. Tingkatkan Peringkat Anda untuk mengakses fitur ini',
            upgradeToRank: 'Naikkan ke Pangkat',
        },
        savingName:
            'Menyimpan nama, butuh beberapa waktu. Tolong jangan tutup aplikasi',
        generatingNFT:
            'Melakukan beberapa keajaiban. Biasanya dibutuhkan waktu hingga beberapa menit ..',
        generateNewNFT: {
            title: 'Kembali ke Langkah Sebelumnya?',
            text: 'Anda akan dikembalikan dan kehilangan kemajuan Anda saat ini. Hewan peliharaan Anda unik, kami tidak akan dapat membuat hewan peliharaan yang sama persis',
            yesGenerate: 'Ya, Bawa Aku Kembali',
            noKeep: 'Tidak, Tetaplah di sini',
        },
        askForCameraPermissions: {
            title: 'Tidak Ada Izin Untuk Kamera',
            text: 'Anda harus memberikan izin untuk kamera agar dapat menggunakan fitur ini',
        },
        askForLocationPermissions: {
            title: 'Tidak Ada Izin Untuk Lokasi',
            text: 'Anda harus memberikan izin lokasi untuk dapat menggunakan fitur ini',
        },
        askForCameraRollPermissions: {
            title: 'Tidak Ada Izin Untuk Camera Roll',
            text: 'Anda harus memberikan izin untuk Camera Roll agar dapat menggunakan fitur ini',
        },
        askForLocationPermissionsWeb: {
            title: 'Tidak Ada Izin Untuk Lokasi',
            text: 'Anda harus memberikan izin lokasi untuk dapat menggunakan fitur ini',
            additionalText: '. Buka pengaturan dan aktifkan izin untuk lokasi',
            button: 'Tutup',
        },
        nftPreview: {
            title: 'Pratinjau NFT',
            text: 'Ini adalah pratinjau hewan peliharaan Anda',
        },
        confirmation: {
            title: 'Apakah Anda yakin?',
            text: 'Harap konfirmasikan tindakan Anda untuk melanjutkan',
            yes: 'Ya, Konfirmasi',
            cancel: 'Batal',
        },
        modalChangeLanguage: {
            screenTitle: 'Ubah Bahasa',
            button: 'Ubah',
        },
    },
    navigationBar: {
        wallet: {
            MAIN: 'Utama',
            NFT: 'NFT',
            REWARDS: 'Hadiah',
            GAMING: 'Permainan',
        },
        tasks: { active: 'Aktif', history: 'Sejarah' },
        admin: { verify: 'Verifikasi', dashboard: 'Dasbor' },
        referrals: { invites: 'Mengundang', all: 'Referensi Saya' },
        collections: { collection: 'Koleksi', mystery: 'Kotak Misteri' },
        tooltip:
            'Ini adalah tab dompet. Buka di sini untuk melihat saldo dan hadiah Anda. Di tab, Anda dapat menarik, menyetor, mengklaim, dan menukar token',
    },
    AppState: {
        GameMaintenanceState: {
            title: 'Pemeliharaan Permainan',
            text: 'Tugas IguVerse sedang dalam pemeliharaan dan saat ini tidak tersedia. Maaf atas ketidaknyamanan ini dan segera kembali lagi',
            button: 'Dapat',
        },
        FullMaintenanceState: {
            title: 'Aplikasi Sedang Dalam Pemeliharaan',
            text: 'Aplikasi IguVerse sedang dalam pemeliharaan dan saat ini tidak tersedia. Mohon maaf atas ketidaknyamanan ini dan segera kembali. Tetap terhubung di media sosial kami',
        },
        GlobalErrorState: {
            title: 'Pemeliharaan Tidak Terjadwal',
            text: 'Aplikasi IguVerse sedang dalam pengembangan dan saat ini kami memiliki pemeliharaan yang tidak direncanakan. Maaf atas ketidaknyamanan ini dan segera kembali lagi',
            button: 'Coba lagi',
        },
        UpdateRequiredState: {
            title: 'Pembaruan Tersedia',
            text: 'Versi aplikasi ini sudah usang, harap perbarui aplikasi dari {{store}} Store untuk terus menggunakannya',
            button: 'Pembaruan',
            cancel: 'Tidak Sekarang',
            error: 'Tidak dapat membuka tautan, buka {{store}} Store secara manual dan unduh versi terbaru',
        },
        UpdateRequiredStateWeb: {
            title: 'Memperbarui Aplikasi ..',
            text: 'Aplikasi saat ini sedang dalam pembaruan, silakan coba lagi dalam beberapa menit',
            button: 'Coba lagi',
        },
        NoNetworkConnectionState: {
            title: 'Tidak ada koneksi',
            text: 'Sepertinya Anda memiliki masalah dengan koneksi internet. Internet diperlukan agar aplikasi dapat bekerja dengan baik',
            button: 'Dapat',
            reconnected: 'Terhubung kembali!',
            reconnecting: 'Koneksi terputus. Menyambung kembali..',
        },
    },
    ranks: {
        rankLongTitle: '{{rank}} Pangkat',
        level: '{{level}} LVL',
        upgradeRankButton: 'Tingkatkan Peringkat',
        upgradeText:
            'Anda telah mencapai semua Level di Peringkat Anda saat ini. Saatnya untuk meningkatkan ke {{rank}} Rank dan meningkatkan performa Anda',
        lockedText:
            '{{rank}} Rank tidak tersedia untuk mint. Anda dapat mencapainya dengan naik level dan maju melalui permainan',
        perDay: 'Setiap hari',
        dailyUnlock: 'Buka Kunci Harian',
        foodConsumption: 'Konsumsi Harian',
        maxAge: 'Max. Usia',
        days: 'Hari',
        list: {
            free: {
                title: 'Gratis',
                infoText:
                    'Peringkat Gratis akan memberi Anda kesempatan untuk menjelajahi aplikasi dan fungsinya. Namun, Anda tidak dapat mengklaim atau menarik hadiah sebelum membeli atau menaikkan peringkat NFT Anda',
            },
            starter: { title: 'Starter' },
            common: { title: 'Common' },
            uncommon: { title: 'Uncommon' },
            unusual: { title: 'Unusual' },
            rare: { title: 'Rare' },
            mystical: { title: 'Mystical' },
            legendary: { title: 'Legendary' },
            epic: { title: 'Epic' },
            exotic: { title: 'Exotic' },
            royal: { title: 'Royal' },
            diamond: { title: 'Diamond' },
        },
        ranksDetailedInfoScreen: { button: 'Sebagai NFT', current: 'Saat ini' },
        rankDetailedInfo: {
            reward: {
                title: 'Hadiah Harian ≈ {{reward}} ≈ {{usd}}',
                text: 'Perkiraan hadiah harian dalam token jika semua tugas harian diselesaikan',
                warning:
                    'Nilai tersebut hanya merupakan estimasi dari kapasitas penghasilan hewan peliharaan dan dapat bervariasi',
                warningFree:
                    'Peringkat gratis memiliki peluang acak untuk mendapatkan hadiah dalam permainan. Tidak ada hadiah yang dijamin untuk peringkat Gratis',
            },
            rate: {
                title: 'Tarif Buka Kunci Harian ≈ {{reward}} ({{rate}}) ≈ {{usd}}',
                text: 'Anda dapat mentransfer {{percent}}% dari hadiah VIGUP yang tersedia ke dompet utama Anda. Setelah diklaim, token dapat ditukar, dikirim ke dompet lain, atau ditarik',
                alert: 'Token VIGUP lainnya sedang menunggu keputusan dan akan disimpan di Dompet Terkunci',
            },
            consumption: {
                title: 'Konsumsi Makanan = {{consumption}}',
                text: 'Hewan peliharaan Anda mengkonsumsi token setiap hari. Jika hewan peliharaan tidak diberi makan tepat waktu, ia akan kehilangan kesehatan dan bisa mati',
            },
            age: {
                title: 'Usia Maks = {{maxAge}} hari',
                text: 'Setelah NFT Anda mencapai usia ini, NFT akan mati dan perlu dipulihkan',
                alert: 'Naik Peringkat akan mengatur ulang usia NFT Anda kembali ke 0, dan hewan peliharaan virtual yang ditingkatkan akan hidup sesuai dengan batas usia Peringkat baru. Setelah menghidupkan kembali NFT, Anda akan memulai Level 1',
            },
        },
        modalWhatIsRank: {
            title: 'Apa itu Peringkat?',
            text: 'Peringkat memengaruhi kapasitas penghasilan hewan peliharaan Anda dan karakteristik penting lainnya seperti Tingkat Buka Kunci Harian dan Tingkat Konsumsi Hewan Peliharaan. Semakin tinggi peringkat, semakin baik karakteristiknya',
            buttonAvailable: 'Lihat Peringkat yang Tersedia',
            buttonAll: 'Lihat Semua Peringkat',
        },
        checkoutUpgradeRank: {
            title: 'Tingkatkan Peringkat',
            text: 'Semakin tinggi peringkatnya, semakin banyak hadiah yang akan diperoleh hewan peliharaan Anda',
            upgradeTo: 'Tingkatkan ke',
            transaction:
                'Tingkatkan Peringkat ke {{rank}} Peringkat untuk "{{name}}" NFT',
        },
        successUpgradeRank: {
            title: 'Peringkat Ditingkatkan!',
            text: 'Peringkat NFT berhasil ditingkatkan. Mainkan tugas harian dan dapatkan lebih banyak hadiah',
            backToPet: 'Lihat hewan peliharaan',
        },
    },
    localNotifications: {
        moveToEarnFinished: {
            title: 'Tugas berjalan selesai',
            message:
                'Buka aplikasi dan lihat berapa banyak Energi yang Anda kumpulkan',
        },
        noPets: {
            title: 'Bergegaslah untuk mendapatkan hewan peliharaan Anda',
            message:
                'Dapatkan hewan peliharaan pertama Anda dan mulailah perjalanan menakjubkan Anda di IguVerse',
        },
    },
    monthPicker: {
        month1: 'Januari',
        month2: 'Februari',
        month3: 'Maret',
        month4: 'April',
        month5: 'Mei',
        month6: 'Juni',
        month7: 'Juli',
        month8: 'Agustus',
        month9: 'September',
        month10: 'Oktober',
        month11: 'November',
        month12: 'Desember',
        selectMonth: 'Pilih',
    },
    staking: {
        stakeLoading: 'Mengaktifkan dorongan, jangan tutup aplikasi...',
        unStakeLoading: 'Menghapus dorongan, jangan tutup aplikasi...',
        general: {
            dailyBoost: 'Peningkatan Harian',
            ended: 'Berakhir',
            summary: 'Total',
            days: '{{days}} Hari',
            current: 'Dorongan Saat Ini',
        },
        plans: {
            title: 'Rincian Opsi',
            text: 'Setiap paket dorongan menentukan periode opsi dan bonus',
            days: ' Hari',
            boost: 'Meningkatkan hingga {{boost}}%',
        },
        welcomeScreen: {
            title: 'Dorongan',
            headerTitleStart: 'Hasilkan ',
            headerTitleCenter: 'Hingga {{number}}%',
            headerTitleEnd: ' dengan Dorongan',
            headerText:
                'Anda dapat mendorong hadiah dalam game Anda dengan mengunci token Anda untuk periode waktu tertentu',
            stake: {
                title: 'Opsi Dorongan',
                text: 'Berinvestasi token IGU dan IGUP Anda untuk mendapatkan peningkatan hadiah atau bunga',
            },
            lock: {
                title: 'Periode Kunci',
                text: 'Token Anda akan dikunci selama periode waktu yang ditentukan dalam opsi',
            },
            calculation: {
                title: 'Perhitungan Boost',
                text: 'Dorongan dihitung ulang setiap hari tergantung pada hadiah harian Anda',
                alert: 'Jika hadiah Anda berubah, boost juga akan berubah. Anda akan selalu dapat melihat boost saat ini',
            },
            button: 'Aktifkan Dorongan',
        },
        optionsScreen: {
            toastAlready: 'Opsi dorongan sudah aktif',
            button: 'Lanjutkan',
            screenTitle: 'Opsi Dorongan',
            title: 'Pilih Dorongan Opsi',
            text: 'Pilih opsi dorongan untuk token Anda. Anda dapat menggunakan beberapa opsi dorongan secara bersamaan',
            IGUP: {
                title: 'Dorong dengan IGUP',
                text: 'Kunci IGUP Anda untuk jangka waktu tertentu dan dapatkan peningkatan hadiah harian Anda!',
            },
        },
        plansScreen: {
            button: 'Lanjutkan',
            selectPlan: 'Pilih Opsi',
            title: 'Pilih Opsi Dorongan',
            headerTitle: 'Pilih Opsi',
            headerText:
                'Jumlah yang Anda pilih akan dikunci dalam smart contract hingga akhir periode. Hanya satu paket yang dapat dipertaruhkan pada saat yang sama',
            headerInfoText: 'Rencana Mana yang Harus Dipilih?',
            lock: {
                title: 'Periode Penguncian = {{days}} Hari',
                description:
                    'Periode penguncian adalah periode waktu ketika token Anda akan dikunci dan bonus akan aktif',
            },
            boost: {
                title: 'Peningkatan Penghargaan = ~{{boost}} %',
                description:
                    'Peningkatan Penghargaan adalah pengubah yang meningkatkan hadiah dalam game Anda dengan persentase tertentu',
            },
            calculation: {
                title: 'Peningkatan Harian = ~{{boost}} %',
                description:
                    'Dorongan dihitung ulang setiap hari berdasarkan hadiah Anda',
                alert: 'Jika hadiah Anda telah berubah, boost juga akan berubah. Anda akan selalu dapat melihat boost saat ini',
            },
        },
        coinsInputScreen: {
            title: 'Pilih Jumlah Token',
            button: 'Hitung Peningkatan Harian',
            button2: 'Lewati Langkah',
            loading: 'Menghitung dorongan harian..',
            available: 'Tersedia ',
            maxButton: 'Max',
            errors: {
                digits: 'Harus hanya berupa angka',
                max: 'Tidak cukup token di saldo. Silakan masukkan jumlah atau deposit lain',
                min: 'Jumlahnya harus minimal {{limit}} {{coin}}',
                maxStack: 'Jumlahnya harus maksimal {{limit}} {{coin}}',
            },
            maxBoost:
                'Berinvestasi {{amount}} {{coin}} untuk Mendapatkan Peningkatan {{boost}}%',
            maxBoostModal: {
                title: 'Maksimalkan peningkatan Anda',
                text: 'Kunci jumlah yang disarankan dan terima dorongan maksimal yang mungkin dalam opsi ini!',
                button: 'Tambahkan Koin',
                deposit: {
                    title: 'Setoran optimal = {{amount}} {{coin}}',
                    text: 'Jumlah optimal token untuk hasil tertinggi. Nilainya tergantung pada jumlah hewan peliharaan dan statistiknya',
                },
                boost: {
                    title: 'Peningkatan Harian Maks = {{boost}}%',
                    text: 'Peningkatan harian setelah setoran optimal dipertaruhkan. Peningkatan akan dihitung ulang setiap hari tergantung pada statistik hewan peliharaan Anda. Anda selalu dapat menambahkan token jika diperlukan!',
                },
            },
        },
        dailyBoostScreen: {
            title: 'Peningkatan Harian',
            headerTitle: 'Daily Boost = ',
            headerText:
                'Dorongan akan aktif dalam periode kunci opsi, setelah itu token akan dapat diklaim',
            button: 'Konfirmasi',
            confirmationModal: {
                title: 'Konfirmasi',
                keys: {
                    from: 'Dari',
                    duration: 'Durasi',
                    endingOn: 'Berakhir',
                    dailyBoost: 'Peningkatan Harian',
                    summary: 'Jumlah',
                },
                values: {
                    from: 'Dompet Utama',
                    duration: '{{plan}}, {{days}} Hari',
                },
            },
        },
        successScreen: {
            title: 'Mengaktifkan dorong berhasil',
            text: 'Token Anda dipertaruhkan dan akan ditahan hingga akhir paket. Setelah rencana berakhir, Anda harus menggunakan tombol "Dapatkan Token" untuk melepaskan token kembali ke dompet Anda',
            button: 'Kembali ke Dompet',
        },
        successUnStakeScreen: {
            title: 'Berhasil menghapus dorong',
            text: 'Anda telah berhasil menghapus dorongan. Token dikembalikan ke Dompet Utama Anda',
            button: 'Kembali ke Dompet',
        },
        alreadyScreen: {
            title: 'Dorongan',
            headerTitle: 'Rincian Rencana',
            headerText:
                'Anda telah mempertaruhkan token Anda dan akan ditahan hingga akhir paket. Setelah rencana berakhir, token dapat dilepaskan ke dompet Utama',
            headerInfoText: 'Bagaimana cara kerjanya?',

            confirmationModal: {
                title: 'Konfirmasi transaksi',
                keys: {
                    from: 'Ke Dompet',
                    duration: 'Durasi',
                    endingOn: 'Berakhir pada',
                    dailyBoost: 'Peningkatan Harian',
                    summary: 'Ringkasan Total',
                },
                values: {
                    from: 'Dompet Hadiah',
                    duration: '{{plan}}, {{days}} Hari',
                },
            },
            staked: {
                title: '{{coin}} Dorongan',
                text: 'Rencana aktif. Anda dapat menambahkan lebih banyak token',
                timerTitle: 'Sisa Waktu',
                staking: 'Dorongan:',
                deposit: 'Disetor Pada:',
                end: 'Berakhir pada:',
                boost: 'Peningkatan Harian:',
                summary: 'Ringkasan:',
                buttonAdd: 'Tambahkan Lebih Banyak Koin',
                buttonUpgrade: 'Paket Peningkatan',
                buttonUnstake: 'Dapatkan Token',

                modalAddCoins: {
                    title: 'Tambahkan Lebih Banyak Token?',
                    text: 'Setelah Anda menambahkan token, opsi dorongan Anda akan dihitung ulang berdasarkan jumlah yang disetorkan dan timer akan dimulai ulang',
                    button1: 'Tambahkan Token',
                    button2: 'Batal',
                },
                modalUpgrade: {
                    title: 'Rencana Peningkatan?',
                    text: 'Setelah Anda meningkatkan opsi dorongan Anda, itu akan dihitung ulang berdasarkan jumlah yang disetorkan dan timer akan dimulai ulang',
                    button1: 'Rencana',
                    button2: 'Batal',
                },
            },
        },
    },
    timer: {
        captions: { day: 'Hari', hour: 'Jam', min: 'Min', sec: 'Sec' },
        newDay: 'Hari baru',
        refreshed: 'Tugas-tugas Anda disegarkan',
    },
    referrals: {
        myReferrer: 'Anda memasukkan kode rujukan pengguna ini',
        referralCode: 'Ref Anda. Kode',
        referralLink: 'Ref Anda. Tautan',
        header: {
            title: 'Mengundang Pengguna Baru',
            text: 'Undang pengguna lain dan dapatkan lebih banyak lagi dengan program referral kami. Lihat cara kerjanya di bawah ini',
            infoText: 'Bagaimana cara kerjanya?',
        },
        direct: {
            title: 'Rujukan Langsung - {{directPercentage}}%',
            text: 'Anda akan mendapatkan {{directPercentage}}% dari semua hadiah yang diperoleh teman',
        },
        indirect: {
            title: 'Rujukan Tidak Langsung - {{inDirectPercentage}}%',
            text: 'Anda akan mendapatkan {{inDirectPercentage}}% dari semua hadiah yang diperoleh oleh teman dari teman',
        },
        gaming: {
            title: 'Bonus Permainan',
            text: 'Bonus referensi aktif untuk game PvP dan tugas game',
        },
        buttonShare: 'Mengundang Pengguna',
        invitedReferrals: {
            card: {
                direct: 'Rujukan Langsung',
                indirect: 'Rujukan Tidak Langsung',
                active: 'Rujukan Aktif',
                turnover: 'Total Perputaran',
            },
            viewReward: 'Lihat Hadiah',
            indirectModal: {
                title: 'Rujukan Tidak Langsung',
                text: 'Pengguna ini diundang oleh salah satu teman Anda',
            },
            header: {
                title: 'Rujukan yang Diundang',
                text: 'Di sini Anda dapat melihat semua rujukan yang diundang dan dorongan harian Anda jika Anda melakukan semua persyaratan',
                infoText: 'Bagaimana Cara Kerja Daily Boost?',
                list: 'Rujukan',
                sort: 'Urutkan Berdasarkan',
                filter: {
                    CreatedAt: 'Terbaru',
                    UserEnergy: 'Energi',
                },
            },
        },
        emptyScreen: {
            title: 'Ups!',
            text: 'Ada yang salah. Tapi jangan khawatir itu akan diperbaiki dengan cepat. Coba tarik.',
        },
        emptyList: {
            title: ' Belum Ada Rujukan yang Diundang',
            text: 'Anda belum mengundang pengguna mana pun. Tapi itu bukan masalah, mari kita lakukan sekarang juga',
        },
        allInvitedReferralsScreen: { title: 'Semua Rujukan yang Diundang' },
        inviteUsersScreen: {
            title: 'Undang Pengguna',
            text: 'Unduh aplikasi IguVerse dan berikan kode referral',
            myNFT: 'Hewan Peliharaan Saya NFT',
            collectedEnergy: 'Energi yang Terkumpul',
            leaderBoard: 'Tempat Papan Peringkat',
            button: 'Berbagi Kode',
            download: 'Unduh Aplikasi IguVerse',
        },
        referralCard: {
            title: 'Gunakan Kode Rujukan',
            text: 'Masukkan kode referral untuk mendapatkan bonus tambahan',
            button: 'Masukkan Kode',
        },
        referrerModal: {
            title: 'Kode Rujukan',
            text: 'Masukkan kode referral dan Anda akan menerima diskon dan bonus yang berbeda',
            label: 'Kode Rujukan',
            placeHolder: 'Masukkan kode rujukan',
            noCode: 'Tidak memiliki kode?',
            apply: 'Baca lebih lanjut tentang rujukan',
            button: 'Kirimkan Kode Rujukan',
            success: {
                toastSuccess: {
                    title: 'Kode rujukan yang dikirimkan',
                    text: 'Sekarang semua fungsi tersedia untuk Anda',
                },
            },
            error: {
                empty: 'Kode rujukan tidak boleh kosong',
                incorrectCode:
                    'Kode Salah. Kode rujukan tidak ada atau sudah kedaluwarsa',
                toastError: {
                    title: 'Kode yang Salah',
                    text: 'Kode rujukan tidak ada atau sudah kedaluwarsa',
                },
                forbidden:
                    'Tidak dapat menggunakan kode rujukan pada perangkat ini',
                toastForbidden: {
                    title: 'Terlarang',
                    text: 'Tidak dapat menggunakan kode rujukan pada perangkat ini',
                },
                toastAlreadyLinked: {
                    title: 'Sudah digunakan',
                    text: 'Akun Anda sudah menggunakan kode Referral',
                },
            },
        },
        boostCards: {
            cardTitle: 'Peningkatan Harian = {{boost}}%',
            cardText: 'Anda perlu mengundang ',
            users: ' Pengguna',
            text: 'Semakin banyak pengguna yang Anda undang, semakin banyak dorongan harian yang akan Anda dapatkan',
            button: 'Lihat Hadiah',
        },
        howBoostWorks: {
            title: 'Dapatkan Dorongan untuk Tugas Harian',
            text: 'Undang pengguna dan dapatkan peningkatan untuk tugas harian setelah mencapai jumlah undangan yang tepat. Boost akan secara otomatis diterapkan ketika Anda mencapainya',
            alert: 'Boost dihitung ulang setiap hari dan hanya berlaku untuk referral aktif, yang bermain setiap hari dan mencapai {{rewardEnergyThreshold}} Energi',
        },
        modalReferee: {
            title: 'Temui Referral Anda',
            text: 'Anda dapat mengunjungi media sosial pengguna yang diundang untuk mempelajari lebih lanjut tentang referral Anda atau mengenal mereka',
            energy: 'Energi yang Terkumpul (24 jam)',
        },
    },
    aiQuoteInfo: {
        alertCard: {
            overload: { title: 'Sistem Kelebihan Beban' },
            dailyAttempts: { title: '{{attempts}} Upaya yang tersisa' },
        },
        modalInfo: {
            title: 'NFT dari Imajinasi Anda',
            text: 'Anda dapat membuat NFT menggunakan teknologi AI tetapi operasi ini sangat mahal. Terkadang karena beban tinggi mungkin sementara tidak tersedia',
            daily: 'Penggunaan 24 jam terakhir =',
            dailyText:
                'Anda dapat menghasilkan tidak lebih dari {{amount}} hewan peliharaan unik menggunakan teknologi AI selama periode 24 jam',
            systemLoad: 'Beban Sistem = {{load}}',
            systemLoadText:
                'Terkadang sistem mungkin kelebihan beban karena permintaan yang besar. Anda harus menunggu sedikit',
            load: {
                low: 'Rendah',
                medium: 'Sedang',
                high: 'Tinggi',
                overloaded: 'OverLoaded',
            },
            systemUsage: 'Penggunaan Sistem = {{percentage}}%',
            systemUsageText:
                'Sistem ini dalam versi Beta dan saat ini hanya tersedia dalam jumlah tertentu per hari',
        },
        modalErrorNoMints: {
            title: 'Tidak Ada Mint yang Tersisa',
            text: 'Kami menyesal Anda menginformasikan bahwa semua mint telah dihabiskan untuk hari ini. Tapi jangan khawatir, Anda dapat mencoba mencetak NFT menggunakan teknologi AI besok',
            button1: 'Mint dari Foto',
        },
        modalErrorOverLoad: {
            title: 'Sistem Kelebihan Beban',
            text: 'Kami menyesal Anda menginformasikan bahwa AI mint sekarang kelebihan beban dari pengguna lain. Kami akan memberi tahu Anda, ketika sudah tersedia',
            button1: 'Mint dari Foto',
        },
    },
    howTo: {
        fee: {
            stepOne: {
                title: 'Biaya Blockchain adalah Perkiraan',
                text: 'Semua transaksi di aplikasi berlangsung di blockchain dan memiliki biaya komisi di BNB. Jumlah biaya hanya dapat diketahui pada saat transaksi dilakukan dan kami hanya menampilkan perkiraan',
            },
            stepTwo: {
                title: 'Biaya Lebih Tinggi Untuk Token',
                text: 'Di blockchain, Anda harus menyetujui menggunakan token sebelum melakukan transaksi tertentu. Membayar dengan BNB hanya membutuhkan satu transaksi, sementara membelanjakan token lainnya membutuhkan dua transaksi: persetujuan dan eksekusi',
            },
        },
        charity: {
            stepOne: {
                title: 'Membantu Organisasi Hewan',
                text: 'Anda dapat memilih organisasi amal dari daftar dan menyumbangkannya untuk membantu hewan di seluruh dunia',
            },
            stepTwo: {
                title: 'Tetapkan Persentase yang Lebih Disukai',
                text: 'Anda dapat memilih persentase dari hadiah yang akan disumbangkan (dari 1% hingga 100%). Anda juga dapat mengubah nilai ini kapan saja',
            },
        },
        play: {
            button: 'Mulai Bermain',
            stepOne: {
                title: 'Pilih Hewan Peliharaan untuk Menyelesaikan Tugas',
                text: 'Pilih hewan peliharaan di bagian di bawah ini yang akan berpartisipasi dalam permainan. Pet pertama yang diurutkan akan digunakan dalam tugas Sosial dan akan ditampilkan sebagai Pet utama Anda.',
            },
            stepTwo: {
                title: 'Mengembalikan Energi',
                text: 'Anda memiliki waktu 24 jam untuk memulihkan level Energi Anda dengan menyelesaikan tugas-tugas sebelum akhir hari. 100% Energi berarti Anda akan mendapatkan 100% dari hadiah maksimum yang mungkin Anda dapatkan berdasarkan statistik hewan peliharaan. Setiap hari ketika timer mencapai pukul 00:00, level Energi akan disetel ulang',
            },
            stepThree: {
                title: 'Dapatkan Hadiah',
                text: 'Setelah menyelesaikan tugas, Energi Anda akan dikonversi menjadi Hadiah berdasarkan statistik hewan peliharaan Anda',
            },
            stepFour: {
                title: 'Tingkatkan NFT Anda',
                text: 'Naikkan level hewan peliharaan Anda, cetak hewan peliharaan baru, tingkatkan peringkat untuk menikmati lebih banyak manfaat. Raih posisi tertinggi di Papan Peringkat dan nikmati lebih banyak hadiah',
            },
        },
        referrals: {
            button: 'Mengundang Pengguna',
            stepOne: {
                title: 'Bagikan Kode Referensi Anda',
                text: 'Undang pengguna ke aplikasi IguVerse dan dapatkan penghasilan dari permainan mereka. Untuk referensi langsung, Anda akan mendapatkan - {{direct}}% dan untuk referensi tidak langsung - {{inDirect}}%',
            },
            stepTwo: {
                title: 'Dapatkan Dorongan untuk Tugas Harian',
                text: 'Undang pengguna dan dapatkan dorongan untuk tugas harian setelah mencapai jumlah undangan yang tepat. Temukan detail lebih lanjut di tab "Referensi Saya"',
            },
            stepThree: {
                title: 'Terima Lebih Banyak Diskon',
                text: 'Di blok "NFT to Play" pilih minimal satu NFT untuk bermain game. Ketahuilah bahwa NFT pertama akan mengumpulkan pengalaman level paling banyak',
            },
            stepFour: {
                title: 'Dapatkan Bonus Permainan',
                text: 'Untuk setiap permainan yang dimenangkan dan untuk setiap isi ulang, rujukan langsung akan memberi Anda {{direct}}% dari jumlah, sementara rujukan tidak langsung — {{inDirect}}%',
            },
        },
        availableRewards: {
            stepOne: {
                titleOne: 'Klaim ',
                titleTwo: ' Dari Hadiah Anda',
                text: 'Anda dapat mentransfer {{percent}}% dari hadiah VIGUP yang tersedia ke dompet utama Anda. Setelah diklaim, token dapat ditukar, dikirim ke dompet lain, atau ditarik',
            },
            stepTwo: {
                title: 'Operasi Klaim',
                text: 'Klaim adalah operasi blockchain yang memberi Anda hak untuk mengubah saldo VIGUP Anda ke dompet utama IGUP Anda. Setelah klaim berhasil, dana segera tersedia',
            },
            stepThree: {
                title: 'Tukarkan VIGUP dengan ',
                text: 'Anda akan dapat menukarkan token yang diperoleh dengan token IGUAI setelah pasar dirilis. Dengan menggunakan aplikasi ini, Anda menjadi pengguna awal solusi lapisan atas kami',
            },
            stepFour: {
                title: 'Saldo Negatif',
                text: 'Terkadang saldo Anda yang tersedia bisa negatif, yang berarti Anda menggunakan hadiah yang terkunci untuk berbagai transaksi dalam game seperti Healing dan Level Up. Kami mengizinkan hadiah yang tersedia di bawah nol, hingga nilai saldo terkunci Anda. Setelah token Anda terbuka, saldo yang tersedia juga akan naik',
            },
            alert: 'Token VIGUP lainnya sedang menunggu keputusan dan akan disimpan di Dompet Terkunci',
        },
        lockedRewards: {
            stepOne: {
                title: 'Hadiah Terkunci',
                text: 'Hadiah yang diperoleh dikunci sesuai dengan statistik hewan peliharaan (Peringkat dan Level). Tingkatkan hewan peliharaan Anda untuk mengurangi periode penguncian',
            },
            stepTwo: {
                title: 'Mengonversi ke Hadiah yang Tersedia',
                text: 'Hadiah yang terkunci akan terbuka secara otomatis dan setelah dibuka, akan tersedia di bawah saldo Hadiah yang Tersedia',
            },
            stepThree: {
                title: 'Tukarkan VIGUP dengan ',
                text: 'Anda akan dapat menukarkan token yang diperoleh dengan token IGUAI setelah pasar dirilis. Dengan menggunakan aplikasi ini, Anda menjadi pengguna awal solusi lapisan atas kami',
            },
        },
        socializeToEarn: {
            CONFIRMED: 'Benar',
            FAILED: 'Salah',
            step: {
                title: 'Tautan IguVerse Ditambahkan',
                text: 'Selalu tambahkan tautan ke aplikasi IguVerse, yang dapat ditemukan di Layar Bagikan, saat berbagi ID Pet. Tautan harus dilampirkan ke cerita itu sendiri.',
            },
            stepOne: {
                title: 'ID Hewan Peliharaan Dan Tautan Terlihat Sepenuhnya',
                text: 'ID Hewan Peliharaan dan tautannya harus dapat diidentifikasi oleh pemverifikasi tanpa kesulitan. Tautan ke aplikasi harus aktif',
            },
            stepTwo: {
                title: 'Pet ID ditutupi/diubah secara berlebihan',
                text: 'Tidak ada overlay atau overpainting gambar, serta perampingan yang berlebihan diperbolehkan',
            },
            stepThree: {
                title: 'Pet ID sulit diketahui',
                text: 'Kami tidak mengizinkan modifikasi ID Hewan Peliharaan apa pun, termasuk memotong dan menyembunyikan gambar atau bagiannya. Gesek untuk mempelajari lebih lanjut',
            },
            stepFour: {
                title: 'Pet ID ditutupi secara',
                text: 'Tidak ada overlay atau overpainting gambar, serta perampingan yang berlebihan diperbolehkan',
            },
        },
        verifyUser: {
            stepOne: {
                title: 'Temukan Pet ID di media sosial',
                text: 'Ikuti akun media sosial pengguna lain dan periksa kontennya dan temukan Pet ID. Ketik kode di aplikasi dan selesaikan tugas',
            },
            stepTwo: {
                title: 'Berikan Identitas Hewan Peliharaan yang Ditemukan',
                text: 'Berikan kode dari Pet ID atau pindai menggunakan pemindai kode QR. Jika tidak ada, klik tombol Pet Not Found. Temukan semua pengguna untuk menyelesaikan tugas',
            },
            stepThree: {
                title: 'Bertanggung Jawab',
                text: 'Bermainlah dengan adil dan jangan mencoba menipu dengan menyesatkan sistem dengan memberikan ID yang salah atau mengklaim bahwa Anda tidak dapat menemukannya. Akun Anda dapat ditandai atau diblokir jika Anda terus melakukan hal ini',
            },
        },
        purchaseBNB: {
            screenTitle: 'Cara Membeli BNB',
            title: 'Beli BNB di Binance',
            text: 'BNB adalah mata uang kripto yang digunakan untuk membayar biaya pada Binance Smart Chain, blockchain yang kami gunakan. Tonton video di bawah ini untuk mempelajari lebih lanjut tentang menyetorkan BNB ke dompet dalam game',
            guideBlock: {
                title: 'Panduan Pembelian & Penarikan',
                first: 'Masuk ke aplikasi Binance. Unduh, daftar, dan verifikasi diri Anda jika Anda belum memilikinya',
                second: 'Beli kripto dengan kartu atau layanan p2p. Anda bisa langsung memilih BNB!',
                third: 'Buka tab Dompet dan ketuk Tarik',
                fourth: 'Pilih mata uang kripto yang ingin Anda tarik. Dalam kasus kami, BNB',
                fiveStepOne:
                    'Rekatkan alamat yang ingin Anda tarik dan pilih jaringan: ',
                fiveBold: 'BNB Smart Chain (BEP-20)',
                fiveStepTwo:
                    '. Alamat dompet Anda dapat ditemukan di tab dompet aplikasi IguVerse. Dimulai dengan 0x dan merupakan kombinasi dari huruf dan angka',
                six: 'Tunggu beberapa detik hingga transaksi diproses dan selesai!',
            },
            resourceBlock: {
                title: 'Sumber Daya yang Berguna',
                buy: 'Panduan Cara Membeli BNB (BNB)',
                withdraw: 'Cara Menarik dari Binance',
                status: 'Cara Memeriksa Status Transaksi Mata Uang Kripto di Blockchain',
            },
        },
        petOrderId: {
            title: 'Atur Hewan Peliharaan',
            text: 'Pilih Hewan Peliharaan Karakter yang Dapat Dimainkan di bagian "NFT to Play" dan pesan sisanya! Pemesanan hewan peliharaan akan menentukan XP yang mereka terima',
            cardFeatureInfo: {
                title: 'Prioritas Hewan Peliharaan',
                text: 'Pet Karakter yang Dapat Dimainkan pertama akan mewakili Anda di ID Hewan Peliharaan Anda, dalam pemungutan suara Pet, di papan peringkat',
            },
            button: 'Ubah urutan',
        },
        howToGamingAvailableWallet: {
            screenTitle: 'Dompet yang Tersedia',
            button: 'Isi ulang',
            stepOne: {
                title: 'Mainkan Game Kompetitif',
                text: 'Dompet game memungkinkan Anda bersaing dengan pemain lain untuk mendapatkan hadiah dan memenangkan IGU. Gunakan tab game untuk melihat game yang tersedia',
            },
            stepTwo: {
                title: 'Isi Ulang Dompet Game',
                text: 'Untuk ikut serta, isi ulang dompet game Anda dengan IGU dan dapatkan VIGU. Gunakan tombol di bawah ini untuk mengisi ulang token',
            },
            stepThree: {
                title: 'Tarik ke Dompet Utama',
                text: 'Hadiah yang dimenangkan dalam game kompetitif akan disimpan di dompet game. Anda dapat menarik hadiah ini ke dompet utama kapan saja',
            },
            stepFour: {
                title: 'Dapatkan Bonus dari Referensi',
                text: 'Untuk setiap permainan yang dimenangkan dan untuk setiap isi ulang, rujukan langsung akan memberi Anda {{direct}}% dari jumlah, sementara rujukan tidak langsung — {{indirect}}%',
            },
        },
        howToGamingPendingWallet: {
            screenTitle: 'Dompet Tertunda',
            alert: 'Token di Dompet Permainan Tertunda tidak dipegang oleh IguVerse dan dikunci dalam kontrak pintar selama permainan berlangsung',
            stepOne: {
                title: 'Beku Saat Bermain',
                text: 'Dana di Dompet Gaming akan dibekukan hingga Anda menyelesaikan permainan. Langkah ini telah diterapkan untuk mencegah penipuan',
            },
            stepTwo: {
                title: 'Pencairan Otomatis',
                text: 'Jika Anda telah memenangkan permainan, dana Anda akan secara otomatis dikembalikan ke Dompet Permainan. Jika tidak, mereka akan diberikan kepada pemenang',
            },
        },
        howToCommissionFee: {
            screenTitle: 'Biaya Komisi',
            stepOne: {
                title: ' Biaya Komisi',
                text: 'Kami membebankan biaya komisi {{commission}}% untuk setiap penarikan dari Gaming Wallet',
            },
            stepTwo: {
                title: 'Peningkatan Tokenomics',
                text: 'Game PvP mengikuti model ekonomi kumpulan, yang lebih unggul dari ekonomi sebagian besar proyek GameFi. Biaya komisi akan dipotong untuk lebih memperkuat ekonomi',
            },
        },
        HowToCollections: {
            stepOne: {
                title: 'Pendamping Hewan Peliharaan Virtual',
                text: 'Buat hewan peliharaan NFT dengan bantuan AI yang akan membantu Anda menghasilkan uang di media sosial. Anda juga dapat mengunggah foto hewan peliharaan Anda sendiri',
            },
            stepTwo: {
                title: 'Mengembalikan Energi',
                text: 'Anda memiliki waktu 24 jam untuk memulihkan level Energi Anda dengan menyelesaikan tugas-tugas sebelum akhir hari. 100% Energi berarti Anda akan mendapatkan 100% dari hadiah maksimum yang mungkin Anda dapatkan berdasarkan statistik hewan peliharaan. Setiap hari ketika timer mencapai pukul 00:00, level Energi akan disetel ulang',
            },
            stepThree: {
                title: 'Tukarkan VIGUP dengan ',
                text: 'Anda akan dapat menukarkan token yang diperoleh dengan token IGUAI setelah pasar dirilis. Dengan menggunakan aplikasi ini, Anda menjadi pengguna awal solusi lapisan atas kami',
            },
        },
    },
    energyInfoScreen: {
        title: 'Kumpulkan Energi dan Tukarkan ke Token',
        text: 'Nilai tukar Energi/IGUP Anda tergantung pada jumlah hewan peliharaan, peringkat, level, dan pengubah lainnya seperti boost',
        button: 'Mulai Bermain',
        features: {
            first: {
                title: '1 Energi ≈ {{amount}} IGUP',
                text: 'Ini adalah perkiraan nilai tukar yang dapat berubah tergantung pada kondisi yang berbeda',
            },
            second: {
                title: 'Ambang batas energi = {{energy}}',
                text: 'Jika Anda tidak mencapai ambang batas minimum {{energy}} Energi}}, setengah dari poin energi Anda akan dibakar, dan setengahnya lagi ditransfer ke hari berikutnya',
            },
        },
    },
    initial: {
        initialMint: {
            title: 'Ciptakan Hewan Peliharaan Pertama Anda dan Mulai Perjalanan Anda di IguVerse',
            text: 'Ini adalah langkah terakhir sebelum perjalanan luar biasa Anda di IguVerse. Buat hewan peliharaan pertamamu dan mulailah bermain dan dapatkan hadiah untuk aktivitas sehari-hari dengan hewan peliharaanmu',
            button: 'Ciptakan Hewan Peliharaan Pertama Anda',
        },
        initialReferral: {
            title: 'Nikmati Diskon Referral Mint!',
            text: 'Anda telah diundang ke aplikasi kami. Nikmati diskon dan bonus untuk bermain IguVerse. Cepatlah untuk membuat hewan peliharaan NFT Anda',
            button: 'Lanjutkan',
        },
    },
    ModalShareOrSave: {
        title: 'Simpan Konten Anda',
        text: 'Simpan konten IguVerse favorit Anda ke rol kamera atau bagikan dengan teman Anda',
        save: 'Simpan ke Rol Kamera',
        share: 'Berbagi',
        loading: 'Mempersiapkan konten..',
        saveSuccess: 'Konten yang disimpan ke Camera Roll',
    },
    RelatedApps: {
        downloadApp: {
            titleiOS: 'Aplikasi tersedia di iOS',
            titleAndroid: 'Aplikasi tersedia di Android',
            description:
                'Nikmati pengalaman yang lebih baik di aplikasi seluler',
            buttonOk: 'Unduh Aplikasi',
            buttonCancel: 'Tidak Sekarang',
        },
        switchToApp: {
            titleiOS: 'Beralih ke Aplikasi iOS',
            titleAndroid: 'Beralih ke Aplikasi Android',
            description:
                'Nikmati pengalaman yang lebih baik di aplikasi seluler',
            buttonOk: 'Beralih ke Aplikasi',
            buttonCancel: 'Tidak Sekarang',
        },
    },
    ShareYourFeedback: {
        title: 'Bagikan Umpan Balik Anda',
        text: 'Anda dapat berbagi umpan balik dengan kami, dan dengan mengirimkan formulir ini, Anda akan mengirimkan atau log sisi klien kepada kami, sehingga kami dapat membantu mengidentifikasi masalah Anda',
        placeholder: 'Jelaskan masalah Anda secara terperinci',
        button: 'Kirim',
        loading: 'Mengirim..',
        accessibility:
            'Nonaktifkan fitur "Kirimkan Umpan Balik Anda Saat Bergetar"',
    },
    ModalMainnet: {
        title: 'Fitur Tidak Tersedia',
        text: 'Fitur ini tidak tersedia sampai IGU ditayangkan di bursa. Tanggal pencatatan yang tepat akan segera diumumkan',
        button: 'OK',
    },
    ModalDailyRewards: {
        [DAILY_REWARD_STATUS.Bonus]: {
            title: 'Bonus PvP Dikreditkan',
            text: 'Untuk aktivitas Anda di game PvP, Anda telah diberikan bonus yang disetorkan langsung ke dalam Gaming Wallet',
        },
        [DAILY_REWARD_STATUS.Daily]: {
            title: 'Hadiah Harian Tersedia Di Dompet Anda',
            text: 'Hadiah Anda untuk tugas kemarin telah tiba!',
        },
        [DAILY_REWARD_STATUS.Both]: {
            title: 'Anda Menerima Hadiah Harian & Bonus PvP',
            text: 'Hadiah harian Anda telah tiba dan siap untuk dibuka! Anda juga menerima token bonus untuk memainkan game PvP',
        },
        dailyReward: {
            title: 'Hadiah yang Tersedia {{availableAmount}} / {{totalAmount}} IGUP',
            text: '{{availableAmount}} IGUP segera tersedia di dompet Anda',
        },
        unlocks: {
            title: 'Token Terkunci',
            text: '{{restAmount}} IGUP akan dibuka secara bertahap selama periode',
        },
    },
    MintBonusScreen: {
        mintSuccess: { title: 'Program Bonus', text: 'Bonus Mint' },
        BonusMintRanksDetailedInfoScreen: {
            title: 'Mint NFT - Dapatkan Bonus IGUP instan',
            text: 'Kami menawarkan Anda untuk mencetak NFT dan mendapatkan bonus yang dapat Anda tarik di masa mendatang. Lanjutkan ke langkah berikutnya dan selesaikan proses mint',
            button1: 'Lanjutkan ke Langkah Berikutnya',
            button2: 'Lihat Semua Bonus',
            timeRemaining: 'Sisa Waktu',
            features: {
                bonus: {
                    key: 'Bonus Peringkat = {{amount}} IGUP (${{dollarValue}})',
                    value: 'Token yang akan dikreditkan ke akun Anda setelah berhasil dicetak',
                },
                lock: {
                    key: 'Periode Penguncian = {{days}} Hari',
                    value: 'Token akan tersedia untuk ditarik setelah periode penguncian selesai',
                },
            },
        },
        BonusMintRanksCarouselScreen: {
            screenTitle: 'Bonus Peringkat',
            title: '{{slug}} Pangkat',
            button1: 'Pilih Peringkat',
            features: {
                bonus: {
                    key: 'Bonus Peringkat = {{amount}} IGUP (${{dollarValue}})',
                    value: 'Token yang akan dikreditkan ke akun Anda setelah berhasil dicetak',
                },
                lock: {
                    key: 'Periode Penguncian = {{days}} Hari',
                    value: 'Token akan tersedia untuk ditarik setelah periode penguncian selesai',
                },
            },
        },
    },
    YourPetsAreHungry: {
        title: 'Hewan peliharaan Anda lapar!',
        text: 'Kesehatan yang Hilang akan mengurangi hadiah Anda dan dapat membuat NFT Anda tidak dapat digunakan setelah beberapa saat. Beri makan hewan peliharaan Anda untuk menghasilkan secara konsisten!',
    },
    priceUpModal: {
        title: 'Kenaikan Harga Hingga ',
        text: 'Karena permintaan yang tinggi dan pertumbuhan proyek yang cepat, tim kami memutuskan untuk menaikkan harga NFT untuk memberi penghargaan kepada pengguna awal dan memastikan bahwa ekonomi tetap berkelanjutan dan seimbang dalam jangka panjang',
        priceUpdate: 'Update Harga Di',
        button: 'Mint NFT Baru',
    },
    updateModal: {
        banner: {
            title: 'Pembaruan Baru keluar!',
            text: 'Periksa versi {{version}} baru dari aplikasi',
        },
        screen: {
            screenTitle: 'Pembaruan Baru',
            title: 'Pembaruan Baru keluar!',
            text: 'Tim IguVerse telah bekerja keras untuk meningkatkan pengalaman aplikasi Anda dan mengembangkan fitur baru. Nikmati peningkatan ini di versi{{version}} yang baru',
            button: 'Mulai Bermain',
        },
    },
    communityModal: {
        title: 'Dapatkan Bantuan dari Komunitas Kami',
        text: 'Bergabunglah dengan obrolan komunitas resmi kami untuk mendapatkan jawaban atas pertanyaan Anda dari pemain lain. Pelajari cara bermain, maksimalkan keuntungan Anda dan nikmati IguVerse bersama!',
        button1: 'Lihat Selengkapnya',
        button2: 'Jangan tampilkan lagi',
    },
    socialTooltip: {
        text: 'Klik tag "Gagal" untuk mencari tahu mengapa akun atau ID Hewan Peliharaan Anda tidak memenuhi kriteria kami dan ditolak. Anda juga akan dapat mengakses Knowledgebase untuk mempelajari kriteria tersebut',
    },
    gameIterationText: {
        text: 'Hadiah kemarin sedang dihitung, yang biasanya memakan waktu sekitar {{minutes}} menit. Anda dapat bermain lagi setelah proses ini berakhir',
        toastErrorTitle: 'Hadiah kemarin sedang dihitung',
    },
    howConnectFacebookModal: {
        info: 'Cara Menghubungkan',
        screenTitle: 'Cara Menghubungkan Facebook',
        title: 'Menemukan ID Facebook',
        text: 'Untuk menghubungkan akun Facebook Anda, Anda perlu mencari dan menyalin ID Facebook Anda. Kunjungi halaman profil Anda dan salin bagian tautan setelah / — itu adalah ID Facebook Anda',
        button: 'Hubungkan Akun',
    },

    listingIgu: {
        iguListing: 'IGU Daftar',
        title: ' bersiap-siap untuk ',
        textOne: 'Daftar di bursa {{exchange}} akan berlangsung di ',
        textTwo: '. Kencangkan sabuk pengaman Anda, Iguana, kami berangkat!',
        button: 'Penelitian di bursa saham',
        listed: {
            title: ' terdaftar di ',
            text: 'Peluncuran IGU yang telah lama ditunggu-tunggu akhirnya tiba — ini baru permulaan dari Space Odyssey kami! Beli dan tukar koin IGU di bursa {{exchange}} sekarang juga',
        },
    },
    bybitVote: {
        title1: 'Pilih & Menangkan mulai dari ',
        title2: '!',
        text: 'IguVerse dipilih untuk mengambil bagian dalam ByVotes, di mana Anda dapat memilih daftar ByVit berikutnya. Pilih IGU & terima hadiah!',
        banner: {
            title1: 'Pilih & Menangkan mulai dari ',
            title2: '',
        },
        button: 'Belajarlah lagi',
    },
    howToPurchaseIGU: {
        modalTitle: 'Cara Membeli IGU',
        exchangesModalTitle: 'Beli IGU Di Bursa',
        cardDeposit: {
            title: 'Menyetorkan',
            text: 'Anda dapat menyetor token yang didukung dari dompet BSC BEP-20 mana pun',
        },
        cardExchange: {
            title: 'Beli Di Bursa',
            text: 'Beli & perdagangkan IGU di bursa tempat IGU terdaftar',
        },
        cardTrade: {
            title: 'Berdagang di Aplikasi',
            text: 'Perdagangkan IGU dengan cepat & nyaman langsung di aplikasi',
        },
    },
    howToClaimFreePet: {
        title: 'Beli NFT Untuk Diklaim',
        text: 'Anda tidak dapat mengklaim hadiah, karena Anda tidak memiliki NFT apa pun di akun Anda. Pet Gratis bukan NFT, karena tidak ada di blockchain. Membeli hewan peliharaan NFT atau menaikkan peringkat yang Anda miliki akan memberi Anda akses ke hadiah',
        alert: 'Semua hadiah yang Anda peroleh sebelumnya dilacak dan Anda dapat mengklaimnya setelah pembelian',
        button: 'Mint NFT Baru',
    },
    howToClaimOnButton: {
        titleOne: 'Klaim ',
        titleTwo: ' Dari Hadiah Anda',
        text: 'Anda dapat mentransfer {{percent}}% dari hadiah VIGUP yang tersedia ke dompet utama Anda. Setelah diklaim, token dapat ditukar, dikirim ke dompet lain, atau ditarik',
        alert: 'Token VIGUP lainnya sedang menunggu keputusan dan akan disimpan di Dompet Terkunci',
        button: 'Klaim Hadiah Anda',
    },
    onBoarding: {
        mainWallet: {
            title: 'Dompet Utama',
            stepOne: {
                title: 'Semua Kripto Anda Ada Di Sini',
                text: 'Dompet ini menyimpan semua token yang didukung yang tersedia di akun Anda. Token yang tidak didukung tidak ditampilkan. Semua hadiah Anda akan ditransfer ke sini setelah klaim',
            },
            stepTwo: {
                title: 'Menavigasi Antar Dompet',
                text: 'Dari tab Dompet Utama, Anda dapat membuka semua dompet lain yang tersedia di akun Anda dengan menggesek. Dompet ini termasuk Dompet NFT, Dompet Hadiah, dan Dompet Gaming',
            },
        },
        login: {
            stepOne: {
                title: 'Cara Baru Untuk Menghasilkan Crypto',
                text: 'Gunakan rutinitas media sosial harian Anda untuk mendapatkan token kripto! Tugasnya termasuk berbagi konten online, berjalan, dan memainkan game arcade',
            },
            stepTwo: {
                title: 'Pendamping Hewan Peliharaan Virtual',
                text: 'Buat hewan peliharaan NFT dengan bantuan AI yang akan membantu Anda menghasilkan uang di media sosial. Anda juga dapat mengunggah foto hewan peliharaan Anda sendiri',
            },
            stepThree: {
                title: 'Game Kompetitif',
                text: 'Ingin mendapatkan lebih banyak? Tantang orang lain dalam mode permainan PvP kami dan dapatkan penghasilan besar',
            },
            stepFour: {
                title: 'Donasi untuk Hewan',
                text: '1% dari hadiah harian Anda digunakan untuk kesejahteraan hewan. Anda dapat meningkatkan ukuran donasi di aplikasi',
            },
            stepFive: {
                title: 'Produk Masa Depan',
                text: 'Aplikasi ini hanyalah produk pertama dalam satu seri. Menjadi pengadopsi awal pasar bertenaga AI kami dan jaringan iklan terdesentralisasi setelah dirilis',
            },
        },
    },
    HomeScreen: {
        MemsModal: {
            title1: 'Diskon ',
            title2: ' di MemeFi Discord: Bergabunglah Sekarang!',
            text: 'MemeFi baru saja meluncurkan Kampanye Giveaway NFT di Discord. Tugas sederhana akan memberi Anda Tiket Royale untuk NFT dengan hadiah $MEMF',

            button1: 'Bergabunglah dengan Discord',
            button2: 'Jelajahi Situs Web',
            banner: {
                title: '$450.000 Turun',
                text: 'MemeFi baru saja meluncurkan Kampanye Giveaway NFT di Discord',
            },
        },
        exploreGames: 'Jelajahi Game',
        minimalBet: {
            title: 'Taruhan Minimal = {{amount}}',
            text: 'Jumlah terkecil yang dapat Anda pertaruhkan pada satu permainan',
        },

        WelcomeHeader: {
            title: 'Selamat Datang kembali!',
            text: 'Mainkan & dapatkan crypto setiap har',
        },
        ModalGameComingSoon: {
            title: 'Game Segera Hadir',
            text: 'Tim kami sedang bekerja keras untuk game PvP baru dan akan segera dirilis. Lihatlah permainan menyenangkan lainnya di perpustakaan kami!',
        },
        GamesBlock: {
            header: 'Permainan Kompetitif',
            button: 'Bermain Game',
            buttonContinue: 'Lanjutkan bermain',
            buttonComingSoon: 'Segera hadir...',
            orders: '{{orders}} Kamar',
            games: {
                [MYSTERY_GAMES.mysteryLikes]: {
                    title: 'The Mystery of Likes',
                    text: 'Tebak jumlah suka yang benar untuk NFT',
                },

                [MYSTERY_GAMES.nftRoyal]: {
                    title: 'The Grand Race',
                    text: 'Berpacu menuju kemenangan di jalur bertabur buah',
                },
                [MYSTERY_GAMES.nftEvolution]: {
                    title: 'NFT Evolution',
                    text: 'Kembangkan NFT dan terima versi yang lebih kuat',
                },
                [MYSTERY_GAMES.luckyStrike]: {
                    title: 'Lucky Strike',
                    text: 'Raih tiket untuk mendapatkan keberuntungan dan klaim semuanya dalam permainan keberuntungan yang mendebarkan',
                },
                [MYSTERY_GAMES.quantumSpin]: {
                    title: 'Quantum Disk',
                    text: 'Putar roda kuantum Anda untuk memikat uang receh dalam ayunan',
                },
                [MYSTERY_GAMES.tokenteller]: {
                    title: 'Tokenteller',
                    text: 'Ambil bola kristal Anda dan tebak harga IGU di masa depan',
                },
                socialProof: '{{amount}} menang di game {{game}} PvP sekarang',
            },
        },
        GamesFeatures: {
            orders: 'Ruang Permainan Kosong',
            prizePool: 'Total Hadiah Pool',
            turnover: 'Perputaran {{coin}}',
            totalSlots: 'Total putaran',
        },
        VacantRoomsEmpty: {
            title: 'Tidak Ada Game Kosong',
            text: 'Tidak ada permintaan game aktif untuk saat ini. Apakah Anda ingin membuatnya? Setiap pemain akan dapat menantang Anda',
        },
        EmptyGameHistory: {
            title: 'Belum Ada Permainan',
            text: 'Anda belum pernah memainkan atau membuat game apa pun. Buat sekarang dan ditantang oleh pemain acak',
        },
        GamesNavigationBar: {
            ORDERS: 'Kamar Kosong',
            HISTORY: 'Sejarah',
            ROUNDS: 'Putaran',
            WHEEL: 'Disk',
        },
        ActiveOrdersFilters: {
            title: 'Kamar Kosong',
            modalTitle: 'Urutkan berdasarkan',
            Newest: 'Hadiah Terbaru',
            Oldest: 'Tertua',
            Highest: 'Tertinggi',
            Lowest: 'Terendah',
        },
        ConfirmPlayModal: {
            title: 'Taruhan ',
            title2: 'Putaran untuk ',
            text: 'Dengan bergabung dalam game, Anda mengonfirmasi taruhan yang akan ditarik ke The Pending Game Wallet',
        },
        GamesCreateWelcome: {
            screenTitle: 'Buat Pesanan untuk "{{game}}"',
            title: 'Tantang Orang Lains',
            text: 'Buat game dengan taruhan pilihan dan selesaikan, sehingga pemain lain dapat menerima tantangan Anda',
        },
        MaxMinimalBetFeature: {
            title: 'Taruhan Minimum = {{min}}, Taruhan Maksimum = {{max}}',
            text: 'Jumlah terkecil dan terbesar yang dapat Anda pertaruhkan dalam satu permainan',
        },
        GameTermination: {
            title: 'Penghentian Otomatis = {{days}} Hari',
            text: 'Waktu setelah permainan berakhir jika tidak ada pemain lain yang menantang Anda',
            alert: 'Jika tidak ada yang menantang Anda dalam waktu tujuh hari, game akan dihapus secara otomatis dan deposit akan dikembalikan ke saldo Anda',
        },
        EnterCoinsAmountScreen: {
            screenTitle: 'Masukkan Jumlah Koin',
            error: {
                max: 'Saldo tidak mencukupi, isi ulang untuk melanjutkan',
                maxStake:
                    'Taruhan maksimum {{amount}}, harap kurangi jumlah taruhan',
                minStake:
                    'Taruhan minimum {{amount}}, tolong, tingkatkan taruhannya',
                digits: 'Harus hanya digit',
            },
            confirmTransaction: {
                valueType: 'Pembuatan Pesanan untuk "{{game}}"',
            },
        },
        PreviousGameModal: {
            title: 'Selesaikan Game Sebelumnya?',
            text: 'Selesaikan game yang Anda ikuti agar pengguna lain dapat menantang Anda. Permainan akan otomatis kedaluwarsa dalam {{days}} hari',
            button1: 'Selesaikan permainan sebelumnya',
        },
        GameHistoryScreen: {
            title: 'Sejarah',
            text: 'Inilah riwayat permainan yang telah Anda selesaikan. Anda dapat melihatnya berdasarkan bulan',
            status: {
                [MYSTERY_LIKES_STATUS.WaitingForMyself]:
                    'Menunggu giliran Anda',
                [MYSTERY_LIKES_STATUS.WaitingForOpponent]: 'Menunggu lawan',
                [MYSTERY_LIKES_STATUS.Refund]: 'Permainan telah kedaluwarsa',
            },
        },
        MysteryGamesBanner: {
            oneGame: {
                title: 'Lanjutkan bermain!',
                text: 'Selesaikan permainan "{{game}}"',
            },
            more: {
                title: 'Lanjutkan bermain!',
                text: 'Ada 2 game yang belum selesai',
            },
        },
        MysteryGamesContinueModal: {
            title: 'Lanjutkan bermain',
            text: 'Ada 2 permainan yang belum selesai yang harus Anda selesaikan untuk mempelajari hasil permainan',
        },
        MysteryLikes: {
            MysteryLikesHowItWorks: {
                stepOne: {
                    title: 'Tebak Jumlah Like',
                    text: 'Setiap putaran permainan memiliki {{gamesAmount}} pertandingan melawan pemain lain. Tebak benar lebih banyak dari lawan Anda untuk menang',
                },
                stepTwo: {
                    title: 'Bergabunglah Dan Buat Game',
                    text: 'Pengguna dapat bergabung dan membuat game. Saat membuat game, Anda harus memilih saham di token VIGU. Dengan bergabung dalam sebuah game, Anda setuju untuk mempertaruhkan jumlah token yang ditentukan oleh pembuat game',
                },
                stepThree: {
                    title: 'Selingkuh tidak mungkin',
                    text: 'Jumlah suka untuk NFT tidak dapat diakses oleh pengguna, jadi tidak mungkin ada kecurangan. Jika Anda tampaknya mengalami nasib buruk, itulah masalahnya. Mainkan sedikit lagi dan pasang pasti akan berubah',
                },
            },
            MysteryLikesCreateGameSuccess: {
                title: 'Sebuah Game Dibuat',
                text: 'Anda berhasil membuat game! Tolong, selesaikan putarannya, sehingga kami dapat membandingkan jawaban Anda dengan jawaban lawan Anda di masa depan',
                button: 'Mulai Bermain',
            },
            MysteryLikesSelectRange: {
                title: 'Pilih Rentang',
                text: 'Pilih rentang yang berisi jumlah suka yang benar',
                button: 'Lanjutkan ke Gambar Berikutnya',
                toastError: 'Sudah Memilih',
                buttonFinish: 'Selesaikan Permainan',
                tooltip1:
                    'Ini adalah NFT lawan Anda. Anda perlu menebak berapa banyak suka yang dimilikinya. Suka tidak terlihat oleh Anda dan lawan Anda',
                tooltip2:
                    'Untuk memilih jumlah suka, klik salah satu kartu dan pindah ke gambar berikutnya dengan tombol di bawah',
            },
            MysteryLikesSelectRangeFinish: {
                [MYSTERY_LIKES_STATUS.WaitingForOpponent]: {
                    title: 'Menunggu Lawan',
                    text: 'Anda telah menyelesaikan permainan. Sekarang terserah lawan Anda untuk menantang Anda dan bergabung. Jika tidak diselesaikan oleh lawan dalam waktu tujuh hari, permainan akan dihentikan secara otomatis dan deposit Anda dikembalikan',
                },
                [MYSTERY_LIKES_STATUS.Won]: {
                    title: 'Anda telah menang!',
                    textOne:
                        'Selamat! Anda telah berhasil mengungguli lawan Anda. ',
                    textTwo: ' akan segera ditransfer ke dompet Anda',
                },
                [MYSTERY_LIKES_STATUS.Draw]: {
                    title: 'Wow, ini seri!',
                    text: 'Meskipun kelihatannya tidak mungkin, Anda berdua memenangkan jumlah poin yang sama. Taruhan Anda telah dikembalikan ke dompet Anda. Peduli putaran lain?',
                },
                [MYSTERY_LIKES_STATUS.Lost]: {
                    title: 'Kamu kalah :(',
                    text: 'Sayangnya, lawan Anda berhasil mengungguli Anda di babak permainan ini. Taruhan Anda telah ditransfer ke dompet mereka. Nah, Anda selalu bisa menang lain kali!',
                },
                statistics: 'Statistik Anda',
                alert: 'Jika tidak ada yang menantang Anda dalam waktu tujuh hari, game akan dihapus secara otomatis dan deposit akan dikembalikan ke saldo Anda',
                likes: 'Suka',
            },
            MysteryLikesConfirmPlay: {
                warning:
                    'Jumlah suka untuk NFT tidak dapat diakses oleh pengguna, jadi tidak mungkin ada kecurangan',

                toastErrorGame1: 'Permainan sudah dimula',
                toastErrorGame2: 'Silakan, pilih permainan lain',
            },

            MysteryLikesLoadingScreen: {
                prepare: {
                    title: 'Mempersiapkan NFT',
                    text: 'Kami mengocok NFT, sehingga Anda mendapatkan tata letak acak. Suka tidak terlihat oleh para pemain! Tolong, tunggu sebentar dan jangan tinggalkan game atau aplikasinya',
                },
                complete: {
                    title: 'Menganalisis Hasil',
                    text: 'Memproses pilihan Anda dan lawan untuk mengumumkan hasilnya. Tolong, tunggu sebentar dan jangan tinggalkan game atau aplikasinya',
                },
            },
        },

        NftEvolution: {
            breedCost: {
                title: 'Biaya Pembiakan{{amount}}',
                text: 'Biaya NFT Peringkat berikutnya setelah berkembang biak dengan diskon 40%',
                alert: 'Mendapatkan Peringkat berikutnya tidak dijamin',
            },
            WelcomeNftEvolution: {
                BestRankToBreed: {
                    title: 'Peringkat Terbaik Untuk Dikembangbiakkan',
                    text: 'Berikut daftar kombinasi Peringkat teratas untuk pemuliaan',
                },
                stepOne: {
                    title: 'NFT berkembang biak',
                    text: 'Pilih dua NFT untuk berkembang biak dan dapatkan NFT dari Peringkat acak dengan probabilitas tertentu. NFT tidak hilang!',
                },
                stepTwo: {
                    title: 'Kloning DNA',
                    text: 'Laboratorium berteknologi tinggi kami sekarang dapat mengambil DNA hewan mati dan mengkloningnya! Jadi, ambil beberapa NFT mati dan kembangkan. Kesehatan tidak akan dipulihkan',
                },
                stepThree: {
                    title: 'Peluang peringkat',
                    text: 'Pelajari peluang untuk mendapatkan setiap Peringkat saat berkembang biak. NFT tidak harus memiliki Peringkat yang sama. Namun, Anda memiliki peluang untuk memenangkan NFT dari Peringkat apa pun, termasuk Peringkat yang lebih tinggi',
                },
                stepFour: {
                    title: 'Biaya Pembiakan',
                    text: 'Biaya NFT Peringkat berikutnya setelah berkembang biak dengan diskon 40%. Anda akan menerima NFT unik yang dihasilkan oleh AI. Generasi dari foto tidak tersedia',
                },
            },
            NftEvolutionSelectPets: {
                text: 'Berikut daftar kombinasi Peringkat teratas untuk pemuliaan',
                button: 'Hitung Peluang',
                emptyCard: {
                    first: 'Pilih NFT pertama yang akan dilintasi',
                    second: 'Pilih NFT kedua yang akan dilintasi',
                },
                loading: 'Menganalisis...',
            },
            NftEvolutionSelectPet: {
                title: 'Pilih NFT',
            },
            NftEvolutionCheckout: {
                title: 'Peluang perkawinan silang',
                text: 'Cari tahu lebih lanjut tentang apa yang Anda dapatkan dari perkawinan silang',
                button: 'Berkembang biak Untuk {{amount}}',
                loading: {
                    title: 'Pembiakan',
                    text: 'Tolong, tunggu sementara NFT sedang dikembangkan. Jangan tutup aplikasi atau keluar dari tab. Proses pemuliaan biasanya memakan waktu hingga lima menit',
                },
            },
            ConfirmBreedModal: {
                title: 'Berkembang biak Untuk ',
                text: 'Saat bergabung dengan game, Anda setuju untuk membiakkan dua NFT untuk menerima NFT baru dengan Peringkat acak',
            },
            NftEvolutionSuccess: {
                title: 'NFT Peringkat {{rank}} Dibuat!',
                text: 'Selamat! Anda telah berhasil membiakkan NFT dan menerima NFT Peringkat {{rank}}',
            },
            NftEvolutionMintPet: {
                title: 'Kustomisasi NFT Baru',
                text: 'Kami secara otomatis membuat empat gambar NFT untuk Anda. Lihat, pilih yang terbaik dan ketikkan nama NFT baru Anda',
            },
            noPetModal: {
                title: 'Buat NFT Baru Untuk Dimainkan',
                text: 'Untuk ikut serta dalam permainan, setidaknya diperlukan dua hewan peliharaan. Buat yang baru dan mulai mainkan',
            },
        },

        NftRoyal: {
            lockPeriodWarning:
                'Untuk mencegah cheat, kami menggunakan sistem deteksi cheat',

            NftRoyalHowItWorks: {
                stepOne: {
                    title: 'Mainkan Game Arkade yang Menyenangkan',
                    text: 'Ini adalah variasi permainan dari tugas harian, di mana Anda akan menghadapi lawan yang kuat. Kami menawarkan beberapa mode permainan untuk meningkatkan pengalaman Anda. Anda hanya akan memiliki satu lawan',
                },
                stepTwo: {
                    title: 'Bergabunglah Dan Buat Game',
                    text: 'Pengguna dapat bergabung dan membuat game. Saat membuat game, Anda harus memilih saham di token VIGU. Dengan bergabung dalam sebuah game, Anda setuju untuk mempertaruhkan jumlah token yang ditentukan oleh pembuat game',
                },
                stepThree: {
                    title: 'Selingkuh tidak mungkin',
                    text: 'Untuk mencegah cheat, kami menggunakan sistem deteksi cheat cerdas yang menjamin hanya keterampilan dan keberuntungan yang menentukan pemenang',
                },
            },
            NftRoyalGameSettings: {
                gameMode: {
                    [NFT_ROYAL_GAME_MODE.Score]: {
                        title: 'Poin',
                        text: 'Pemain akan bersaing untuk mendapatkan poin',
                    },
                    [NFT_ROYAL_GAME_MODE.Fruit]: {
                        title: 'Buah',
                        text: 'Pemain akan bersaing untuk mendapatkan buah',
                    },
                },
                difficultyType: {
                    [GAME_DIFFICULTY.Easy]: {
                        title: 'Mudah',
                        text: 'Kecepatan rendah dan tingkat pemijahan kaktus rendah',
                    },
                    [GAME_DIFFICULTY.Medium]: {
                        title: 'Sedang',
                        text: 'Kecepatan sedang dan rata-rata pemijahan kaktus',
                    },
                    [GAME_DIFFICULTY.Hard]: {
                        title: 'Keras',
                        text: 'Kecepatan tinggi dan kecepatan bertelur kaktus yang tinggi',
                    },
                },
                lives: 'Jumlah maksimum nyawa dalam game',
            },
            NftRoyalGameSettingsModal: {
                title: 'Pengaturan permainan',
                text: 'Ada berbagai parameter berbeda untuk gameplay yang lebih seru',
                feature: {
                    mode: {
                        description:
                            'Dalam mode skor Anda bersaing untuk mendapatkan poin dan dalam mode buah Anda bersaing untuk mendapatkan jumlah buah yang dikumpulkan',
                    },
                    difficulty: {
                        description:
                            'Tiga tingkat kesulitan (mudah, sedang dan keras) mengontrol kecepatan dan bibit kaktus',
                    },
                    livesCount: {
                        description:
                            'Jumlah nyawa dalam game. Permainan diakhiri dengan hilangnya nyawa terakhir oleh salah satu pemain',
                    },
                },
            },

            NftRoyalCreateGameSuccess: {
                title: 'Anda telah berhasil membuat game!',
                text: 'Silakan selesaikan permainannya, agar kami dapat membandingkan hasil yang Anda dapatkan dengan hasil yang didapatkan oleh lawan Anda di masa depan',
            },

            NftRoyalGameHistory: {
                [NFT_ROYAL_GAME_HISTORY_STATUS.WaitingForOpponent]: {
                    title: 'Menunggu Lawan',
                    text: 'Anda telah menyelesaikan permainan. Sekarang terserah lawan Anda untuk menantang Anda dan bergabung. Jika tidak diselesaikan oleh lawan dalam waktu tujuh hari, permainan akan dihentikan secara otomatis dan deposit Anda dikembalikan',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Won]: {
                    title: 'Anda telah menang!',
                    textOne:
                        'Selamat! Anda telah berhasil mengungguli lawan Anda. ',
                    textTwo: ' akan ditransfer ke dompet game Anda segera',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Draw]: {
                    title: 'Wow, ini seri!',
                    text: 'Meskipun kelihatannya tidak mungkin, Anda berdua memenangkan jumlah poin yang sama. Taruhan Anda telah dikembalikan ke dompet Anda. Peduli putaran lain?',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Lost]: {
                    title: 'Kamu kalah :(',
                    text: 'Sayangnya, lawan Anda berhasil mengungguli Anda di babak permainan ini. Taruhan Anda telah ditransfer ke dompet mereka. Nah, Anda selalu bisa menang lain kali!',
                },
                GameStatistics: {
                    title: 'Statistik Bermain',
                    score: 'Skor Anda',
                    lives: 'Menyelamatkan Nyawa',
                    fruitCollected: 'Buah yang Dikumpulkan',
                },
            },
            NftRoyalLoadingScreen: {
                prepare: {
                    title: 'Mempersiapkan Permainan',
                    text: 'Kami melakukan semua pekerjaan yang diperlukan untuk memulai permainan. Tolong, tunggu sebentar. Tidak akan memakan waktu terlalu lama!',
                },
                complete: {
                    title: 'Menganalisis Hasil',
                    text: 'Memproses hasil Anda dan hasil lawan Anda untuk mengumumkan hasilnya. Harap tunggu sebentar dan jangan meninggalkan permainan atau aplikasi',
                },
            },
            emptyScreen: {
                title: 'Ups!',
                text: 'Ada yang salah. Tapi jangan khawatir itu akan diperbaiki dengan cepat',
            },
        },

        [MYSTERY_GAMES.luckyStrike]: {
            keys: {
                participants: 'Peserta',
                winners: 'Pemenang yang Beruntung',
            },

            purchaseTicket: 'Ambil Tiket',
            ticketsGrabbed: 'Tiket Diambil',
            soldOut: 'Semua Tiket Habis Terjual',
            LuckyStrikeTimerBlock: {
                title: 'Putaran Berakhir Dalam',
                text: 'Waktu hingga putaran berakhir',
            },
            HashSecuritySystem: {
                title: 'Sistem Hash Aman',
                text: 'Setiap tiket memiliki kode hash unik yang disembunyikan dari pemain lain. Kode menentukan pemenang!',
            },
            LuckyStrikePricePool: {
                title: 'Hadiah = {{text}}',
                text: 'Total kumpulan yang dikumpulkan dari tiket premium. Satu pemenang ambil semuanya. Hadiah dibayarkan ke Dompet Permainan',
            },
            LuckyStrikeParticipants: {
                title: 'Peserta = {{text}}',
                text: 'Pemain untuk ambil bagian dan batas pemain. Setelah batas tercapai, tiket baru menjadi tidak tersedia',
            },
            LuckyStrikeHowItWorks: {
                stepOne: {
                    title: 'Memperkenalkan Lucky Strike',
                    text: 'Mainkan satu putaran dan menangkan hadiah menarik! Setiap tiket yang Anda ambil di setiap putaran meningkatkan peluang Anda untuk menang',
                },
                stepTwo: {
                    title: 'Tingkatkan Peluang Anda',
                    text: 'Pemain memiliki kesempatan untuk memenangkan kumpulan yang dibuat dari tiket premium. Semakin banyak tiket yang Anda kumpulkan, semakin tinggi peluang untuk menerima hadiah',
                },
                stepThree: {
                    title: 'Selingkuh itu Mustahil',
                    text: 'Karena hash tiket tidak dapat diakses oleh pengguna lain, kecurangan tidak mungkin dilakukan. Jika Anda tampaknya mengalami nasib buruk, itulah masalahnya. Mainkan sedikit lagi dan pasang pasti akan berubah',
                },
            },
            LuckyStrikeMain: {
                title: 'Putaran Keberuntungan',
                text: 'Putaran bervariasi dalam durasi, jumlah pemain, dan peluang menang',
                emptyList: {
                    title: 'Tidak Ada Pemenang',
                    text: 'Saat ini, tidak ada pengguna yang telah memenangkan putaran. Pemenang akan muncul segera.',
                },
            },
            LuckyStrikeWinners: {
                title: 'Pemenang yang Beruntung',
                text: 'Lihatlah para pemenang yang beruntung',
            },
            LuckyStrikePurchaseModal: {
                title: 'Dapatkan Tiket "{{type}}"',
                text: 'Premi dikumpulkan dari kumpulan game. Pemenang mengambil seluruh kumpulan dan ditentukan oleh hash tiket. Semakin banyak tiket yang Anda ambil, semakin tinggi peluang untuk menerima hadiah',
                alert: 'Anda dapat mengambil maksimal tiket {{maxTickets}} per satu game untuk mencegah kecurangan dan meningkatkan pengalaman bermain game',
            },
            LuckyStrikeWaitingForResult: {
                title: 'Menunggu Hasil!',
                text: 'Tunggu hingga putaran berakhir untuk mengetahui hasil permainan. Anda dapat mengambil lebih banyak tiket untuk meningkatkan peluang kemenangan Anda',
            },
            LuckyStrikeUserTickets: {
                text: 'Setiap tiket memiliki kode hash unik yang disembunyikan dari pemain lain dan membantu kami menjamin keadilan permainan',
                alert: 'Anda sudah memiliki maksimal {{text}} tiket yang diperbolehkan per game',
            },

            LuckyStrikeHistoryItem: {
                [LUCKY_STRIKE_GAMES_STATUS.Won]: '{{round}} Dimenangkan',
                [LUCKY_STRIKE_GAMES_STATUS.Lost]: '{{round}} Kalah',
                [LUCKY_STRIKE_GAMES_STATUS.WaitingForResults]: 'Menunggu Hasil',
            },
            LuckyStrikeHistoryBlockHeader: {
                [LUCKY_STRIKE_GAMES_STATUS.Won]: {
                    title: 'Anda telah menang',
                    textOne:
                        'Selamat! Tiket Anda adalah yang beruntung dan Anda memenangkan seluruh kumpulan hadiah. ',
                    textTwo: ' akan disetorkan ke dompet Anda secara instan',
                },

                [LUCKY_STRIKE_GAMES_STATUS.Lost]: {
                    title: 'Anda telah Kalah :(',
                    text: 'Sayangnya, kali ini Anda tidak berhasil memenangkan ronde tersebut. Keberuntungan yang sia-sia untuk Anda di yang berikutnya!',
                },
            },
            LuckyStrikeGameHistoryInfo: {
                gameType: 'Tipe Permainan',
                correctTicket: 'Tiket Pemenang',
                yourTicket: 'Tiket Anda',
                yourTickets: 'Tiket Anda',
            },

            toasts: {
                soldOut: {
                    text1: 'Galat!',
                    text2: 'Semua Tiket Terjual!',
                },
                gameExpired: {
                    text1: 'Galat!',
                    text2: 'Putaran Telah Berakhir!',
                },
                gamePending: {
                    text1: 'Ups!',
                    text2: 'Ada yang tidak beres',
                },
            },
        },

        [MYSTERY_GAMES.quantumSpin]: {
            keys: {
                spin: 'Putaran',
                spinning: 'Pemintalan',
            },
            QuantumSpinProvablyFair: {
                card: {
                    title: 'Terbukti Adil',
                    text: 'Semua hasil dihitung melalui fungsi kriptografi, yang memungkinkan siapa pun memeriksa keadilan permainan',
                },

                title: 'Terbukti Adil',
                text: 'Hasilnya dirantai, sehingga sistem tidak mungkin ditipu. Saat kami merilis hash pertama di Twitter, Anda dapat membuktikan sendiri kewajaran hasilnya',
                algorithm: {
                    title: 'Algoritma',
                    text: 'Semua hasil permainan untuk {{rounds}} putaran berikutnya telah ditentukan sebelumnya. Sebelum setiap putaran, kami mengungkapkan hash dari hasilnya, sehingga mustahil bagi kami untuk mengubah hasilnya setelah kenyataan.\n\nSebenarnya kami telah menyambungkan semua hasil, sehingga mustahil bagi kami bahkan untuk mengubah hasil di masa depan. Dan sebelum menghasilkan rantai hasil, kami mengungkapkan hash pertama, menerbitkannya ke Twitter, dan mencampurkan hash block Bitcoin di masa depan yang tidak mungkin kami ketahui. Ini membuat semua hasil terbukti adil.\n\nSebelum putaran pertama permainan dimulai, kami membuat rantai hash. Setiap hash adalah nilai 256 bit. Rantai dimulai dengan nilai 256 bit yang dipilih secara acak dan setiap nilai berikutnya dihitung menggunakan fungsi hash BLAKE2b dari nilai sebelumnya.\n\nMenggunakan fungsi hash kriptografis memastikan bahwa seseorang dapat dengan mudah menghitung nilai mana pun dalam rantai menggunakan nilai sebelumnya, tetapi seseorang tidak dapat dengan mudah menghitung nilai ke arah terbalik. Nilai terakhir dalam rantai hash yang dihitung sebelumnya adalah yang kami publikasikan secara publik dan digunakan untuk putaran pertama permainan. Putaran kedua permainan menggunakan nilai hash kedua terakhir, putaran ketiga menggunakan nilai hash ketiga terakhir, dan seterusnya. Dengan melintasi rantai dengan cara ini, seseorang dapat memverifikasi bahwa hasil semua putaran permainan masa lalu konsisten dengan rantai yang dihitung sebelumnya, tetapi hasil putaran masa depan tetap tidak dapat diprediksi oleh pengguna.\n\nUntuk menghilangkan kemungkinan bahwa kami sengaja menghasilkan rantai menggunakan nilai awal yang membiaskan hasil permainan menjadi menguntungkan bagi kami, setiap nilai dalam rantai ditambahkan ke benih global dan nilai hasilnya di-hash lagi menggunakan BLAKE2b untuk membuat nilai akhir yang akan menentukan hasil setiap putaran permainan. Benih global ini diatur ke hash dari blok Bitcoin yang kami umumkan sebelum penambangannya. Penyertaan benih global memastikan bahwa hasil permainan tidak dapat diketahui oleh kami ketika nilai hash putaran permainan pertama dipublikasikan',
                },
                verification: {
                    title: 'Сontoh Verifikasi',
                    text: 'Siapa pun dapat memverifikasi bahwa hasil semua putaran permainan sebelumnya dihasilkan menggunakan algoritma yang terbukti adil dengan kode python berikut',
                },
            },
            QuantumSpinHowItWorks: {
                stepOne: {
                    title: 'Putar Roda Kuantum',
                    text: 'Roda berada dalam superposisi — kita tidak tahu apa yang akan dihasilkannya. Putar roda untuk memecahkan ketidakpastian dan mendapatkan hadiah terbesar',
                },
                stepTwo: {
                    title: 'Setiap putaran kuantum membutuhkan energi, yaitu token',
                    text: 'Hadiah Anda mungkin bernilai lebih rendah atau lebih tinggi dari taruhan Anda. Tentu saja, Anda dapat memberi kami hadiah besar!',
                },
                stepThree: {
                    title: 'Selingkuh itu Mustahil',
                    text: 'Hasil putaran ditentukan pada saat permainan melalui proses acak dan tidak diketahui oleh tim. Kami menghargai keadilan dan transparansi',
                },
            },
            QuantumSuccess: {
                coin: 'Selamat! Anda telah memenangkan {{coin}} sebagai imbalan, yang akan segera ditransfer ke dompet Anda. Coba keberuntungan Anda lagi dan bagikan hasil Anda di acara sosial',
                rank: 'Selamat! Anda telah memenangkan NFT Peringkat {{rank}}, yang akan segera ditransfer ke dompet Anda. Coba keberuntungan Anda lagi dan bagikan hasil Anda di acara sosial',
            },
            QuantumSpinGameHistory: {
                again: 'Putar Lagi',
            },
            QuantumSpinDetailsModal: {
                button: 'Kembali ke Disk',
            },
            QuantumSpinHistory: {
                title: 'Di sini kosong',
                text: 'Anda belum memainkan satu pun permainan',
            },
        },
        [MYSTERY_GAMES.tokenteller]: {
            predictPrice: 'Prediksi Harga',
            addMoreTokens: 'Tambahkan Lebih Banyak Token',
            priceDirection: 'Arah Harga',

            [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Up]: 'ATAS',
            [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Down]: 'BAWAH',
            TokenTellerConfirmationModal: {
                [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Up]: 'Pengganda ATAS',
                [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Down]:
                    'Pengganda BAWAH',
            },

            TokenTellerHowItWorks: {
                stepOne: {
                    title: 'Memperkenalkan Tokenteller',
                    text: 'Uji keterampilan peramalan Anda dalam game serba cepat ini. Prediksi pergerakan harga IGU dalam putaran {{min}} menit. Gunakan alat apa pun yang diperlukan: bola kristal, ramalan hewan, dan bahkan ilmu hitam',
                },
                stepTwo: {
                    title: 'Ukuran Hadiah',
                    text: 'Dalam satu permainan, Anda memilih atas atau bawah. Besaran hadiah Anda bergantung pada pengganda, yang merupakan rasio kumpulan banteng terhadap kumpulan beruang. Pengganda ditampilkan di Tab Prediksi dan dapat berubah hingga putaran ditayangkan',
                },
                stepThree: {
                    title: 'Kecurangan itu Tidak Mungkin',
                    text: 'Kami menggunakan oracle andal yang mengambil harga {{coin}} saat ini dari bursa. Anda selalu dapat memeriksa harga di bursa',
                },
            },
            TokenTellerMainScreen: {
                title: 'Putaran',
                text: 'Anda hanya dapat bergabung pada putaran mendatang',
            },
            TokenTellerPurchaseModal: {
                title: 'Memprediksi Pergerakan Harga',
                text: 'Bergabunglah dalam putaran untuk memprediksi kemana arah {{coin}}. Pilih taruhan dan arah di bawah ini',
                alert: 'Anda sudah membuat prediksi bahwa token akan {{direction}}. Sekarang Anda hanya dapat meningkatkan posisi Anda ke arah ini',
            },

            TokenTellerPricePool: {
                title: 'Kolam = {{text}}',
                text: 'Kumpulan dikumpulkan dari taruhan pengguna. Hadiahnya tergantung pada rasio antara total taruhan bull dan bear',
            },
            TokenTellerUpPayout: {
                title: 'Pengganda ATAS = {{coefficient}}X',
                text: 'Pengganda pemenang jika harga naik',
            },
            TokenTellerDownPayout: {
                title: 'Pengganda BAWAH = {{coefficient}}X',
                text: 'Pengganda pemenang jika harga turun',
            },
            TokenTellerParticipants: {
                title: 'Peserta = {{text}}',
                text: 'Jumlah pemain yang ambil bagian dalam ronde tersebut',
            },

            TokenTellerTimerBlock: {
                [TOKEN_TELLER_GAME_STATUS.Pending]: {
                    title: 'Putaran Dimulai Pada',
                },
                [TOKEN_TELLER_GAME_STATUS.Closed]: {
                    title: 'Putaran Berakhir Pada',
                },
            },
            TokenTellerHistoryItem: {
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Won]: 'Menang',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Lost]: 'Kalah',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.WaitingForResults]:
                    'Menunggu Hasil',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Refund]: 'Seri',
            },

            TokenTellerHistoryBlockHeader: {
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Won]: {
                    title: 'Anda telah menang!',
                    textOne:
                        'Selamat! Anda telah memperkirakan pergerakan harga dengan benar. ',
                    textTwo: ' akan segera disetorkan ke dompet Anda',
                },

                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Lost]: {
                    title: 'Anda telah Kalah :(',
                    text: 'Sayangnya, Anda tidak berhasil menang kali ini. Alasan bagus untuk membuktikan diri di babak berikutnya!',
                },
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Refund]: {
                    title: 'Wow, ini Seri!',
                    text: 'Walaupun kelihatannya tidak mungkin, ini adalah hasil seri. Taruhan Anda telah dikembalikan ke dompet Anda. Mau ronde berikutnya?',
                },
            },

            TokenTellerGameHistoryInfoItem: {
                iguBefore: 'Harga awal',
                iguAfter: 'Harga penutup',
                prediction: 'Posisi',
                totalPool: 'Jumlah Kolam',
                participants: 'Peserta',
                upPayout: 'Pengganda ATAS',
                downPayout: 'Pengganda BAWAH',
            },
        },
        DailyTasks: {
            header: 'Tugas Harian',
            collected: '{{collectedEnergy}} / {{maxEnergy}} Dikumpulkan',
            SocialTask: {
                title: 'Tugas Sosial',
                text: 'Membuat postingan di media sosial',
            },
            VerificationTask: {
                title: 'Tugas pencarian',
                text: 'Memeriksa pesan pengguna lain',
            },
            MoveTask: {
                title: 'Tugas yang dapat dipindahkan',
                text: 'Nikmati berjalan-jalan di luar bersama hewan peliharaan Anda',
            },
            PlayTask: {
                title: 'Misi permainan',
                text: 'Memainkan game arcade yang menarik',
            },
        },
        ReferralCard: {
            title: 'Diskon {{percent}}% untuk NFT!',
            text: 'Undang pengguna baru ke aplikasi IguVerse dan dapatkan diskon mint NFT',
            button: 'Undang',
        },
        TimerTopUp: {
            title: 'untuk Setiap Top-Up',
            text1: 'Setor token sekarang dan dapatkan {{coin}} {{percent}}% lebih banyak ke dompet Anda! Hanya tersedia sebelum:',
            text2: 'Mulai mainkan game kompetitif baru kami dan dapatkan token bonus di saldo Anda!',
        },
    },
    pvpBonus: {
        cardButton: 'PVP Bonus',
        title: 'Bonus PvP',
        text: 'Pemilik NFT berhak atas insentif untuk bermain PvP. Mulai sekarang dan dapatkan bonus Anda segera!',
        pvpBonusModal: {
            title: 'Cara Menghasilkan Lebih Banyak Di PvP',
            text: 'Pengembalian IguVerse dari PvP akan dibagikan kepada Anda secara proporsional dengan omset Anda! Dapatkan NFT dan Anda akan secara otomatis menerima bonus untuk bermain',
            features: {
                games: {
                    title: 'Penghitung Permainan = {{games}}',
                    text: 'Game yang Anda mainkan hari ini. Jangan hentikan dirimu sekarang!',
                },
                bonus: {
                    title: 'Bonus PvP = {{amount}}',
                    text: 'Ini adalah token ekstra yang akan Anda terima untuk memainkan game PvP di penghujung hari. Bentrok dengan orang lain dan dapatkan lebih banyak lagi!',
                },
            },
        },
        pvpBonusModalFreePet: {
            title: 'Tingkatkan Peringkat Untuk Menerima Lebih Banyak Token Di PvP',
            text: 'Hewan peliharaan Anda dari Peringkat Gratis perlu ditingkatkan ke Peringkat yang lebih tinggi agar Anda memenuhi syarat untuk mendapatkan bonus dari PvP',
        },
    },
    MarketPlace: {
        navigationBar: {
            ORDERS: 'Pesanan Aktif',
            MY_PROFILE: 'Profil saya',
        },
        MarketPlaceActiveOrdersScreen: {
            title: 'Pasar',
            text: 'Tempat untuk berdagang NFT',
            empty: {
                title: 'Tidak Ada NFT Untuk Dijual',
                text: 'Belum ada pesanan penjualan yang dibuat. Jadilah yang pertama untuk membuatnya!',
            },
            notFound: {
                title: 'Tidak ada hasil yang ditemukan',
                text: 'Kami belum menemukan perintah seperti itu. Masukkan kata kunci lain untuk dicari',
            },
        },
        MarketPlaceSearch: {
            modalTitle: 'Penyaring',
            placeHolder: 'Mencari nft, koleksi, pengguna...',
            typeSection: {
                [MARKETPLACE_PET_TYPE.AISystem]: 'Sistem AI',
                [MARKETPLACE_PET_TYPE.FromPhoto]: 'Dari Foto',
                [MARKETPLACE_PET_TYPE.Alive]: 'Hidup',
                [MARKETPLACE_PET_TYPE.Dead]: 'Mati',
            },

            sortBySection: {
                [MARKETPLACE_ORDERS_SORT_OPTION.FromHighestPrice]:
                    'Dari Harga Tertinggi',
                [MARKETPLACE_ORDERS_SORT_OPTION.FromLowestPrice]:
                    'Dari Harga Terendah',
                [MARKETPLACE_ORDERS_SORT_OPTION.RecentlyListed]:
                    'Baru Saja Terdaftar',
                [MARKETPLACE_ORDERS_SORT_OPTION.EndingSoon]: 'Segera berakhir',
            },
        },
        MarketPlaceWelcomeCreateOrderScreen: {
            screenTitle: 'Buat Pesanan Baru',
            title: 'Perkenalkan NFT Anda ke Dunia Besar',
            text: 'Di sini Anda dapat mendaftarkan NFT Anda dan menjualnya',
            features: {
                rank: {
                    title: 'Peringkat Minimal – {{rank}}',
                    text: 'NFT Anda harus memiliki Peringkat lebih tinggi dari Peringkat {{lowRank}}. Hanya NFT yang dibeli di aplikasi yang dapat diperdagangkan di pasar',
                },
                termination: {
                    title: 'Penghentian Otomatis = {{days}} Hari',
                    text: 'Waktu di mana pesanan akan kedaluwarsa jika tidak dibeli sebelumnya',
                    alert: 'Jika tidak ada yang membeli NFT dalam {{days}} hari, pesanan akan secara otomatis dihapus dari Marketplace. Selama terdaftar, Anda dapat terus bermain dan menghasilkan',
                },
                commission: {
                    title: 'Biaya Komisi = {{commission}}%',
                    text: 'Setiap NFT yang berhasil terjual dikenakan biaya komisi sebesar {{commission}}%',
                },
            },
        },
        MarketPlaceModalNoPet: {
            title: 'Mencetak NFT Untuk Dijual',
            text: 'Untuk menjual NFT, Anda harus memiliki setidaknya satu hewan peliharaan. Buat satu sekarang!',
        },
        MarketPlaceSelectNftScreen: {
            screenTitle: 'Pilih NFT',
        },
        MarketPlaceSelectNftPriceScreen: {
            screenTitle: 'Masukkan Harga NFT',
        },
        MarketPlaceCreateOrderSuccessScreen: {
            title: 'NFT Terdaftar di Pasar',
            text: 'Anda telah berhasil mendaftarkan NFT Anda. Sekarang pengguna lain akan dapat membelinya',
        },
        navigationBarOverview: {
            OVERVIEW: 'Ringkasan',
            OWNER_HISTORY: 'Sejarah Pemilik',
        },
        MarketPlaceOverview: {
            text: 'Ini adalah NFT dari pengguna lain. Anda dapat melihat ciri-cirinya di bawah ini:',
            textOwner:
                'Ini adalah NFT Anda. Anda dapat melihat ciri-cirinya di bawah ini:',
            OverviewOwnerSection: {
                profileLabel: 'Profil Pemilik',
            },
            proceedToCheckoutModal: {
                title: 'Lanjutkan ke pembayaran?',
                text: 'Setelah membeli NFT, itu akan berada dalam mode cooldown selama 24 jam. Pastikan Anda telah memeriksa semua propertinya sebelum membeli',
            },
        },
        DelistNftModal: {
            title: 'Hapus NFT?',
            text: 'Jika dihapus dari daftar, NFT akan keluar dari pasar dan tidak lagi tersedia untuk dibeli',
        },
        MarketplaceProfile: {
            joined: 'Bergabung {{date}}',
            myNFTs: 'NFT saya',
            exploreNFTs: 'Jelajahi NFT',
            emptyUser: {
                title: 'Tidak Ada Pesanan',
                text: 'Belum ada pesanan pasar yang dibuat',
            },
            empty: {
                title: 'Tidak Ada Pesanan',
                text: 'Pengguna ini belum membuat pesanan apa pun',
            },
        },
        MarketPlaceDelistSuccessScreen: {
            title: 'NFT "{{name}}" telah berhasil dihapus dari pasar',
        },
        MarketPlaceBuySuccessScreen: {
            title: 'NFT Baru Bergabung dengan Keluarga',
            text: 'Anda telah berhasil membeli NFT baru! Sekarang koleksi Anda mendapat anggota baru dan jauh lebih kuat sekarang',
        },
        MarketPlaceOverviewOwnerHistoryScreen: {
            empty: {
                title: 'Tidak Ada Riwayat NFT',
                text: 'NFT belum diperdagangkan. Anda bisa menjadi yang pertama membelinya!',
            },
        },
        MarketPlaceNoTradeAvalibleScreen: {
            title: 'Marketplace Telah Keluar!',
            description:
                'Kami baru saja merilis pasar internal kami, tempat Anda dapat memperdagangkan NFT IguVerse Anda. Buka melalui Aplikasi Web dan buat pesanan pertama Anda sekarang!',
            button: 'Jelajahi di Aplikasi Web',
        },
    },
    SpaceId: {
        card: {
            title: 'Dapatkan ID SPASI',
            text: 'Pamerkan nama panggilan khusus Anda di mana saja di aplikasi dan seterusnya',
        },
        how: {
            screenTitle: 'Cara Menggunakan SPACE ID',
            title: 'Daftarkan Identitas Digital',
            text: 'Bosan dengan alamat rumit yang tidak dapat dibaca? Ubah milik Anda dengan identitas yang dapat dibaca manusia (nama domain) dengan SPACE ID!',
            guideBlock: {
                first: 'Impor dompet IguVerse Anda ke Dompet DeFi non-penahanan apa pun (mis. Trustwallet, Metamask) melalui seed-phrase Anda',
                second: 'Tambahkan jaringan BEP-20 dan hubungkan dompet Anda ke situs web',
                third: 'Cari nama domain yang diinginkan di situs web',
                fourth: 'Beli nama domain yang diinginkan dan perbarui aplikasi IguVer. Anda akan dapat melihat nama panggilan khusus Anda di dompet, di papan peringkat, dan di tempat lain yang menggunakannya',
                alert: 'Untuk membeli domain, Anda harus memiliki beberapa BNB di dompet Anda',
            },
            button1: 'Jelajahi domain SPACE ID',
        },
        modal: {
            title: 'SPACE ID yang unik!',
            text: 'Anda telah berhasil membeli dan mendaftarkan domain khusus! Mulai sekarang, nama unik Anda akan ditampilkan di mana saja di aplikasi. Alamat asli Anda akan tetap sama dan Anda dapat menyalinnya dengan mengeklik "Salin" di dompet Anda',
            link: 'Pelajari Lebih Lanjut di SPACE ID',
        },
    },
    Achievements: {
        title: 'Prestasi',
        text: 'Tugas mendebarkan yang melacak kemajuan unik Anda dan memungkinkan Anda memamerkan keahlian dan pengalaman bermain game Anda',
        unlocked: '{{achievement}} Tidak terkunci!',
        unlockedText:
            'Selamat! Anda telah berhasil membuka pencapaian. Bagikan dengan teman Anda di media sosial!',
        button: 'Bagikan Prestasi',
        modal: {
            title: 'Tampil menonjol dengan prestasi',
            text: 'Selesaikan tugas untuk mendapatkan prestasi. Jauh lebih menghibur untuk bermain dengan sedikit tantangan dan peti penuh medali',
        },
    },
};

export default id;
